import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export enum ActivityStatus {
  Completed = 'COMPLETED',
  Ongoing = 'ONGOING',
  Planned = 'PLANNED'
}

export type ApplicationUser = {
  __typename?: 'ApplicationUser';
  authorities: Array<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  grantedAuthorities: Array<Scalars['String']>;
  groupMemberships: Array<UserGroup>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  username: Scalars['String'];
};

export type Article9SupportNeeded = SupportNeeded & {
  __typename?: 'Article9SupportNeeded';
  activityAnchored?: Maybe<Scalars['String']>;
  activityContribution?: Maybe<Scalars['String']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  estimatedAmountRsd: Scalars['Float'];
  estimatedAmountUsd: Scalars['Float'];
  expectedFinancialInstrument?: Maybe<FinancialInstrument>;
  expectedTimeframeEnd: Scalars['Int'];
  expectedTimeframeStart: Scalars['Int'];
  expectedUseImpactAndEstimatedResults?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  project: CfProject;
  sector?: Maybe<Scalars['String']>;
  supportReceived: Array<Article9SupportReceived>;
  supportType?: Maybe<SupportType>;
};

export type Article9SupportReceived = SupportReceived & {
  __typename?: 'Article9SupportReceived';
  activityContribution?: Maybe<Scalars['String']>;
  amountRsd: Scalars['Float'];
  amountUsd: Scalars['Float'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  financialInstrument?: Maybe<FinancialInstrument>;
  id: Scalars['ID'];
  implementingEntity?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  recipientEntity?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  supportNeeded: Article9SupportNeeded;
  supportType?: Maybe<SupportType>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type Article10SupportNeeded = SupportNeeded & {
  __typename?: 'Article10SupportNeeded';
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  expectedTimeframeEnd: Scalars['Int'];
  expectedTimeframeStart: Scalars['Int'];
  expectedUseImpactAndEstimatedResults?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  project: CfProject;
  sector?: Maybe<Scalars['String']>;
  supportReceived: Array<Article10SupportReceived>;
  supportType?: Maybe<SupportType>;
  typeOfTechnology?: Maybe<Scalars['String']>;
};

export type Article10SupportReceived = SupportReceived & {
  __typename?: 'Article10SupportReceived';
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  implementingEntity?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  recipientEntity?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  supportNeeded: Article10SupportNeeded;
  supportType?: Maybe<SupportType>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  typeOfTechnology?: Maybe<Scalars['String']>;
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type Article11SupportNeeded = SupportNeeded & {
  __typename?: 'Article11SupportNeeded';
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  expectedTimeframeEnd: Scalars['Int'];
  expectedTimeframeStart: Scalars['Int'];
  expectedUseImpactAndEstimatedResults?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  project: CfProject;
  supportReceived: Array<Article11SupportReceived>;
  supportType?: Maybe<SupportType>;
};

export type Article11SupportReceived = SupportReceived & {
  __typename?: 'Article11SupportReceived';
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  implementingEntity?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  recipientEntity?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  supportNeeded: Article11SupportNeeded;
  supportType?: Maybe<SupportType>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type Article13SupportNeededReceived = {
  __typename?: 'Article13SupportNeededReceived';
  amountRsd: Scalars['Float'];
  amountUsd: Scalars['Float'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  project: CfProject;
  recipientEntity?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type BaseArticle9SupportNeeded = {
  activityAnchored?: Maybe<Scalars['String']>;
  activityContribution?: Maybe<Scalars['String']>;
  estimatedAmountRsd: Scalars['Float'];
  estimatedAmountUsd: Scalars['Float'];
  expectedFinancialInstrument?: Maybe<FinancialInstrument>;
  sector?: Maybe<Scalars['String']>;
};

export type BaseArticle9SupportReceived = {
  activityContribution?: Maybe<Scalars['String']>;
  amountRsd: Scalars['Float'];
  amountUsd: Scalars['Float'];
  channel?: Maybe<Scalars['String']>;
  financialInstrument?: Maybe<FinancialInstrument>;
  sector?: Maybe<Scalars['String']>;
};

export type BaseArticle10SupportNeeded = {
  sector?: Maybe<Scalars['String']>;
  typeOfTechnology?: Maybe<Scalars['String']>;
};

export type BaseArticle10SupportReceived = {
  sector?: Maybe<Scalars['String']>;
  typeOfTechnology?: Maybe<Scalars['String']>;
};

export type BaseArticle11Support = {
  placeholder?: Maybe<Scalars['Boolean']>;
};

export type BaseSupportNeeded = {
  expectedTimeframeEnd: Scalars['Int'];
  expectedTimeframeStart: Scalars['Int'];
  expectedUseImpactAndEstimatedResults?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  supportType?: Maybe<SupportType>;
};

export type BaseSupportReceived = {
  description?: Maybe<Scalars['String']>;
  implementingEntity?: Maybe<Scalars['String']>;
  recipientEntity?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  supportType?: Maybe<SupportType>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type BasicSupportStatistic = SupportStatistic & {
  __typename?: 'BasicSupportStatistic';
  amount: Scalars['Int'];
  year: Scalars['Int'];
};

export type CfProject = {
  __typename?: 'CfProject';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ChangePassword = {
  oldPassword: Scalars['String'];
  password: Scalars['String'];
  passwordRepeat: Scalars['String'];
};

export type ChangePasswordToken = {
  password: Scalars['String'];
  passwordRepeat: Scalars['String'];
};

export enum ClimateChangeImpactState {
  AlreadyRegistered = 'ALREADY_REGISTERED',
  Projected = 'PROJECTED'
}

export type CommonSupportFilter = {
  approved?: Maybe<Scalars['Boolean']>;
  financialInstrument?: Maybe<FinancialInstrument>;
  id?: Maybe<Scalars['ID']>;
  project?: Maybe<Scalars['String']>;
  supportType?: Maybe<SupportType>;
  timeframeEnd?: Maybe<Scalars['Int']>;
  timeframeStart?: Maybe<Scalars['Int']>;
};

export type CreateArticle9SupportNeeded = {
  base: BaseArticle9SupportNeeded;
  common: BaseSupportNeeded;
};

export type CreateArticle9SupportReceived = {
  base: BaseArticle9SupportReceived;
  common: BaseSupportReceived;
  supportNeeded: Scalars['ID'];
};

export type CreateArticle10SupportNeeded = {
  base: BaseArticle10SupportNeeded;
  common: BaseSupportNeeded;
};

export type CreateArticle10SupportReceived = {
  base: BaseArticle10SupportReceived;
  common: BaseSupportReceived;
  supportNeeded: Scalars['ID'];
};

export type CreateArticle11SupportNeeded = {
  base: BaseArticle11Support;
  common: BaseSupportNeeded;
};

export type CreateArticle11SupportReceived = {
  base: BaseArticle11Support;
  common: BaseSupportReceived;
  supportNeeded: Scalars['ID'];
};

export type CreateArticle13SupportNeededReceived = {
  amountRsd: Scalars['Float'];
  amountUsd: Scalars['Float'];
  channel?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  recipientEntity?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type CreateDataCollectionDocument = {
  description?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  name: Scalars['String'];
  storagePath: Scalars['String'];
  template: Scalars['ID'];
  year: Scalars['Int'];
};

export type CreateDataCollectionTemplate = {
  description: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationReceivers: Array<Scalars['ID']>;
  reportingOrganization: Scalars['ID'];
  storagePath?: Maybe<Scalars['String']>;
};

export type CreateExternalSource = {
  descriptionTranslations: Array<UpdateTranslationText>;
  nameTranslations: Array<UpdateTranslationText>;
  scope: ExternalSourceScope;
  sourceUrl: Scalars['String'];
};

export type CreateIndicator = {
  category: IndicatorCategory;
  datasets: Array<CreateIndicatorDataset>;
  name: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
};

export type CreateIndicatorDataset = {
  additionalRemarks?: Maybe<Scalars['String']>;
  guidanceDefinitions?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numeratorDenominator?: Maybe<Scalars['String']>;
};

export type CreateInfoDocument = {
  descriptionTranslations: Array<UpdateTranslationText>;
  fileName: Scalars['String'];
  nameTranslations: Array<UpdateTranslationText>;
  scope: InfoDocumentScope;
  storagePath: Scalars['String'];
};

export type CreateMeasure = {
  achievedResults?: Maybe<Scalars['String']>;
  climateChangeImpacts?: Maybe<Array<ClimateChangeImpactState>>;
  description: Scalars['String'];
  expectedImprovements?: Maybe<Scalars['String']>;
  expectedSourceOfFunding?: Maybe<Scalars['String']>;
  extensionOfMeasure?: Maybe<Scalars['String']>;
  extremeEvents?: Maybe<Scalars['String']>;
  impactOnGhgEmissions?: Maybe<Scalars['String']>;
  implementationPhases?: Maybe<Scalars['String']>;
  indicators?: Maybe<Scalars['String']>;
  legalAndPolicyBasis?: Maybe<Scalars['String']>;
  lifetimeEnd: Scalars['String'];
  lifetimeStart: Scalars['String'];
  linkToOtherMeasures?: Maybe<Scalars['String']>;
  linkz?: Maybe<Scalars['String']>;
  lossesAndDamages?: Maybe<Scalars['String']>;
  measureType: MeasureType;
  name: Scalars['String'];
  objective: Scalars['String'];
  otherBenefits?: Maybe<Scalars['String']>;
  problemsAndBarriers?: Maybe<Scalars['String']>;
  publicConsultationProcess?: Maybe<Scalars['String']>;
  reportingInMrv: Scalars['String'];
  responsibilityFor?: Maybe<Responsibility>;
  territorialCoverage: TerritorialCoverage;
  totalExpectedInvestmentRsd?: Maybe<Scalars['Float']>;
  totalExpectedInvestmentUsd?: Maybe<Scalars['Float']>;
};

export type CreateMeasurePeriodData = {
  investmentRsd?: Maybe<Scalars['Float']>;
  investmentUsd?: Maybe<Scalars['Float']>;
  measure: Scalars['ID'];
  realized: Scalars['Boolean'];
  reportingPeriod: Scalars['ID'];
  sourceOfFunding?: Maybe<SourceOfFunding>;
  status: MeasureStatus;
};

export type CreateReportingPeriod = {
  endYear: Scalars['Int'];
  name: Scalars['String'];
  startYear: Scalars['Int'];
};

export type CreateSharedDocument = {
  description: Scalars['String'];
  fileName: Scalars['String'];
  name: Scalars['String'];
  scope: SharedDocumentScope;
  storagePath: Scalars['String'];
  year: Scalars['Int'];
};

export type CreateUser = {
  displayName: Scalars['String'];
  email: Scalars['String'];
  groupMemberships: Array<Scalars['ID']>;
  organization: Scalars['ID'];
  username: Scalars['String'];
};

export type CrfDocument = {
  __typename?: 'CrfDocument';
  active: Scalars['Boolean'];
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
};

export type DataCollectionDocument = {
  __typename?: 'DataCollectionDocument';
  accessOrganizations: Array<Organization>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization: Organization;
  template: DataCollectionTemplate;
  year: Scalars['Int'];
};

export type DataCollectionTemplate = {
  __typename?: 'DataCollectionTemplate';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description: Scalars['String'];
  documents: Array<DataCollectionDocument>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationReceivers: Array<ApplicationUser>;
  reportingOrganization: Organization;
};


export type DataCollectionTemplateDocumentsArgs = {
  year?: Maybe<Scalars['Int']>;
};

export type DataCollectionYear = {
  __typename?: 'DataCollectionYear';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  year: Scalars['Int'];
  yearLocked: Scalars['Boolean'];
};

export type ExternalApplication = {
  __typename?: 'ExternalApplication';
  applicationUrl: Scalars['String'];
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  deletedBy?: Maybe<Scalars['String']>;
  deletedDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  nameTranslations: Array<TranslatedText>;
  preferredNameTranslation?: Maybe<TranslatedText>;
};


export type ExternalApplicationPreferredNameTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type ExternalSource = {
  __typename?: 'ExternalSource';
  active: Scalars['Boolean'];
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  deletedBy?: Maybe<Scalars['String']>;
  deletedDate?: Maybe<Scalars['String']>;
  descriptionTranslations: Array<TranslatedText>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  nameTranslations: Array<TranslatedText>;
  preferredDescriptionTranslation?: Maybe<TranslatedText>;
  preferredNameTranslation?: Maybe<TranslatedText>;
  primarySource: Scalars['Boolean'];
  scope: ExternalSourceScope;
  sourceUrl: Scalars['String'];
};


export type ExternalSourcePreferredDescriptionTranslationArgs = {
  preferredLanguage: Scalars['String'];
};


export type ExternalSourcePreferredNameTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export enum ExternalSourceScope {
  Cca = 'CCA',
  Cf = 'CF',
  Ghg = 'GHG',
  Indi = 'INDI',
  Nc = 'NC',
  Ndc = 'NDC',
  Pam = 'PAM',
  Pas = 'PAS'
}

export enum FinancialInstrument {
  ConcessionalLoan = 'CONCESSIONAL_LOAN',
  Equity = 'EQUITY',
  Grant = 'GRANT',
  Guarantee = 'GUARANTEE',
  NonConcessionalLoan = 'NON_CONCESSIONAL_LOAN',
  Other = 'OTHER'
}

export type GhgCategory = {
  __typename?: 'GhgCategory';
  code: Scalars['String'];
  id: Scalars['ID'];
  orderIndex: Scalars['Int'];
  preferredTranslation?: Maybe<TranslatedText>;
  translations: Array<TranslatedText>;
};


export type GhgCategoryPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type GhgSector = {
  __typename?: 'GhgSector';
  code: Scalars['String'];
  id: Scalars['ID'];
  orderIndex: Scalars['Int'];
  parentSector?: Maybe<GhgSector>;
  preferredTranslation?: Maybe<TranslatedText>;
  specialSector: Scalars['Boolean'];
  translations: Array<TranslatedText>;
  usableInProjections: Scalars['Boolean'];
  values: Array<GhgValue>;
};


export type GhgSectorPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};


export type GhgSectorValuesArgs = {
  filter?: Maybe<GhgValueFilter>;
};

export type GhgValue = {
  __typename?: 'GhgValue';
  category: GhgCategory;
  id: Scalars['ID'];
  sector: GhgSector;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type GhgValueFilter = {
  categories?: Maybe<Array<Scalars['ID']>>;
  categoryCodes?: Maybe<Array<Scalars['String']>>;
  sectors?: Maybe<Array<Scalars['ID']>>;
  yearFrom?: Maybe<Scalars['Int']>;
  yearTo?: Maybe<Scalars['Int']>;
};

export type GhgValueRange = {
  __typename?: 'GhgValueRange';
  maxYear?: Maybe<Scalars['Int']>;
  minYear?: Maybe<Scalars['Int']>;
};

export type Indicator = {
  __typename?: 'Indicator';
  category: IndicatorCategory;
  code?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  datasets: Array<IndicatorDataset>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
};

export enum IndicatorCategory {
  Cca = 'CCA',
  GhgAdditionalPriority = 'GHG_ADDITIONAL_PRIORITY',
  GhgPriority_1 = 'GHG_PRIORITY_1',
  GhgSupplementary = 'GHG_SUPPLEMENTARY',
  Other = 'OTHER',
  Pas = 'PAS'
}

export type IndicatorDataset = {
  __typename?: 'IndicatorDataset';
  additionalRemarks?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  crfSourceCategory?: Maybe<GhgCategory>;
  crfSourceSector?: Maybe<GhgSector>;
  guidanceDefinitions?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indicator: Indicator;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numeratorDenominator?: Maybe<Scalars['String']>;
  values: Array<IndicatorDatasetValue>;
};


export type IndicatorDatasetValuesArgs = {
  filter?: Maybe<IndicatorDatasetValuesFilterDto>;
};

export type IndicatorDatasetValue = {
  __typename?: 'IndicatorDatasetValue';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  dataset: IndicatorDataset;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type IndicatorDatasetValuesFilterDto = {
  yearFrom?: Maybe<Scalars['Int']>;
  yearTo?: Maybe<Scalars['Int']>;
};

export type IndicatorsFilterDto = {
  category?: Maybe<IndicatorCategory>;
};

export type InfoDocument = {
  __typename?: 'InfoDocument';
  active: Scalars['Boolean'];
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  deletedBy?: Maybe<Scalars['String']>;
  deletedDate?: Maybe<Scalars['String']>;
  descriptionTranslations: Array<TranslatedText>;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  nameTranslations: Array<TranslatedText>;
  preferredDescriptionTranslation?: Maybe<TranslatedText>;
  preferredNameTranslation?: Maybe<TranslatedText>;
  primaryDocument: Scalars['Boolean'];
  scope: InfoDocumentScope;
};


export type InfoDocumentPreferredDescriptionTranslationArgs = {
  preferredLanguage: Scalars['String'];
};


export type InfoDocumentPreferredNameTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export enum InfoDocumentScope {
  Cca = 'CCA',
  Cf = 'CF',
  Ghg = 'GHG',
  Indi = 'INDI',
  Nc = 'NC',
  Ndc = 'NDC',
  Pam = 'PAM',
  Pas = 'PAS'
}

export type Language = {
  __typename?: 'Language';
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type Measure = {
  __typename?: 'Measure';
  achievedResults?: Maybe<Scalars['String']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  climateChangeImpacts?: Maybe<Array<ClimateChangeImpactState>>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description: Scalars['String'];
  expectedImprovements?: Maybe<Scalars['String']>;
  expectedSourceOfFunding?: Maybe<Scalars['String']>;
  extensionOfMeasure?: Maybe<Scalars['String']>;
  extremeEvents?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  impactOnGhgEmissions?: Maybe<Scalars['String']>;
  implementationPhases?: Maybe<Scalars['String']>;
  indicators?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  legalAndPolicyBasis?: Maybe<Scalars['String']>;
  lifetimeEnd: Scalars['String'];
  lifetimeStart: Scalars['String'];
  linkToOtherMeasures?: Maybe<Scalars['String']>;
  linkz?: Maybe<Scalars['String']>;
  lossesAndDamages?: Maybe<Scalars['String']>;
  measureType: MeasureType;
  name: Scalars['String'];
  ncRelevant?: Maybe<Scalars['Boolean']>;
  ndcRelevant?: Maybe<Scalars['Boolean']>;
  objective: Scalars['String'];
  otherBenefits?: Maybe<Scalars['String']>;
  periodData?: Maybe<Array<MeasurePeriodData>>;
  problemsAndBarriers?: Maybe<Scalars['String']>;
  publicConsultationProcess?: Maybe<Scalars['String']>;
  reportingInMrv: Scalars['String'];
  reportingPeriods: Array<ReportingPeriod>;
  responsibilityFor?: Maybe<Responsibility>;
  territorialCoverage: TerritorialCoverage;
  totalExpectedInvestmentRsd?: Maybe<Scalars['Float']>;
  totalExpectedInvestmentUsd?: Maybe<Scalars['Float']>;
};

export type MeasurePeriodData = {
  __typename?: 'MeasurePeriodData';
  id: Scalars['ID'];
  investmentRsd?: Maybe<Scalars['Float']>;
  investmentUsd?: Maybe<Scalars['Float']>;
  measure: Measure;
  realized: Scalars['Boolean'];
  reportingPeriod: ReportingPeriod;
  sourceOfFunding?: Maybe<SourceOfFunding>;
  status: MeasureStatus;
};

export type MeasureStatistics = {
  __typename?: 'MeasureStatistics';
  amountPerTerritorialCoverage: Array<MeasureStatisticsPerTerritorialCoverage>;
  totalAmount: Scalars['Int'];
};

export type MeasureStatisticsPerTerritorialCoverage = {
  __typename?: 'MeasureStatisticsPerTerritorialCoverage';
  amount: Scalars['Int'];
  territorialCoverage: TerritorialCoverage;
};

export enum MeasureStatus {
  Adopted = 'ADOPTED',
  Completed = 'COMPLETED',
  Implemented = 'IMPLEMENTED',
  Planned = 'PLANNED'
}

export enum MeasureType {
  CapacityBuildingOrTraining = 'CAPACITY_BUILDING_OR_TRAINING',
  Financial = 'FINANCIAL',
  OrganizationalOrInstitutional = 'ORGANIZATIONAL_OR_INSTITUTIONAL',
  Policies = 'POLICIES',
  Prevention = 'PREVENTION',
  Recovery = 'RECOVERY',
  TechnologicalOrInfrastructural = 'TECHNOLOGICAL_OR_INFRASTRUCTURAL'
}

export type MeasuresQueryFilter = {
  approved?: Maybe<Scalars['Boolean']>;
  ncRelevant?: Maybe<Scalars['Boolean']>;
  ndcRelevant?: Maybe<Scalars['Boolean']>;
  reportingPeriod?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
};

export enum ModuleScope {
  Cca = 'CCA',
  CcaAdaptations = 'CCA_ADAPTATIONS',
  CcaExternalSources = 'CCA_EXTERNAL_SOURCES',
  CcaRelatedDocuments = 'CCA_RELATED_DOCUMENTS',
  Cf = 'CF',
  CfArticle_9 = 'CF_ARTICLE_9',
  CfArticle_10 = 'CF_ARTICLE_10',
  CfArticle_11 = 'CF_ARTICLE_11',
  CfArticle_13 = 'CF_ARTICLE_13',
  CfExternalSources = 'CF_EXTERNAL_SOURCES',
  CfRelatedDocuments = 'CF_RELATED_DOCUMENTS',
  Ghg = 'GHG',
  GhgEmissionsPerGas = 'GHG_EMISSIONS_PER_GAS',
  GhgEmissionsPerSector = 'GHG_EMISSIONS_PER_SECTOR',
  GhgExternalSources = 'GHG_EXTERNAL_SOURCES',
  GhgRelatedDocuments = 'GHG_RELATED_DOCUMENTS',
  GhgSectorEmissionComparison = 'GHG_SECTOR_EMISSION_COMPARISON',
  Indicators = 'INDICATORS',
  IndicatorsCcaFigures = 'INDICATORS_CCA_FIGURES',
  IndicatorsExternalSources = 'INDICATORS_EXTERNAL_SOURCES',
  IndicatorsGhgFigures = 'INDICATORS_GHG_FIGURES',
  IndicatorsOtherFigures = 'INDICATORS_OTHER_FIGURES',
  IndicatorsPasFigures = 'INDICATORS_PAS_FIGURES',
  IndicatorsRelatedDocuments = 'INDICATORS_RELATED_DOCUMENTS',
  Ndc = 'NDC',
  NdcExternalSources = 'NDC_EXTERNAL_SOURCES',
  NdcGhgEmissionsBySector = 'NDC_GHG_EMISSIONS_BY_SECTOR',
  NdcNationalGhgEmissionsTrend = 'NDC_NATIONAL_GHG_EMISSIONS_TREND',
  NdcRelatedDocuments = 'NDC_RELATED_DOCUMENTS',
  Pam = 'PAM',
  PamExternalSources = 'PAM_EXTERNAL_SOURCES',
  PamList = 'PAM_LIST',
  PamRelatedDocuments = 'PAM_RELATED_DOCUMENTS',
  Pas = 'PAS',
  PasExternalSources = 'PAS_EXTERNAL_SOURCES',
  PasRelatedDocuments = 'PAS_RELATED_DOCUMENTS',
  PasScenarios = 'PAS_SCENARIOS'
}

export type ModuleVisibility = {
  __typename?: 'ModuleVisibility';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  orderIndex: Scalars['Int'];
  parentScope?: Maybe<ModuleScope>;
  publiclyVisible: Scalars['Boolean'];
  scope: ModuleScope;
};

export type MonetarySupportStatistic = SupportStatistic & {
  __typename?: 'MonetarySupportStatistic';
  amount: Scalars['Int'];
  valueRsd: Scalars['Float'];
  valueUsd: Scalars['Float'];
  year: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  approveArticle9SupportNeeded: Article9SupportNeeded;
  approveArticle9SupportReceived: Article9SupportReceived;
  approveArticle10SupportNeeded: Article10SupportNeeded;
  approveArticle10SupportReceived: Article10SupportReceived;
  approveArticle11SupportNeeded: Article11SupportNeeded;
  approveArticle11SupportReceived: Article11SupportReceived;
  approveArticle13SupportNeededReceived: Article13SupportNeededReceived;
  approveDataCollectionDocument: DataCollectionDocument;
  approveMeasure: Measure;
  approvePolicyAndMeasure: PolicyMeasure;
  changeInfoDocumentPrimary: InfoDocument;
  changeInfoDocumentVisibility: InfoDocument;
  changePassword: ApplicationUser;
  changePasswordByToken: ApplicationUser;
  changeSharedDocumentVisibility: SharedDocument;
  changeSourcePrimary: ExternalSource;
  changeSourceVisibility: ExternalSource;
  createArticle9SupportNeeded: Article9SupportNeeded;
  createArticle9SupportReceived: Article9SupportReceived;
  createArticle10SupportNeeded: Article10SupportNeeded;
  createArticle10SupportReceived: Article10SupportReceived;
  createArticle11SupportNeeded: Article11SupportNeeded;
  createArticle11SupportReceived: Article11SupportReceived;
  createArticle13SupportNeededReceived: Article13SupportNeededReceived;
  createDataCollectionDocument: DataCollectionDocument;
  createDataCollectionTemplate: DataCollectionTemplate;
  createExternalApplication: ExternalApplication;
  createExternalSource: ExternalSource;
  createIndicator: Indicator;
  createMeasure: Measure;
  createMeasurePeriodData: MeasurePeriodData;
  createOrganization: Organization;
  createPolicyAndMeasure: PolicyMeasure;
  createReportingPeriod: ReportingPeriod;
  createUser: ApplicationUser;
  deleteArticle9SupportNeeded: Article9SupportNeeded;
  deleteArticle9SupportReceived: Article9SupportReceived;
  deleteArticle10SupportNeeded: Article10SupportNeeded;
  deleteArticle10SupportReceived: Article10SupportReceived;
  deleteArticle11SupportNeeded: Article11SupportNeeded;
  deleteArticle11SupportReceived: Article11SupportReceived;
  deleteArticle13SupportNeededReceived: Article13SupportNeededReceived;
  deleteExternalApplication: ExternalApplication;
  deleteExternalSource: ExternalSource;
  deleteIndicator: Indicator;
  deleteInfoDocument: InfoDocument;
  deleteMeasure: Measure;
  deletePolicyAndMeasure: PolicyMeasure;
  deleteSharedDocument: Scalars['Boolean'];
  refuseArticle9SupportNeeded: Article9SupportNeeded;
  refuseArticle9SupportReceived: Article9SupportReceived;
  refuseArticle10SupportNeeded: Article10SupportNeeded;
  refuseArticle10SupportReceived: Article10SupportReceived;
  refuseArticle11SupportNeeded: Article11SupportNeeded;
  refuseArticle11SupportReceived: Article11SupportReceived;
  refuseArticle13SupportNeededReceived: Article13SupportNeededReceived;
  refuseDataCollectionDocument: DataCollectionDocument;
  refuseMeasure: Measure;
  refusePolicyAndMeasure: PolicyMeasure;
  resetPassword: Scalars['Boolean'];
  setDataCollectionYearLock: DataCollectionYear;
  updateArticle9SupportNeeded: Article9SupportNeeded;
  updateArticle9SupportReceived: Article9SupportReceived;
  updateArticle10SupportNeeded: Article10SupportNeeded;
  updateArticle10SupportReceived: Article10SupportReceived;
  updateArticle11SupportNeeded: Article11SupportNeeded;
  updateArticle11SupportReceived: Article11SupportReceived;
  updateArticle13SupportNeededReceived: Article13SupportNeededReceived;
  updateDataCollectionDocument: DataCollectionDocument;
  updateDataCollectionDocumentAccess: DataCollectionDocument;
  updateDataCollectionDocumentContent: DataCollectionDocument;
  updateDataCollectionTemplate: DataCollectionTemplate;
  updateExternalApplication: ExternalApplication;
  updateExternalSource: ExternalSource;
  updateIndicator: Indicator;
  updateIndicatorValues: Array<IndicatorDatasetValue>;
  updateInfoDocument: InfoDocument;
  updateMeasure: Measure;
  updateMeasureNcRelevancy: Measure;
  updateMeasureNdcRelevancy: Measure;
  updateMeasurePeriodData: MeasurePeriodData;
  updateModuleVisibility: Array<ModuleVisibility>;
  updateNdcTargets: Array<NdcTarget>;
  updateOrganization: Organization;
  updatePolicyAndMeasure: PolicyMeasure;
  updatePolicyAndMeasureNcRelevancy: PolicyMeasure;
  updatePolicyAndMeasureNdcRelevancy: PolicyMeasure;
  updateSharedDocument: SharedDocument;
  updateTranslation: TranslatedItem;
  updateUser: ApplicationUser;
  updateUserStatus: ApplicationUser;
  uploadCrfDocument: CrfDocument;
  uploadInfoDocument: InfoDocument;
  uploadProjectionDocument: ProjectionDocument;
  uploadSharedDocument: SharedDocument;
};


export type MutationApproveArticle9SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationApproveArticle9SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationApproveArticle10SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationApproveArticle10SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationApproveArticle11SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationApproveArticle11SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationApproveArticle13SupportNeededReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationApproveDataCollectionDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationApproveMeasureArgs = {
  id: Scalars['ID'];
};


export type MutationApprovePolicyAndMeasureArgs = {
  id: Scalars['ID'];
};


export type MutationChangeInfoDocumentPrimaryArgs = {
  documentId: Scalars['ID'];
  primary: Scalars['Boolean'];
};


export type MutationChangeInfoDocumentVisibilityArgs = {
  documentId: Scalars['ID'];
  visible: Scalars['Boolean'];
};


export type MutationChangePasswordArgs = {
  dto: ChangePassword;
  username: Scalars['String'];
};


export type MutationChangePasswordByTokenArgs = {
  dto: ChangePasswordToken;
  token: Scalars['ID'];
};


export type MutationChangeSharedDocumentVisibilityArgs = {
  documentId: Scalars['ID'];
  visible: Scalars['Boolean'];
};


export type MutationChangeSourcePrimaryArgs = {
  primary: Scalars['Boolean'];
  sourceId: Scalars['ID'];
};


export type MutationChangeSourceVisibilityArgs = {
  sourceId: Scalars['ID'];
  visible: Scalars['Boolean'];
};


export type MutationCreateArticle9SupportNeededArgs = {
  dto?: Maybe<CreateArticle9SupportNeeded>;
};


export type MutationCreateArticle9SupportReceivedArgs = {
  dto?: Maybe<CreateArticle9SupportReceived>;
};


export type MutationCreateArticle10SupportNeededArgs = {
  dto?: Maybe<CreateArticle10SupportNeeded>;
};


export type MutationCreateArticle10SupportReceivedArgs = {
  dto?: Maybe<CreateArticle10SupportReceived>;
};


export type MutationCreateArticle11SupportNeededArgs = {
  dto?: Maybe<CreateArticle11SupportNeeded>;
};


export type MutationCreateArticle11SupportReceivedArgs = {
  dto?: Maybe<CreateArticle11SupportReceived>;
};


export type MutationCreateArticle13SupportNeededReceivedArgs = {
  dto?: Maybe<CreateArticle13SupportNeededReceived>;
};


export type MutationCreateDataCollectionDocumentArgs = {
  dto: CreateDataCollectionDocument;
};


export type MutationCreateDataCollectionTemplateArgs = {
  dto: CreateDataCollectionTemplate;
};


export type MutationCreateExternalApplicationArgs = {
  dto: UpdateExternalApplication;
};


export type MutationCreateExternalSourceArgs = {
  dto: CreateExternalSource;
};


export type MutationCreateIndicatorArgs = {
  dto: CreateIndicator;
};


export type MutationCreateMeasureArgs = {
  dto: CreateMeasure;
};


export type MutationCreateMeasurePeriodDataArgs = {
  dto: CreateMeasurePeriodData;
};


export type MutationCreateOrganizationArgs = {
  dto: UpdateOrganization;
};


export type MutationCreatePolicyAndMeasureArgs = {
  dto: UpdatePolicyMeasure;
};


export type MutationCreateReportingPeriodArgs = {
  dto: CreateReportingPeriod;
};


export type MutationCreateUserArgs = {
  dto: CreateUser;
};


export type MutationDeleteArticle9SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteArticle9SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteArticle10SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteArticle10SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteArticle11SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteArticle11SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteArticle13SupportNeededReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteExternalApplicationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteExternalSourceArgs = {
  sourceId: Scalars['ID'];
};


export type MutationDeleteIndicatorArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInfoDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteMeasureArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePolicyAndMeasureArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSharedDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationRefuseArticle9SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseArticle9SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseArticle10SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseArticle10SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseArticle11SupportNeededArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseArticle11SupportReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseArticle13SupportNeededReceivedArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseDataCollectionDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRefuseMeasureArgs = {
  id: Scalars['ID'];
};


export type MutationRefusePolicyAndMeasureArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  username: Scalars['String'];
};


export type MutationSetDataCollectionYearLockArgs = {
  locked: Scalars['Boolean'];
  year: Scalars['Int'];
};


export type MutationUpdateArticle9SupportNeededArgs = {
  dto?: Maybe<UpdateArticle9SupportNeeded>;
};


export type MutationUpdateArticle9SupportReceivedArgs = {
  dto?: Maybe<UpdateArticle9SupportReceived>;
};


export type MutationUpdateArticle10SupportNeededArgs = {
  dto?: Maybe<UpdateArticle10SupportNeeded>;
};


export type MutationUpdateArticle10SupportReceivedArgs = {
  dto?: Maybe<UpdateArticle10SupportReceived>;
};


export type MutationUpdateArticle11SupportNeededArgs = {
  dto?: Maybe<UpdateArticle11SupportNeeded>;
};


export type MutationUpdateArticle11SupportReceivedArgs = {
  dto?: Maybe<UpdateArticle11SupportReceived>;
};


export type MutationUpdateArticle13SupportNeededReceivedArgs = {
  dto?: Maybe<UpdateArticle13SupportNeededReceived>;
};


export type MutationUpdateDataCollectionDocumentArgs = {
  documentId: Scalars['ID'];
  dto: UpdateDataCollectionDocument;
};


export type MutationUpdateDataCollectionDocumentAccessArgs = {
  id: Scalars['ID'];
  organizations: Array<Scalars['ID']>;
};


export type MutationUpdateDataCollectionDocumentContentArgs = {
  documentId: Scalars['ID'];
  dto: UpdateDataCollectionDocumentContent;
};


export type MutationUpdateDataCollectionTemplateArgs = {
  documentId: Scalars['ID'];
  dto: UpdateDataCollectionTemplate;
};


export type MutationUpdateExternalApplicationArgs = {
  dto: UpdateExternalApplication;
  id: Scalars['ID'];
};


export type MutationUpdateExternalSourceArgs = {
  dto: UpdateExternalSource;
  sourceId: Scalars['ID'];
};


export type MutationUpdateIndicatorArgs = {
  dto: UpdateIndicator;
  id: Scalars['ID'];
};


export type MutationUpdateIndicatorValuesArgs = {
  values: Array<UpdateIndicatorDatasetValue>;
};


export type MutationUpdateInfoDocumentArgs = {
  documentId: Scalars['ID'];
  dto: UpdateInfoDocument;
};


export type MutationUpdateMeasureArgs = {
  dto: UpdateMeasure;
};


export type MutationUpdateMeasureNcRelevancyArgs = {
  id: Scalars['ID'];
  ncRelevant: Scalars['Boolean'];
};


export type MutationUpdateMeasureNdcRelevancyArgs = {
  id: Scalars['ID'];
  ndcRelevant: Scalars['Boolean'];
};


export type MutationUpdateMeasurePeriodDataArgs = {
  dto: UpdateMeasurePeriodData;
};


export type MutationUpdateModuleVisibilityArgs = {
  dto: UpdateModuleVisibility;
};


export type MutationUpdateNdcTargetsArgs = {
  dtos: Array<UpdateNdcTarget>;
};


export type MutationUpdateOrganizationArgs = {
  dto: UpdateOrganization;
  id: Scalars['ID'];
};


export type MutationUpdatePolicyAndMeasureArgs = {
  dto: UpdatePolicyMeasure;
  id: Scalars['ID'];
};


export type MutationUpdatePolicyAndMeasureNcRelevancyArgs = {
  id: Scalars['ID'];
  ncRelevant: Scalars['Boolean'];
};


export type MutationUpdatePolicyAndMeasureNdcRelevancyArgs = {
  id: Scalars['ID'];
  ndcRelevant: Scalars['Boolean'];
};


export type MutationUpdateSharedDocumentArgs = {
  documentId: Scalars['ID'];
  dto: UpdateSharedDocument;
};


export type MutationUpdateTranslationArgs = {
  dto: UpdateTranslation;
};


export type MutationUpdateUserArgs = {
  dto: UpdateUser;
  id: Scalars['ID'];
};


export type MutationUpdateUserStatusArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationUploadCrfDocumentArgs = {
  dto: SimpleFileUpload;
};


export type MutationUploadInfoDocumentArgs = {
  dto: CreateInfoDocument;
};


export type MutationUploadProjectionDocumentArgs = {
  dto: SimpleFileUpload;
};


export type MutationUploadSharedDocumentArgs = {
  dto: CreateSharedDocument;
};

export type NdcTarget = {
  __typename?: 'NdcTarget';
  code: Scalars['String'];
  ghgSector?: Maybe<GhgSector>;
  id: Scalars['ID'];
  orderIndex: Scalars['Int'];
  preferredTranslation?: Maybe<TranslatedText>;
  targetValues: Array<NdcTargetValue>;
  translations: Array<TranslatedText>;
};


export type NdcTargetPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type NdcTargetFilter = {
  onlyRoot?: Maybe<Scalars['Boolean']>;
  sector?: Maybe<Scalars['ID']>;
  sectorCode?: Maybe<Scalars['String']>;
};

export type NdcTargetValue = {
  __typename?: 'NdcTargetValue';
  id: Scalars['ID'];
  ndcTarget: NdcTarget;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type Organization = {
  __typename?: 'Organization';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  mainOrganization: Scalars['Boolean'];
  orderIndex: Scalars['Int'];
  preferredTranslation?: Maybe<TranslatedText>;
  translations: Array<TranslatedText>;
};


export type OrganizationPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type PamObjective = {
  __typename?: 'PamObjective';
  code?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  orderIndex: Scalars['Int'];
  preferredTranslation?: Maybe<TranslatedText>;
  translations: Array<TranslatedText>;
};


export type PamObjectivePreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type PamUnionPolicy = {
  __typename?: 'PamUnionPolicy';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  orderIndex: Scalars['Int'];
  preferredTranslation?: Maybe<TranslatedText>;
  translations: Array<TranslatedText>;
};


export type PamUnionPolicyPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type PolicyMeasure = {
  __typename?: 'PolicyMeasure';
  additionalComment?: Maybe<Scalars['String']>;
  affectedGhgGases?: Maybe<Array<PolicyMeasureGhgGas>>;
  affectedSectors?: Maybe<Array<PolicyMeasureSectors>>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  article15ContributionAssessment?: Maybe<Scalars['String']>;
  assesmentsAndTechnicalReports?: Maybe<PolicyMeasureExternalReference>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  exAnteAssessment?: Maybe<PolicyMeasureExAnteAssessment>;
  exPostAssessment?: Maybe<PolicyMeasureExPostAssessment>;
  genderEqualityImpact?: Maybe<Scalars['String']>;
  generalComments?: Maybe<Scalars['String']>;
  geographicalCoverage?: Maybe<PolicyMeasureGeographicalCoverage>;
  id: Scalars['ID'];
  implementationPeriodEnd?: Maybe<Scalars['Int']>;
  implementationPeriodStart?: Maybe<Scalars['Int']>;
  implementationResponsibleEntityName?: Maybe<Scalars['String']>;
  implementationResponsibleEntityType?: Maybe<PolicyMeasureResponsibleEntityType>;
  implementationStatus?: Maybe<PolicyMeasureImplementationStatus>;
  implementationStatusDetails?: Maybe<Scalars['String']>;
  includingProjectionsScenario?: Maybe<PolicyMeasureProjectionScenario>;
  indicatorValues?: Maybe<Array<PolicyMeasureIndicator>>;
  indicatorsDescription?: Maybe<Scalars['String']>;
  informationAccess?: Maybe<PolicyMeasureInformationAccess>;
  informationSourceName?: Maybe<Scalars['String']>;
  interactionWithOtherPoliciesAndMeasuresDescription?: Maybe<Scalars['String']>;
  interactsWithOtherPoliciesAndMeasures?: Maybe<Scalars['Boolean']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  localName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ncRelevant?: Maybe<Scalars['Boolean']>;
  ndcRelevant?: Maybe<Scalars['Boolean']>;
  neededImprovements?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<PamObjective>>;
  pamNumber: Scalars['Int'];
  pamType?: Maybe<PolicyMeasureType>;
  policiesOrMeasureCoverage?: Maybe<Scalars['String']>;
  policyImpactType?: Maybe<Array<PolicyMeasureImpactType>>;
  policyInstrumentType?: Maybe<Array<PolicyMeasureInstrument>>;
  projectedCostsAndBenefits?: Maybe<PolicyMeasureCostsAndBenefits>;
  quantifiedObjective?: Maybe<Scalars['String']>;
  realizedCostsAndBenefits?: Maybe<PolicyMeasureCostsAndBenefits>;
  relatedSerbianPolicy?: Maybe<Scalars['String']>;
  relatedToUnionPolicy?: Maybe<Scalars['Boolean']>;
  relatedUnionPolicy?: Maybe<Array<PamUnionPolicy>>;
  responsibilityDetails?: Maybe<Scalars['String']>;
  sdgImpact?: Maybe<SustainableDevelopmentGoal>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type PolicyMeasureCostsAndBenefits = {
  __typename?: 'PolicyMeasureCostsAndBenefits';
  absoluteBenefitPerYearEur?: Maybe<Scalars['Float']>;
  absoluteGrossCostsPerYearEur?: Maybe<Scalars['Float']>;
  absoluteNetCostsPerYearEur?: Maybe<Scalars['Float']>;
  benefitsEurPerTonCO2eReduced?: Maybe<Scalars['Float']>;
  calculatedYears?: Maybe<Scalars['String']>;
  costEstimatesDescription?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  estimationSourceDocumentation?: Maybe<PolicyMeasureExternalReference>;
  grossCostsEurPerTonCO2eReduced?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  netCostsEurPerTonCO2eReduced?: Maybe<Scalars['Float']>;
  nonGhgMitigationBenefitsDescription?: Maybe<Scalars['String']>;
  priceYear?: Maybe<Scalars['Int']>;
};

export type PolicyMeasureExAnteAssessment = {
  __typename?: 'PolicyMeasureExAnteAssessment';
  affectedFactors?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  documentationOfEstimation?: Maybe<PolicyMeasureExternalReference>;
  ghgEmissionsReduction?: Maybe<Array<PolicyMeasureGhgEmissionsReduction>>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  mitigationEstimateBasisExplanation?: Maybe<Scalars['String']>;
};

export type PolicyMeasureExPostAssessment = {
  __typename?: 'PolicyMeasureExPostAssessment';
  affectedFactors?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  documentationOfEstimation?: Maybe<PolicyMeasureExternalReference>;
  ghgEmissionsReduction?: Maybe<PolicyMeasureGhgEmissionsReduction>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  mitigationEstimateBasisExplanation?: Maybe<Scalars['String']>;
};

export type PolicyMeasureExternalReference = {
  __typename?: 'PolicyMeasureExternalReference';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  referenceName?: Maybe<Scalars['String']>;
  referenceUrl?: Maybe<Scalars['String']>;
};

export type PolicyMeasureFilter = {
  approved?: Maybe<Scalars['Boolean']>;
  ncRelevant?: Maybe<Scalars['Boolean']>;
  ndcRelevant?: Maybe<Scalars['Boolean']>;
};

export enum PolicyMeasureGeographicalCoverage {
  Local = 'LOCAL',
  National = 'NATIONAL',
  Regional = 'REGIONAL',
  TwoOrMoreCountries = 'TWO_OR_MORE_COUNTRIES'
}

export type PolicyMeasureGhgEmissionsReduction = {
  __typename?: 'PolicyMeasureGhgEmissionsReduction';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  esr?: Maybe<Scalars['Float']>;
  euEts?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  lulucf?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  yearOffset: Scalars['Int'];
};

export enum PolicyMeasureGhgGas {
  Ch4 = 'CH4',
  Co2 = 'CO2',
  Hfc = 'HFC',
  N2O = 'N2O',
  Nf3 = 'NF3',
  Pfc = 'PFC',
  Sf6 = 'SF6'
}

export enum PolicyMeasureImpactType {
  EsdEsr = 'ESD_ESR',
  EuEts = 'EU_ETS',
  Lulucf = 'LULUCF'
}

export enum PolicyMeasureImplementationStatus {
  Adopted = 'ADOPTED',
  Expired = 'EXPIRED',
  Implemented = 'IMPLEMENTED',
  Planned = 'PLANNED'
}

export type PolicyMeasureIndicator = {
  __typename?: 'PolicyMeasureIndicator';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export enum PolicyMeasureInformationAccess {
  Open = 'OPEN',
  Restricted = 'RESTRICTED'
}

export enum PolicyMeasureInstrument {
  Economic = 'ECONOMIC',
  Fiscal = 'FISCAL',
  InformationEducation = 'INFORMATION_EDUCATION',
  Other = 'OTHER',
  Planning = 'PLANNING',
  Regulatory = 'REGULATORY',
  Research = 'RESEARCH',
  VoluntaryOrNegotiatedAgreement = 'VOLUNTARY_OR_NEGOTIATED_AGREEMENT'
}

export enum PolicyMeasureProjectionScenario {
  NotIncluded = 'NOT_INCLUDED',
  Wam = 'WAM',
  Wem = 'WEM',
  WithoutMeasuresScenario = 'WITHOUT_MEASURES_SCENARIO'
}

export enum PolicyMeasureResponsibleEntityType {
  CompaniesBusinessesOrIndustrialAssociations = 'COMPANIES_BUSINESSES_OR_INDUSTRIAL_ASSOCIATIONS',
  LocalGovernment = 'LOCAL_GOVERNMENT',
  NationalGovernment = 'NATIONAL_GOVERNMENT',
  Others = 'OTHERS',
  RegionalEntities = 'REGIONAL_ENTITIES',
  ResearchInstitutions = 'RESEARCH_INSTITUTIONS'
}

export enum PolicyMeasureSectors {
  Agriculture = 'AGRICULTURE',
  EnergyConsumption = 'ENERGY_CONSUMPTION',
  EnergySupply = 'ENERGY_SUPPLY',
  IndustrialProcesses = 'INDUSTRIAL_PROCESSES',
  Lulucf = 'LULUCF',
  OtherSectors = 'OTHER_SECTORS',
  Transport = 'TRANSPORT',
  WasteManagement = 'WASTE_MANAGEMENT'
}

export type PolicyMeasureStatistics = {
  __typename?: 'PolicyMeasureStatistics';
  amountPerStatus: Array<PolicyMeasureStatisticsPerStatus>;
  totalAmount: Scalars['Int'];
};

export type PolicyMeasureStatisticsPerStatus = {
  __typename?: 'PolicyMeasureStatisticsPerStatus';
  amount: Scalars['Int'];
  status: PolicyMeasureImplementationStatus;
};

export enum PolicyMeasureType {
  Group = 'GROUP',
  Single = 'SINGLE'
}

export type ProjectionDocument = {
  __typename?: 'ProjectionDocument';
  active: Scalars['Boolean'];
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
};

export type ProjectionValue = {
  __typename?: 'ProjectionValue';
  id: Scalars['ID'];
  scenario: Scenario;
  sector: GhgSector;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type ProjectionValueFilter = {
  scenarios?: Maybe<Array<Scalars['ID']>>;
  sectorCodes?: Maybe<Array<Scalars['String']>>;
  sectors?: Maybe<Array<Scalars['ID']>>;
  yearFrom?: Maybe<Scalars['Int']>;
  yearTo?: Maybe<Scalars['Int']>;
};

export type PublicAvailability = {
  __typename?: 'PublicAvailability';
  externalSources: Array<PublicExternalSourceAvailability>;
  infoDocuments: Array<PublicInfoDocumentAvailability>;
  modules: Array<PublicModuleAvailability>;
};

export type PublicExternalSourceAvailability = {
  __typename?: 'PublicExternalSourceAvailability';
  available: Scalars['Boolean'];
  scope: ExternalSourceScope;
};

export type PublicInfoDocumentAvailability = {
  __typename?: 'PublicInfoDocumentAvailability';
  available: Scalars['Boolean'];
  scope: InfoDocumentScope;
};

export type PublicModuleAvailability = {
  __typename?: 'PublicModuleAvailability';
  available: Scalars['Boolean'];
  scope: ModuleScope;
};

export type Query = {
  __typename?: 'Query';
  article9SupportNeeded: Array<Article9SupportNeeded>;
  article9SupportNeededStatistic: Array<MonetarySupportStatistic>;
  article9SupportReceived: Array<Article9SupportReceived>;
  article9SupportReceivedStatistic: Array<MonetarySupportStatistic>;
  article10SupportNeeded: Array<Article10SupportNeeded>;
  article10SupportNeededStatistic: Array<BasicSupportStatistic>;
  article10SupportReceived: Array<Article10SupportReceived>;
  article10SupportReceivedStatistic: Array<BasicSupportStatistic>;
  article11SupportNeeded: Array<Article11SupportNeeded>;
  article11SupportNeededStatistic: Array<BasicSupportStatistic>;
  article11SupportReceived: Array<Article11SupportReceived>;
  article11SupportReceivedStatistic: Array<BasicSupportStatistic>;
  article13SupportNeededReceived: Array<Article13SupportNeededReceived>;
  article13SupportNeededReceivedStatistic: Array<MonetarySupportStatistic>;
  crfDocuments: Array<CrfDocument>;
  currentUser?: Maybe<ApplicationUser>;
  dataCollectionTemplates: Array<DataCollectionTemplate>;
  dataCollectionYears: Array<DataCollectionYear>;
  dataset: IndicatorDataset;
  externalApplication: ExternalApplication;
  externalApplications: Array<ExternalApplication>;
  externalSources: Array<ExternalSource>;
  ghgCategories: Array<GhgCategory>;
  ghgCategory?: Maybe<GhgCategory>;
  ghgCategoryByCode?: Maybe<GhgCategory>;
  ghgSector?: Maybe<GhgSector>;
  ghgSectorByCode?: Maybe<GhgSector>;
  ghgSectors: Array<GhgSector>;
  ghgValueRange?: Maybe<GhgValueRange>;
  ghgValues: Array<GhgValue>;
  indicators: Array<Indicator>;
  infoDocuments: Array<InfoDocument>;
  measure: Measure;
  measurePeriodData: MeasurePeriodData;
  measureStatistics: MeasureStatistics;
  measures: Array<Measure>;
  moduleVisibilities: Array<ModuleVisibility>;
  ndcTargets: Array<NdcTarget>;
  organizations: Array<Organization>;
  pamObjectives: Array<PamObjective>;
  pamStatistics: PolicyMeasureStatistics;
  pamUnionPolicies: Array<PamUnionPolicy>;
  policiesAndMeasures: Array<PolicyMeasure>;
  policyAndMeasure: PolicyMeasure;
  projectionDocuments: Array<ProjectionDocument>;
  projectionValues: Array<ProjectionValue>;
  publicAvailability: PublicAvailability;
  publicExternalSources: Array<ExternalSource>;
  publicInfoDocuments: Array<InfoDocument>;
  reportingPeriods: Array<ReportingPeriod>;
  scenario?: Maybe<Scenario>;
  scenarios: Array<Scenario>;
  sharedDocuments: Array<SharedDocument>;
  sustainableDevelopmentGoals: Array<SustainableDevelopmentGoal>;
  translation: TranslatedItem;
  userByUsername?: Maybe<ApplicationUser>;
  userGroups: Array<UserGroup>;
  users: Array<ApplicationUser>;
  verifyToken: TokenStatus;
};


export type QueryArticle9SupportNeededArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryArticle9SupportNeededStatisticArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryArticle9SupportReceivedArgs = {
  filter?: Maybe<SupportReceivedFilter>;
};


export type QueryArticle9SupportReceivedStatisticArgs = {
  filter?: Maybe<SupportReceivedFilter>;
};


export type QueryArticle10SupportNeededArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryArticle10SupportNeededStatisticArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryArticle10SupportReceivedArgs = {
  filter?: Maybe<SupportReceivedFilter>;
};


export type QueryArticle10SupportReceivedStatisticArgs = {
  filter?: Maybe<SupportReceivedFilter>;
};


export type QueryArticle11SupportNeededArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryArticle11SupportNeededStatisticArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryArticle11SupportReceivedArgs = {
  filter?: Maybe<SupportReceivedFilter>;
};


export type QueryArticle11SupportReceivedStatisticArgs = {
  filter?: Maybe<SupportReceivedFilter>;
};


export type QueryArticle13SupportNeededReceivedArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryArticle13SupportNeededReceivedStatisticArgs = {
  filter?: Maybe<SupportNeededFilter>;
};


export type QueryDataCollectionTemplatesArgs = {
  year?: Maybe<Scalars['Int']>;
};


export type QueryDatasetArgs = {
  id: Scalars['ID'];
};


export type QueryExternalApplicationArgs = {
  id: Scalars['ID'];
};


export type QueryExternalSourcesArgs = {
  scope: ExternalSourceScope;
};


export type QueryGhgCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryGhgCategoryByCodeArgs = {
  code: Scalars['String'];
};


export type QueryGhgSectorArgs = {
  id: Scalars['ID'];
};


export type QueryGhgSectorByCodeArgs = {
  code: Scalars['String'];
};


export type QueryGhgValuesArgs = {
  filter?: Maybe<GhgValueFilter>;
};


export type QueryIndicatorsArgs = {
  filter?: Maybe<IndicatorsFilterDto>;
};


export type QueryInfoDocumentsArgs = {
  scope: InfoDocumentScope;
};


export type QueryMeasureArgs = {
  id: Scalars['ID'];
};


export type QueryMeasurePeriodDataArgs = {
  id: Scalars['ID'];
};


export type QueryMeasureStatisticsArgs = {
  onlyApproved?: Maybe<Scalars['Boolean']>;
};


export type QueryMeasuresArgs = {
  filter?: Maybe<MeasuresQueryFilter>;
};


export type QueryNdcTargetsArgs = {
  filter?: Maybe<NdcTargetFilter>;
};


export type QueryPamStatisticsArgs = {
  onlyApproved?: Maybe<Scalars['Boolean']>;
};


export type QueryPoliciesAndMeasuresArgs = {
  filter?: Maybe<PolicyMeasureFilter>;
};


export type QueryPolicyAndMeasureArgs = {
  id: Scalars['ID'];
};


export type QueryProjectionValuesArgs = {
  filter?: Maybe<ProjectionValueFilter>;
};


export type QueryPublicExternalSourcesArgs = {
  scope: ExternalSourceScope;
};


export type QueryPublicInfoDocumentsArgs = {
  scope: InfoDocumentScope;
};


export type QueryScenarioArgs = {
  id: Scalars['ID'];
};


export type QuerySharedDocumentsArgs = {
  scope: SharedDocumentScope;
  year?: Maybe<Scalars['Int']>;
};


export type QueryTranslationArgs = {
  key: TranslationKey;
};


export type QueryUserByUsernameArgs = {
  username: Scalars['String'];
};


export type QueryVerifyTokenArgs = {
  token: Scalars['ID'];
};

export type ReportingPeriod = {
  __typename?: 'ReportingPeriod';
  endYear: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startYear: Scalars['Int'];
};

export enum Responsibility {
  Implementation = 'IMPLEMENTATION',
  MonitoringAndReporting = 'MONITORING_AND_REPORTING',
  Planning = 'PLANNING'
}

export type Scenario = {
  __typename?: 'Scenario';
  code: Scalars['String'];
  id: Scalars['ID'];
  orderIndex: Scalars['Int'];
  preferredTranslation?: Maybe<TranslatedText>;
  translations: Array<TranslatedText>;
  values: Array<ProjectionValue>;
};


export type ScenarioPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};


export type ScenarioValuesArgs = {
  filter?: Maybe<ProjectionValueFilter>;
};

export type SharedDocument = {
  __typename?: 'SharedDocument';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization: Organization;
  scope: SharedDocumentScope;
  visibleByAllOrganizations: Scalars['Boolean'];
  year: Scalars['Int'];
};

export enum SharedDocumentScope {
  Cca = 'CCA',
  Cf = 'CF',
  Ghg = 'GHG',
  Indi = 'INDI',
  Nc = 'NC',
  Ndc = 'NDC',
  Pam = 'PAM',
  Pas = 'PAS'
}

export type SimpleFileUpload = {
  fileName: Scalars['String'];
  storagePath: Scalars['String'];
};

export enum SourceOfFunding {
  GrantOrDonation = 'GRANT_OR_DONATION',
  Loan = 'LOAN',
  LocalBudget = 'LOCAL_BUDGET',
  PrivateFinancing = 'PRIVATE_FINANCING',
  StateBudget = 'STATE_BUDGET'
}

export type SupportNeeded = {
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  expectedTimeframeEnd: Scalars['Int'];
  expectedTimeframeStart: Scalars['Int'];
  expectedUseImpactAndEstimatedResults?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  project: CfProject;
  supportType?: Maybe<SupportType>;
};

export type SupportNeededFilter = {
  common?: Maybe<CommonSupportFilter>;
  hasSupportRecieved?: Maybe<Scalars['Boolean']>;
};

export type SupportReceived = {
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  implementingEntity?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  recipientEntity?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  supportType?: Maybe<SupportType>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type SupportReceivedFilter = {
  common?: Maybe<CommonSupportFilter>;
  statusOfActivity?: Maybe<ActivityStatus>;
};

export type SupportStatistic = {
  amount: Scalars['Int'];
  year: Scalars['Int'];
};

export enum SupportType {
  Adaptation = 'ADAPTATION',
  CrossCutting = 'CROSS_CUTTING',
  Mitigation = 'MITIGATION'
}

export type SustainableDevelopmentGoal = {
  __typename?: 'SustainableDevelopmentGoal';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  orderIndex: Scalars['Int'];
  preferredTranslation?: Maybe<TranslatedText>;
  translations: Array<TranslatedText>;
};


export type SustainableDevelopmentGoalPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export enum TerritorialCoverage {
  Local = 'LOCAL',
  National = 'NATIONAL',
  Regional = 'REGIONAL'
}

export enum TokenStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Used = 'USED',
  Valid = 'VALID'
}

export type TranslatedItem = {
  __typename?: 'TranslatedItem';
  id: Scalars['ID'];
  preferredTranslation?: Maybe<TranslatedText>;
  translationKey: TranslationKey;
  translations: Array<TranslatedText>;
};


export type TranslatedItemPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type TranslatedText = {
  __typename?: 'TranslatedText';
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  language: Language;
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  translation: Scalars['String'];
};

export enum TranslationKey {
  CcaIntroduction = 'CCA_INTRODUCTION',
  CfArticle9Introduction = 'CF_ARTICLE9_INTRODUCTION',
  CfArticle10Introduction = 'CF_ARTICLE10_INTRODUCTION',
  CfArticle11Introduction = 'CF_ARTICLE11_INTRODUCTION',
  CfArticle13Introduction = 'CF_ARTICLE13_INTRODUCTION',
  CfIntroduction = 'CF_INTRODUCTION',
  ExternalApplicationsIntroduction = 'EXTERNAL_APPLICATIONS_INTRODUCTION',
  GhgEmissionsChart = 'GHG_EMISSIONS_CHART',
  GhgEmissionsGasChart = 'GHG_EMISSIONS_GAS_CHART',
  GhgEmissionsSectorChart = 'GHG_EMISSIONS_SECTOR_CHART',
  GhgIntroduction = 'GHG_INTRODUCTION',
  IndiCcaFigures = 'INDI_CCA_FIGURES',
  IndiGhgFigures = 'INDI_GHG_FIGURES',
  IndiIntroduction = 'INDI_INTRODUCTION',
  IndiOtherFigures = 'INDI_OTHER_FIGURES',
  IndiPasFigures = 'INDI_PAS_FIGURES',
  IntroductionHeader = 'INTRODUCTION_HEADER',
  IntroductionText = 'INTRODUCTION_TEXT',
  NdcIntroduction = 'NDC_INTRODUCTION',
  NdcNationalChart = 'NDC_NATIONAL_CHART',
  NdcSectorChart = 'NDC_SECTOR_CHART',
  PamIntroduction = 'PAM_INTRODUCTION',
  PasIntroduction = 'PAS_INTRODUCTION',
  PasScenarioChart = 'PAS_SCENARIO_CHART'
}

export type UpdateArticle9SupportNeeded = {
  base: BaseArticle9SupportNeeded;
  common: BaseSupportNeeded;
  id: Scalars['ID'];
};

export type UpdateArticle9SupportReceived = {
  base: BaseArticle9SupportReceived;
  common: BaseSupportReceived;
  id: Scalars['ID'];
};

export type UpdateArticle10SupportNeeded = {
  base: BaseArticle10SupportNeeded;
  common: BaseSupportNeeded;
  id: Scalars['ID'];
};

export type UpdateArticle10SupportReceived = {
  base: BaseArticle10SupportReceived;
  common: BaseSupportReceived;
  id: Scalars['ID'];
};

export type UpdateArticle11SupportNeeded = {
  base: BaseArticle11Support;
  common: BaseSupportNeeded;
  id: Scalars['ID'];
};

export type UpdateArticle11SupportReceived = {
  base: BaseArticle11Support;
  common: BaseSupportReceived;
  id: Scalars['ID'];
};

export type UpdateArticle13SupportNeededReceived = {
  amountRsd: Scalars['Float'];
  amountUsd: Scalars['Float'];
  channel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  projectDescription?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  recipientEntity?: Maybe<Scalars['String']>;
  statusOfActivity?: Maybe<ActivityStatus>;
  timeframeEnd: Scalars['Int'];
  timeframeStart: Scalars['Int'];
  useImpactAndEstimatedResults?: Maybe<Scalars['String']>;
};

export type UpdateDataCollectionDocument = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdateDataCollectionDocumentContent = {
  fileName: Scalars['String'];
  storagePath: Scalars['String'];
};

export type UpdateDataCollectionTemplate = {
  description: Scalars['String'];
  name: Scalars['String'];
  notificationReceivers: Array<Scalars['ID']>;
  reportingOrganization: Scalars['ID'];
};

export type UpdateExternalApplication = {
  applicationUrl: Scalars['String'];
  nameTranslations: Array<UpdateTranslationText>;
};

export type UpdateExternalSource = {
  descriptionTranslations: Array<UpdateTranslationText>;
  nameTranslations: Array<UpdateTranslationText>;
  sourceUrl: Scalars['String'];
};

export type UpdateIndicator = {
  datasets: Array<UpdateIndicatorDataset>;
  name: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
};

export type UpdateIndicatorDataset = {
  additionalRemarks?: Maybe<Scalars['String']>;
  guidanceDefinitions?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  numeratorDenominator?: Maybe<Scalars['String']>;
};

export type UpdateIndicatorDatasetValue = {
  dataset: Scalars['ID'];
  value?: Maybe<Scalars['Float']>;
  year: Scalars['Int'];
};

export type UpdateInfoDocument = {
  descriptionTranslations: Array<UpdateTranslationText>;
  nameTranslations: Array<UpdateTranslationText>;
};

export type UpdateMeasure = {
  achievedResults?: Maybe<Scalars['String']>;
  climateChangeImpacts?: Maybe<Array<ClimateChangeImpactState>>;
  description: Scalars['String'];
  expectedImprovements?: Maybe<Scalars['String']>;
  expectedSourceOfFunding?: Maybe<Scalars['String']>;
  extensionOfMeasure?: Maybe<Scalars['String']>;
  extremeEvents?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  impactOnGhgEmissions?: Maybe<Scalars['String']>;
  implementationPhases?: Maybe<Scalars['String']>;
  indicators?: Maybe<Scalars['String']>;
  legalAndPolicyBasis?: Maybe<Scalars['String']>;
  lifetimeEnd: Scalars['String'];
  lifetimeStart: Scalars['String'];
  linkToOtherMeasures?: Maybe<Scalars['String']>;
  linkz?: Maybe<Scalars['String']>;
  lossesAndDamages?: Maybe<Scalars['String']>;
  measureType: MeasureType;
  name: Scalars['String'];
  objective: Scalars['String'];
  otherBenefits?: Maybe<Scalars['String']>;
  problemsAndBarriers?: Maybe<Scalars['String']>;
  publicConsultationProcess?: Maybe<Scalars['String']>;
  reportingInMrv: Scalars['String'];
  responsibilityFor?: Maybe<Responsibility>;
  territorialCoverage: TerritorialCoverage;
  totalExpectedInvestmentRsd?: Maybe<Scalars['Float']>;
  totalExpectedInvestmentUsd?: Maybe<Scalars['Float']>;
};

export type UpdateMeasurePeriodData = {
  id: Scalars['ID'];
  investmentRsd?: Maybe<Scalars['Float']>;
  investmentUsd?: Maybe<Scalars['Float']>;
  realized: Scalars['Boolean'];
  sourceOfFunding?: Maybe<SourceOfFunding>;
  status: MeasureStatus;
};

export type UpdateModuleVisibility = {
  publiclyVisible: Scalars['Boolean'];
  scope: ModuleScope;
};

export type UpdateNdcTarget = {
  id: Scalars['ID'];
  targetValues: Array<UpdateNdcTargetValue>;
};

export type UpdateNdcTargetValue = {
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type UpdateOrganization = {
  translations: Array<UpdateTranslationText>;
};

export type UpdatePolicyMeasure = {
  additionalComment?: Maybe<Scalars['String']>;
  affectedGhgGases?: Maybe<Array<PolicyMeasureGhgGas>>;
  affectedSectors?: Maybe<Array<PolicyMeasureSectors>>;
  article15ContributionAssessment?: Maybe<Scalars['String']>;
  assesmentsAndTechnicalReports?: Maybe<UpdatePolicyMeasureExternalReference>;
  exAnteAssessment?: Maybe<UpdatePolicyMeasureExAnteAssessment>;
  exPostAssessment?: Maybe<UpdatePolicyMeasureExPostAssessment>;
  genderEqualityImpact?: Maybe<Scalars['String']>;
  generalComments?: Maybe<Scalars['String']>;
  geographicalCoverage?: Maybe<PolicyMeasureGeographicalCoverage>;
  implementationPeriodEnd?: Maybe<Scalars['Int']>;
  implementationPeriodStart?: Maybe<Scalars['Int']>;
  implementationResponsibleEntityName?: Maybe<Scalars['String']>;
  implementationResponsibleEntityType?: Maybe<PolicyMeasureResponsibleEntityType>;
  implementationStatus?: Maybe<PolicyMeasureImplementationStatus>;
  implementationStatusDetails?: Maybe<Scalars['String']>;
  includingProjectionsScenario?: Maybe<PolicyMeasureProjectionScenario>;
  indicatorValues?: Maybe<Array<UpdatePolicyMeasureIndicator>>;
  indicatorsDescription?: Maybe<Scalars['String']>;
  informationAccess?: Maybe<PolicyMeasureInformationAccess>;
  informationSourceName?: Maybe<Scalars['String']>;
  interactionWithOtherPoliciesAndMeasuresDescription?: Maybe<Scalars['String']>;
  interactsWithOtherPoliciesAndMeasures?: Maybe<Scalars['Boolean']>;
  localName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  neededImprovements?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<Scalars['ID']>>;
  pamType?: Maybe<PolicyMeasureType>;
  policiesOrMeasureCoverage?: Maybe<Scalars['String']>;
  policyImpactType?: Maybe<Array<PolicyMeasureImpactType>>;
  policyInstrumentType?: Maybe<Array<PolicyMeasureInstrument>>;
  projectedCostsAndBenefits?: Maybe<UpdatePolicyMeasureCostsAndBenefits>;
  quantifiedObjective?: Maybe<Scalars['String']>;
  realizedCostsAndBenefits?: Maybe<UpdatePolicyMeasureCostsAndBenefits>;
  relatedSerbianPolicy?: Maybe<Scalars['String']>;
  relatedToUnionPolicy?: Maybe<Scalars['Boolean']>;
  relatedUnionPolicy?: Maybe<Array<Scalars['ID']>>;
  responsibilityDetails?: Maybe<Scalars['String']>;
  sdgImpact?: Maybe<Scalars['ID']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type UpdatePolicyMeasureCostsAndBenefits = {
  absoluteBenefitPerYearEur?: Maybe<Scalars['Float']>;
  absoluteGrossCostsPerYearEur?: Maybe<Scalars['Float']>;
  absoluteNetCostsPerYearEur?: Maybe<Scalars['Float']>;
  benefitsEurPerTonCO2eReduced?: Maybe<Scalars['Float']>;
  calculatedYears?: Maybe<Scalars['String']>;
  costEstimatesDescription?: Maybe<Scalars['String']>;
  estimationSourceDocumentation?: Maybe<UpdatePolicyMeasureExternalReference>;
  grossCostsEurPerTonCO2eReduced?: Maybe<Scalars['Float']>;
  netCostsEurPerTonCO2eReduced?: Maybe<Scalars['Float']>;
  nonGhgMitigationBenefitsDescription?: Maybe<Scalars['String']>;
  priceYear?: Maybe<Scalars['Int']>;
};

export type UpdatePolicyMeasureExAnteAssessment = {
  affectedFactors?: Maybe<Scalars['String']>;
  documentationOfEstimation?: Maybe<UpdatePolicyMeasureExternalReference>;
  ghgEmissionsReduction?: Maybe<Array<UpdatePolicyMeasureGhgEmissionsReduction>>;
  mitigationEstimateBasisExplanation?: Maybe<Scalars['String']>;
};

export type UpdatePolicyMeasureExPostAssessment = {
  affectedFactors?: Maybe<Scalars['String']>;
  documentationOfEstimation?: Maybe<UpdatePolicyMeasureExternalReference>;
  ghgEmissionsReduction?: Maybe<UpdatePolicyMeasureGhgEmissionsReduction>;
  mitigationEstimateBasisExplanation?: Maybe<Scalars['String']>;
};

export type UpdatePolicyMeasureExternalReference = {
  referenceName?: Maybe<Scalars['String']>;
  referenceUrl?: Maybe<Scalars['String']>;
};

export type UpdatePolicyMeasureGhgEmissionsReduction = {
  esr?: Maybe<Scalars['Float']>;
  euEts?: Maybe<Scalars['Float']>;
  lulucf?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  yearOffset: Scalars['Int'];
};

export type UpdatePolicyMeasureIndicator = {
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type UpdateSharedDocument = {
  description: Scalars['String'];
  name: Scalars['String'];
  year: Scalars['Int'];
};

export type UpdateTranslation = {
  translationKey: TranslationKey;
  translations: Array<UpdateTranslationText>;
};

export type UpdateTranslationText = {
  languageCode: Scalars['String'];
  translatedText: Scalars['String'];
};

export type UpdateUser = {
  displayName: Scalars['String'];
  email: Scalars['String'];
  groupMemberships: Array<Scalars['ID']>;
  organization: Scalars['ID'];
};

export type UserGroup = {
  __typename?: 'UserGroup';
  authorities: Array<Scalars['String']>;
  createdBy: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  lastModifiedBy?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
  preferredTranslation?: Maybe<TranslatedText>;
  translations: Array<TranslatedText>;
};


export type UserGroupPreferredTranslationArgs = {
  preferredLanguage: Scalars['String'];
};

export type ApproveArticle9SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveArticle9SupportNeededMutation = { __typename?: 'Mutation', approveArticle9SupportNeeded: { __typename?: 'Article9SupportNeeded', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApproveArticle9SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveArticle9SupportReceivedMutation = { __typename?: 'Mutation', approveArticle9SupportReceived: { __typename?: 'Article9SupportReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApproveArticle10SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveArticle10SupportNeededMutation = { __typename?: 'Mutation', approveArticle10SupportNeeded: { __typename?: 'Article10SupportNeeded', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApproveArticle10SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveArticle10SupportReceivedMutation = { __typename?: 'Mutation', approveArticle10SupportReceived: { __typename?: 'Article10SupportReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApproveArticle11SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveArticle11SupportNeededMutation = { __typename?: 'Mutation', approveArticle11SupportNeeded: { __typename?: 'Article11SupportNeeded', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApproveArticle11SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveArticle11SupportReceivedMutation = { __typename?: 'Mutation', approveArticle11SupportReceived: { __typename?: 'Article11SupportReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApproveArticle13SupportNeededReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveArticle13SupportNeededReceivedMutation = { __typename?: 'Mutation', approveArticle13SupportNeededReceived: { __typename?: 'Article13SupportNeededReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApproveDataCollectionDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveDataCollectionDocumentMutation = { __typename?: 'Mutation', approveDataCollectionDocument: { __typename?: 'DataCollectionDocument', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined } };

export type ApproveMeasureMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveMeasureMutation = { __typename?: 'Mutation', approveMeasure: { __typename?: 'Measure', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type ApprovePolicyAndMeasureMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApprovePolicyAndMeasureMutation = { __typename?: 'Mutation', approvePolicyAndMeasure: { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string }> | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string } | null | undefined } };

export type Article10NeededDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Article10NeededDetailsQuery = { __typename?: 'Query', article10SupportNeeded: Array<{ __typename?: 'Article10SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, typeOfTechnology?: string | null | undefined, expectedUseImpactAndEstimatedResults?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article10SupportReceived', id: string }> }> };

export type Article10NeededListQueryVariables = Exact<{
  filter?: Maybe<SupportNeededFilter>;
}>;


export type Article10NeededListQuery = { __typename?: 'Query', supportNeeded: Array<{ __typename?: 'Article10SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article10SupportReceived', id: string }> }> };

export type Article10ReceivedDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Article10ReceivedDetailsQuery = { __typename?: 'Query', article10SupportReceived: Array<{ __typename?: 'Article10SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, typeOfTechnology?: string | null | undefined, useImpactAndEstimatedResults?: string | null | undefined, recipientEntity?: string | null | undefined, implementingEntity?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article10SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } }> };

export type Article10ReceivedListQueryVariables = Exact<{
  filter?: Maybe<SupportReceivedFilter>;
}>;


export type Article10ReceivedListQuery = { __typename?: 'Query', supportReceived: Array<{ __typename?: 'Article10SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article10SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } }> };

export type Article10StatisticsQueryVariables = Exact<{
  filter?: Maybe<CommonSupportFilter>;
}>;


export type Article10StatisticsQuery = { __typename?: 'Query', supportNeededStatistic: Array<{ __typename?: 'BasicSupportStatistic', year: number, amount: number }>, supportReceivedStatistic: Array<{ __typename?: 'BasicSupportStatistic', year: number, amount: number }> };

export type Article11NeededDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Article11NeededDetailsQuery = { __typename?: 'Query', article11SupportNeeded: Array<{ __typename?: 'Article11SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, supportType?: SupportType | null | undefined, expectedUseImpactAndEstimatedResults?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article11SupportReceived', id: string }> }> };

export type Article11NeededListQueryVariables = Exact<{
  filter?: Maybe<SupportNeededFilter>;
}>;


export type Article11NeededListQuery = { __typename?: 'Query', supportNeeded: Array<{ __typename?: 'Article11SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, supportType?: SupportType | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article11SupportReceived', id: string }> }> };

export type Article11ReceivedDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Article11ReceivedDetailsQuery = { __typename?: 'Query', article11SupportReceived: Array<{ __typename?: 'Article11SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, useImpactAndEstimatedResults?: string | null | undefined, recipientEntity?: string | null | undefined, implementingEntity?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article11SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } }> };

export type Article11ReceivedListQueryVariables = Exact<{
  filter?: Maybe<SupportReceivedFilter>;
}>;


export type Article11ReceivedListQuery = { __typename?: 'Query', supportReceived: Array<{ __typename?: 'Article11SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article11SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } }> };

export type Article11StatisticsQueryVariables = Exact<{
  filter?: Maybe<CommonSupportFilter>;
}>;


export type Article11StatisticsQuery = { __typename?: 'Query', supportNeededStatistic: Array<{ __typename?: 'BasicSupportStatistic', year: number, amount: number }>, supportReceivedStatistic: Array<{ __typename?: 'BasicSupportStatistic', year: number, amount: number }> };

export type Article13NeededReceivedDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Article13NeededReceivedDetailsQuery = { __typename?: 'Query', article13SupportNeededReceived: Array<{ __typename?: 'Article13SupportNeededReceived', id: string, recipientEntity?: string | null | undefined, channel?: string | null | undefined, amountRsd: number, amountUsd: number, timeframeStart: number, timeframeEnd: number, statusOfActivity?: ActivityStatus | null | undefined, useImpactAndEstimatedResults?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } }> };

export type Article13NeededReceivedListQueryVariables = Exact<{
  filter?: Maybe<SupportNeededFilter>;
}>;


export type Article13NeededReceivedListQuery = { __typename?: 'Query', supportNeeded: Array<{ __typename?: 'Article13SupportNeededReceived', id: string, timeframeStart: number, timeframeEnd: number, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } }> };

export type Article13StatisticsQueryVariables = Exact<{
  filter?: Maybe<CommonSupportFilter>;
}>;


export type Article13StatisticsQuery = { __typename?: 'Query', supportStatistic: Array<{ __typename?: 'MonetarySupportStatistic', year: number, amount: number, valueRsd: number, valueUsd: number }> };

export type Article9NeededDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Article9NeededDetailsQuery = { __typename?: 'Query', article9SupportNeeded: Array<{ __typename?: 'Article9SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, expectedUseImpactAndEstimatedResults?: string | null | undefined, supportType?: SupportType | null | undefined, expectedFinancialInstrument?: FinancialInstrument | null | undefined, estimatedAmountRsd: number, estimatedAmountUsd: number, sector?: string | null | undefined, activityContribution?: string | null | undefined, activityAnchored?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article9SupportReceived', id: string }> }> };

export type Article9NeededListQueryVariables = Exact<{
  filter?: Maybe<SupportNeededFilter>;
}>;


export type Article9NeededListQuery = { __typename?: 'Query', supportNeeded: Array<{ __typename?: 'Article9SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article9SupportReceived', id: string }> }> };

export type Article9ReceivedDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Article9ReceivedDetailsQuery = { __typename?: 'Query', article9SupportReceived: Array<{ __typename?: 'Article9SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, channel?: string | null | undefined, amountRsd: number, amountUsd: number, financialInstrument?: FinancialInstrument | null | undefined, activityContribution?: string | null | undefined, recipientEntity?: string | null | undefined, implementingEntity?: string | null | undefined, useImpactAndEstimatedResults?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article9SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } }> };

export type Article9ReceivedListQueryVariables = Exact<{
  filter?: Maybe<SupportReceivedFilter>;
}>;


export type Article9ReceivedListQuery = { __typename?: 'Query', supportReceived: Array<{ __typename?: 'Article9SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article9SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } }> };

export type Article9StatisticsQueryVariables = Exact<{
  filter?: Maybe<CommonSupportFilter>;
}>;


export type Article9StatisticsQuery = { __typename?: 'Query', supportNeededStatistic: Array<{ __typename?: 'MonetarySupportStatistic', year: number, amount: number, valueRsd: number, valueUsd: number }>, supportReceivedStatistic: Array<{ __typename?: 'MonetarySupportStatistic', year: number, amount: number, valueRsd: number, valueUsd: number }> };

export type ChangeExternalSourcePrimaryMutationVariables = Exact<{
  sourceId: Scalars['ID'];
  primary: Scalars['Boolean'];
  language: Scalars['String'];
}>;


export type ChangeExternalSourcePrimaryMutation = { __typename?: 'Mutation', changeSourcePrimary: { __typename?: 'ExternalSource', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type ChangeExternalSourceVisibilityMutationVariables = Exact<{
  sourceId: Scalars['ID'];
  visible: Scalars['Boolean'];
  language: Scalars['String'];
}>;


export type ChangeExternalSourceVisibilityMutation = { __typename?: 'Mutation', changeSourceVisibility: { __typename?: 'ExternalSource', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type ChangeInfoDocumentPrimaryMutationVariables = Exact<{
  documentId: Scalars['ID'];
  primary: Scalars['Boolean'];
  language: Scalars['String'];
}>;


export type ChangeInfoDocumentPrimaryMutation = { __typename?: 'Mutation', changeInfoDocumentPrimary: { __typename?: 'InfoDocument', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type ChangeInfoDocumentVisibilityMutationVariables = Exact<{
  documentId: Scalars['ID'];
  visible: Scalars['Boolean'];
  language: Scalars['String'];
}>;


export type ChangeInfoDocumentVisibilityMutation = { __typename?: 'Mutation', changeInfoDocumentVisibility: { __typename?: 'InfoDocument', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type ChangePasswordByTokenMutationVariables = Exact<{
  token: Scalars['ID'];
  dto: ChangePasswordToken;
}>;


export type ChangePasswordByTokenMutation = { __typename?: 'Mutation', changePasswordByToken: { __typename?: 'ApplicationUser', id: string, username: string } };

export type ChangePasswordMutationVariables = Exact<{
  username: Scalars['String'];
  dto: ChangePassword;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ApplicationUser', id: string } };

export type ChangeSharedDocumentVisibilityMutationVariables = Exact<{
  documentId: Scalars['ID'];
  visible: Scalars['Boolean'];
  language: Scalars['String'];
}>;


export type ChangeSharedDocumentVisibilityMutation = { __typename?: 'Mutation', changeSharedDocumentVisibility: { __typename?: 'SharedDocument', id: string, fileName: string, year: number, visibleByAllOrganizations: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, name: string, description: string, organization: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } } };

export type CreateArticle10NeededMutationVariables = Exact<{
  dto: CreateArticle10SupportNeeded;
}>;


export type CreateArticle10NeededMutation = { __typename?: 'Mutation', createArticle10SupportNeeded: { __typename?: 'Article10SupportNeeded', id: string } };

export type CreateArticle10ReceivedMutationVariables = Exact<{
  dto: CreateArticle10SupportReceived;
}>;


export type CreateArticle10ReceivedMutation = { __typename?: 'Mutation', createArticle10SupportReceived: { __typename?: 'Article10SupportReceived', id: string } };

export type CreateArticle11NeededMutationVariables = Exact<{
  dto: CreateArticle11SupportNeeded;
}>;


export type CreateArticle11NeededMutation = { __typename?: 'Mutation', createArticle11SupportNeeded: { __typename?: 'Article11SupportNeeded', id: string } };

export type CreateArticle11ReceivedMutationVariables = Exact<{
  dto: CreateArticle11SupportReceived;
}>;


export type CreateArticle11ReceivedMutation = { __typename?: 'Mutation', createArticle11SupportReceived: { __typename?: 'Article11SupportReceived', id: string } };

export type CreateArticle13NeededReceivedMutationVariables = Exact<{
  dto: CreateArticle13SupportNeededReceived;
}>;


export type CreateArticle13NeededReceivedMutation = { __typename?: 'Mutation', createArticle13SupportNeededReceived: { __typename?: 'Article13SupportNeededReceived', id: string } };

export type CreateArticle9NeededMutationVariables = Exact<{
  dto: CreateArticle9SupportNeeded;
}>;


export type CreateArticle9NeededMutation = { __typename?: 'Mutation', createArticle9SupportNeeded: { __typename?: 'Article9SupportNeeded', id: string } };

export type CreateArticle9ReceivedMutationVariables = Exact<{
  dto: CreateArticle9SupportReceived;
}>;


export type CreateArticle9ReceivedMutation = { __typename?: 'Mutation', createArticle9SupportReceived: { __typename?: 'Article9SupportReceived', id: string } };

export type CreateExternalApplicationMutationVariables = Exact<{
  dto: UpdateExternalApplication;
  language: Scalars['String'];
}>;


export type CreateExternalApplicationMutation = { __typename?: 'Mutation', createExternalApplication: { __typename?: 'ExternalApplication', id: string, applicationUrl: string, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type CreateExternalSourceMutationVariables = Exact<{
  dto: CreateExternalSource;
  language: Scalars['String'];
}>;


export type CreateExternalSourceMutation = { __typename?: 'Mutation', createExternalSource: { __typename?: 'ExternalSource', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type CreateIndicatorMutationVariables = Exact<{
  dto: CreateIndicator;
}>;


export type CreateIndicatorMutation = { __typename?: 'Mutation', createIndicator: { __typename?: 'Indicator', id: string, number?: number | null | undefined, name: string, datasets: Array<{ __typename?: 'IndicatorDataset', id: string, code?: string | null | undefined, name: string, numeratorDenominator?: string | null | undefined, guidanceDefinitions?: string | null | undefined, additionalRemarks?: string | null | undefined, comments?: string | null | undefined }> } };

export type CreateMeasureMutationVariables = Exact<{
  dto: CreateMeasure;
}>;


export type CreateMeasureMutation = { __typename?: 'Mutation', createMeasure: { __typename?: 'Measure', id: string, name: string, lifetimeStart: string, lifetimeEnd: string, measureType: MeasureType, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, reportingPeriods: Array<{ __typename?: 'ReportingPeriod', id: string, name: string, startYear: number, endYear: number }>, periodData?: Array<{ __typename?: 'MeasurePeriodData', reportingPeriod: { __typename?: 'ReportingPeriod', id: string } }> | null | undefined } };

export type CreateMeasurePeriodDataMutationVariables = Exact<{
  dto: CreateMeasurePeriodData;
}>;


export type CreateMeasurePeriodDataMutation = { __typename?: 'Mutation', createMeasurePeriodData: { __typename?: 'MeasurePeriodData', id: string, status: MeasureStatus, sourceOfFunding?: SourceOfFunding | null | undefined, realized: boolean, investmentRsd?: number | null | undefined, investmentUsd?: number | null | undefined, measure: { __typename?: 'Measure', id: string }, reportingPeriod: { __typename?: 'ReportingPeriod', id: string, name: string } } };

export type CreateOrganizationMutationVariables = Exact<{
  dto: UpdateOrganization;
  language: Scalars['String'];
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } };

export type CreatePamMutationVariables = Exact<{
  dto: UpdatePolicyMeasure;
}>;


export type CreatePamMutation = { __typename?: 'Mutation', createPolicyAndMeasure: { __typename?: 'PolicyMeasure', id: string } };

export type CreateUserMutationVariables = Exact<{
  dto: CreateUser;
  language: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'ApplicationUser', id: string, displayName?: string | null | undefined, username: string, email: string, enabled: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, groupMemberships: Array<{ __typename?: 'UserGroup', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }>, organization?: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } | null | undefined } };

export type CrfDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type CrfDocumentsQuery = { __typename?: 'Query', crfDocuments: Array<{ __typename?: 'CrfDocument', id: string, fileName: string, active: boolean, createdBy: string, createdDate: string }> };

export type CurrentUserDetailsQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type CurrentUserDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'ApplicationUser', id: string, displayName?: string | null | undefined, username: string, email: string, enabled: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, groupMemberships: Array<{ __typename?: 'UserGroup', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }>, organization?: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } | null | undefined } | null | undefined };

export type CurrentUserPingQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'ApplicationUser', id: string } | null | undefined };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'ApplicationUser', id: string, username: string, authorities: Array<string> } | null | undefined };

export type DataCollectionListQueryVariables = Exact<{
  language: Scalars['String'];
  year: Scalars['Int'];
}>;


export type DataCollectionListQuery = { __typename?: 'Query', dataCollectionTemplates: Array<{ __typename?: 'DataCollectionTemplate', id: string, name: string, description: string, fileName?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, documents: Array<{ __typename?: 'DataCollectionDocument', id: string, name: string, fileName: string, description?: string | null | undefined, year: number, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, accessOrganizations: Array<{ __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> }>, reportingOrganization: { __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }, notificationReceivers: Array<{ __typename?: 'ApplicationUser', id: string }> }> };

export type DataCollectionTemplateListQueryVariables = Exact<{
  year?: Maybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type DataCollectionTemplateListQuery = { __typename?: 'Query', dataCollectionTemplates: Array<{ __typename?: 'DataCollectionTemplate', id: string, name: string, description: string, fileName?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, reportingOrganization: { __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }, notificationReceivers: Array<{ __typename?: 'ApplicationUser', id: string }> }> };

export type DataCollectionYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataCollectionYearsQuery = { __typename?: 'Query', dataCollectionYears: Array<{ __typename?: 'DataCollectionYear', id: string, year: number, yearLocked: boolean, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined }> };

export type DeleteArticle9SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticle9SupportNeededMutation = { __typename?: 'Mutation', deleteArticle9SupportNeeded: { __typename?: 'Article9SupportNeeded', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type DeleteArticle9SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticle9SupportReceivedMutation = { __typename?: 'Mutation', deleteArticle9SupportReceived: { __typename?: 'Article9SupportReceived', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type DeleteArticle10SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticle10SupportNeededMutation = { __typename?: 'Mutation', deleteArticle10SupportNeeded: { __typename?: 'Article10SupportNeeded', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type DeleteArticle10SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticle10SupportReceivedMutation = { __typename?: 'Mutation', deleteArticle10SupportReceived: { __typename?: 'Article10SupportReceived', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type DeleteArticle11SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticle11SupportNeededMutation = { __typename?: 'Mutation', deleteArticle11SupportNeeded: { __typename?: 'Article11SupportNeeded', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type DeleteArticle11SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticle11SupportReceivedMutation = { __typename?: 'Mutation', deleteArticle11SupportReceived: { __typename?: 'Article11SupportReceived', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type DeleteArticle13SupportNeededReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticle13SupportNeededReceivedMutation = { __typename?: 'Mutation', deleteArticle13SupportNeededReceived: { __typename?: 'Article13SupportNeededReceived', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type DeleteExternalApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteExternalApplicationMutation = { __typename?: 'Mutation', deleteExternalApplication: { __typename?: 'ExternalApplication', id: string } };

export type DeleteExternalSourceMutationVariables = Exact<{
  sourceId: Scalars['ID'];
  language: Scalars['String'];
}>;


export type DeleteExternalSourceMutation = { __typename?: 'Mutation', deleteExternalSource: { __typename?: 'ExternalSource', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type DeleteIndicatorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIndicatorMutation = { __typename?: 'Mutation', deleteIndicator: { __typename?: 'Indicator', id: string } };

export type DeleteInfoDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
  language: Scalars['String'];
}>;


export type DeleteInfoDocumentMutation = { __typename?: 'Mutation', deleteInfoDocument: { __typename?: 'InfoDocument', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type DeleteMeasureMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMeasureMutation = { __typename?: 'Mutation', deleteMeasure: { __typename?: 'Measure', id: string } };

export type DeletePamMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePamMutation = { __typename?: 'Mutation', deletePolicyAndMeasure: { __typename?: 'PolicyMeasure', id: string } };

export type DeleteSharedDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type DeleteSharedDocumentMutation = { __typename?: 'Mutation', deleteSharedDocument: boolean };

export type ExternalApplicationQueryVariables = Exact<{
  id: Scalars['ID'];
  language: Scalars['String'];
}>;


export type ExternalApplicationQuery = { __typename?: 'Query', externalApplication: { __typename?: 'ExternalApplication', id: string, applicationUrl: string, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type ExternalApplicationsQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type ExternalApplicationsQuery = { __typename?: 'Query', externalApplications: Array<{ __typename?: 'ExternalApplication', id: string, applicationUrl: string, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type ExternalSourcesQueryVariables = Exact<{
  scope: ExternalSourceScope;
  language: Scalars['String'];
}>;


export type ExternalSourcesQuery = { __typename?: 'Query', externalSources: Array<{ __typename?: 'ExternalSource', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type CrfDocumentDataFragment = { __typename?: 'CrfDocument', id: string, fileName: string, active: boolean, createdBy: string, createdDate: string };

export type DataCollectionTemplateDataFragment = { __typename?: 'DataCollectionTemplate', id: string, name: string, description: string, fileName?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, reportingOrganization: { __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }, notificationReceivers: Array<{ __typename?: 'ApplicationUser', id: string }> };

export type DataCollectionDocumentDataFragment = { __typename?: 'DataCollectionDocument', id: string, name: string, fileName: string, description?: string | null | undefined, year: number, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, accessOrganizations: Array<{ __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type ExternalApplicationDataFragment = { __typename?: 'ExternalApplication', id: string, applicationUrl: string, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type ExternalSourceDataFragment = { __typename?: 'ExternalSource', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type GhgCategoryDataFragment = { __typename?: 'GhgCategory', id: string, code: string, orderIndex: number, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type GhgSectorDataFragment = { __typename?: 'GhgSector', id: string, code: string, orderIndex: number, specialSector: boolean, usableInProjections: boolean, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, parentSector?: { __typename?: 'GhgSector', id: string } | null | undefined };

export type GhgValueDataFragment = { __typename?: 'GhgValue', id: string, year: number, value: number, category: { __typename?: 'GhgCategory', id: string }, sector: { __typename?: 'GhgSector', id: string } };

export type GhgValueRangeDataFragment = { __typename?: 'GhgValueRange', minYear?: number | null | undefined, maxYear?: number | null | undefined };

export type InfoDocumentDataFragment = { __typename?: 'InfoDocument', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type NdcTargetDataFragment = { __typename?: 'NdcTarget', id: string, code: string, orderIndex: number, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, ghgSector?: { __typename?: 'GhgSector', id: string } | null | undefined };

export type NdcTargetValueDataFragment = { __typename?: 'NdcTargetValue', id: string, year: number, value: number };

export type OrganizationDataFragment = { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> };

export type PamDataFragment = { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string }> | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string } | null | undefined };

export type PamEmissionReductionDataFragment = { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined };

export type ProjectionDocumentDataFragment = { __typename?: 'ProjectionDocument', id: string, fileName: string, active: boolean, createdBy: string, createdDate: string };

export type ProjectionValueDataFragment = { __typename?: 'ProjectionValue', id: string, year: number, value: number, scenario: { __typename?: 'Scenario', id: string }, sector: { __typename?: 'GhgSector', id: string } };

export type PublicExternalSourceDataFragment = { __typename?: 'ExternalSource', id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type PublicInfoDocumentDataFragment = { __typename?: 'InfoDocument', id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type ScenarioDataFragment = { __typename?: 'Scenario', id: string, code: string, orderIndex: number, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type SharedDocumentDataFragment = { __typename?: 'SharedDocument', id: string, fileName: string, year: number, visibleByAllOrganizations: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, name: string, description: string, organization: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } };

export type TranslatedTextDataFragment = { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } };

export type TranslationItemDataFragment = { __typename?: 'TranslatedItem', id: string, translationKey: TranslationKey, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> };

export type UserDataFragment = { __typename?: 'ApplicationUser', id: string, displayName?: string | null | undefined, username: string, email: string, enabled: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, organization?: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } | null | undefined };

export type UserGroupDataFragment = { __typename?: 'UserGroup', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined };

export type GhgCategoriesQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type GhgCategoriesQuery = { __typename?: 'Query', ghgCategories: Array<{ __typename?: 'GhgCategory', id: string, code: string, orderIndex: number, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type GhgSectorsQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type GhgSectorsQuery = { __typename?: 'Query', ghgSectors: Array<{ __typename?: 'GhgSector', id: string, code: string, orderIndex: number, specialSector: boolean, usableInProjections: boolean, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, parentSector?: { __typename?: 'GhgSector', id: string } | null | undefined }> };

export type GhgValueRangeQueryVariables = Exact<{ [key: string]: never; }>;


export type GhgValueRangeQuery = { __typename?: 'Query', ghgValueRange?: { __typename?: 'GhgValueRange', minYear?: number | null | undefined, maxYear?: number | null | undefined } | null | undefined };

export type GhgValuesQueryVariables = Exact<{
  filter?: Maybe<GhgValueFilter>;
}>;


export type GhgValuesQuery = { __typename?: 'Query', ghgValues: Array<{ __typename?: 'GhgValue', id: string, year: number, value: number, category: { __typename?: 'GhgCategory', id: string }, sector: { __typename?: 'GhgSector', id: string } }> };

export type IndicatorDataViewerQueryVariables = Exact<{
  filter?: Maybe<IndicatorsFilterDto>;
  valueFilter?: Maybe<IndicatorDatasetValuesFilterDto>;
}>;


export type IndicatorDataViewerQuery = { __typename?: 'Query', indicators: Array<{ __typename?: 'Indicator', id: string, number?: number | null | undefined, name: string, datasets: Array<{ __typename?: 'IndicatorDataset', id: string, code?: string | null | undefined, name: string, numeratorDenominator?: string | null | undefined, guidanceDefinitions?: string | null | undefined, additionalRemarks?: string | null | undefined, comments?: string | null | undefined, crfSourceSector?: { __typename?: 'GhgSector', id: string } | null | undefined, crfSourceCategory?: { __typename?: 'GhgCategory', id: string } | null | undefined, values: Array<{ __typename?: 'IndicatorDatasetValue', id: string, year: number, value: number }> }> }> };

export type IndicatorDatasetQueryVariables = Exact<{
  id: Scalars['ID'];
  valueFilter?: Maybe<IndicatorDatasetValuesFilterDto>;
}>;


export type IndicatorDatasetQuery = { __typename?: 'Query', dataset: { __typename?: 'IndicatorDataset', id: string, code?: string | null | undefined, name: string, numeratorDenominator?: string | null | undefined, indicator: { __typename?: 'Indicator', id: string, number?: number | null | undefined, name: string }, values: Array<{ __typename?: 'IndicatorDatasetValue', id: string, year: number, value: number }> } };

export type IndicatorListQueryVariables = Exact<{
  filter?: Maybe<IndicatorsFilterDto>;
}>;


export type IndicatorListQuery = { __typename?: 'Query', indicators: Array<{ __typename?: 'Indicator', id: string, number?: number | null | undefined, name: string, category: IndicatorCategory, datasets: Array<{ __typename?: 'IndicatorDataset', id: string, code?: string | null | undefined, name: string, numeratorDenominator?: string | null | undefined, crfSourceSector?: { __typename?: 'GhgSector', id: string } | null | undefined, crfSourceCategory?: { __typename?: 'GhgCategory', id: string } | null | undefined }> }> };

export type InfoDocumentsQueryVariables = Exact<{
  scope: InfoDocumentScope;
  language: Scalars['String'];
}>;


export type InfoDocumentsQuery = { __typename?: 'Query', infoDocuments: Array<{ __typename?: 'InfoDocument', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type IntroductionTextQueryVariables = Exact<{ [key: string]: never; }>;


export type IntroductionTextQuery = { __typename?: 'Query', headerTranslation: { __typename?: 'TranslatedItem', id: string, translationKey: TranslationKey, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> }, textTranslation: { __typename?: 'TranslatedItem', id: string, translationKey: TranslationKey, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } };

export type MeasureDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MeasureDetailsQuery = { __typename?: 'Query', measure: { __typename?: 'Measure', id: string, reportingInMrv: string, name: string, objective: string, description: string, territorialCoverage: TerritorialCoverage, measureType: MeasureType, lifetimeStart: string, lifetimeEnd: string, legalAndPolicyBasis?: string | null | undefined, implementationPhases?: string | null | undefined, problemsAndBarriers?: string | null | undefined, expectedImprovements?: string | null | undefined, achievedResults?: string | null | undefined, responsibilityFor?: Responsibility | null | undefined, publicConsultationProcess?: string | null | undefined, totalExpectedInvestmentRsd?: number | null | undefined, totalExpectedInvestmentUsd?: number | null | undefined, expectedSourceOfFunding?: string | null | undefined, linkToOtherMeasures?: string | null | undefined, indicators?: string | null | undefined, linkz?: string | null | undefined, extensionOfMeasure?: string | null | undefined, otherBenefits?: string | null | undefined, impactOnGhgEmissions?: string | null | undefined, lossesAndDamages?: string | null | undefined, extremeEvents?: string | null | undefined, climateChangeImpacts?: Array<ClimateChangeImpactState> | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined } };

export type MeasurePeriodDataDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MeasurePeriodDataDetailsQuery = { __typename?: 'Query', measurePeriodData: { __typename?: 'MeasurePeriodData', id: string, status: MeasureStatus, sourceOfFunding?: SourceOfFunding | null | undefined, realized: boolean, investmentRsd?: number | null | undefined, investmentUsd?: number | null | undefined, measure: { __typename?: 'Measure', id: string }, reportingPeriod: { __typename?: 'ReportingPeriod', id: string, name: string } } };

export type MeasureStatisticsQueryVariables = Exact<{
  onlyApproved?: Maybe<Scalars['Boolean']>;
}>;


export type MeasureStatisticsQuery = { __typename?: 'Query', measureStatistics: { __typename?: 'MeasureStatistics', totalAmount: number, amountPerTerritorialCoverage: Array<{ __typename?: 'MeasureStatisticsPerTerritorialCoverage', territorialCoverage: TerritorialCoverage, amount: number }> } };

export type MeasuresListQueryVariables = Exact<{
  filter?: Maybe<MeasuresQueryFilter>;
}>;


export type MeasuresListQuery = { __typename?: 'Query', measures: Array<{ __typename?: 'Measure', id: string, name: string, lifetimeStart: string, lifetimeEnd: string, measureType: MeasureType, totalExpectedInvestmentRsd?: number | null | undefined, totalExpectedInvestmentUsd?: number | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, reportingPeriods: Array<{ __typename?: 'ReportingPeriod', id: string, name: string, startYear: number, endYear: number }>, periodData?: Array<{ __typename?: 'MeasurePeriodData', id: string, investmentRsd?: number | null | undefined, investmentUsd?: number | null | undefined, reportingPeriod: { __typename?: 'ReportingPeriod', id: string, name: string, startYear: number, endYear: number } }> | null | undefined }> };

export type ModuleVisibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type ModuleVisibilityQuery = { __typename?: 'Query', moduleVisibilities: Array<{ __typename?: 'ModuleVisibility', id: string, scope: ModuleScope, parentScope?: ModuleScope | null | undefined, publiclyVisible: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined }> };

export type NdcChartQueryVariables = Exact<{
  sectorCode: Scalars['String'];
  targetFilter?: Maybe<NdcTargetFilter>;
  language: Scalars['String'];
}>;


export type NdcChartQuery = { __typename?: 'Query', ghgSectorByCode?: { __typename?: 'GhgSector', id: string, code: string, orderIndex: number, specialSector: boolean, usableInProjections: boolean, values: Array<{ __typename?: 'GhgValue', id: string, year: number, value: number, category: { __typename?: 'GhgCategory', id: string }, sector: { __typename?: 'GhgSector', id: string } }>, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, parentSector?: { __typename?: 'GhgSector', id: string } | null | undefined } | null | undefined, ndcTargets: Array<{ __typename?: 'NdcTarget', id: string, code: string, orderIndex: number, targetValues: Array<{ __typename?: 'NdcTargetValue', id: string, year: number, value: number }>, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, ghgSector?: { __typename?: 'GhgSector', id: string } | null | undefined }>, scenarios: Array<{ __typename?: 'Scenario', id: string, code: string, orderIndex: number, values: Array<{ __typename?: 'ProjectionValue', id: string, year: number, value: number, scenario: { __typename?: 'Scenario', id: string }, sector: { __typename?: 'GhgSector', id: string } }>, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type NdcTargetsQueryVariables = Exact<{
  language: Scalars['String'];
  filter?: Maybe<NdcTargetFilter>;
}>;


export type NdcTargetsQuery = { __typename?: 'Query', ndcTargets: Array<{ __typename?: 'NdcTarget', id: string, code: string, orderIndex: number, ghgSector?: { __typename?: 'GhgSector', id: string, code: string, orderIndex: number, specialSector: boolean, usableInProjections: boolean, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, parentSector?: { __typename?: 'GhgSector', id: string } | null | undefined } | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type NdcTargetsWithValuesQueryVariables = Exact<{
  language: Scalars['String'];
  filter?: Maybe<NdcTargetFilter>;
}>;


export type NdcTargetsWithValuesQuery = { __typename?: 'Query', ndcTargets: Array<{ __typename?: 'NdcTarget', id: string, code: string, orderIndex: number, targetValues: Array<{ __typename?: 'NdcTargetValue', id: string, year: number, value: number }>, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, ghgSector?: { __typename?: 'GhgSector', id: string } | null | undefined }> };

export type OrganizationsQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> }> };

export type PamDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PamDetailsQuery = { __typename?: 'Query', policyAndMeasure: { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string }> | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string } | null | undefined } };

export type PamListQueryVariables = Exact<{
  filter?: Maybe<PolicyMeasureFilter>;
}>;


export type PamListQuery = { __typename?: 'Query', policiesAndMeasures: Array<{ __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, shortDescription?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined }> };

export type PamObjectivesListQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type PamObjectivesListQuery = { __typename?: 'Query', pamObjectives: Array<{ __typename?: 'PamObjective', id: string, code?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type PamStatisticsQueryVariables = Exact<{
  onlyApproved?: Maybe<Scalars['Boolean']>;
}>;


export type PamStatisticsQuery = { __typename?: 'Query', pamStatistics: { __typename?: 'PolicyMeasureStatistics', totalAmount: number, amountPerStatus: Array<{ __typename?: 'PolicyMeasureStatisticsPerStatus', status: PolicyMeasureImplementationStatus, amount: number }> } };

export type PamUnionPoliciesListQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type PamUnionPoliciesListQuery = { __typename?: 'Query', pamUnionPolicies: Array<{ __typename?: 'PamUnionPolicy', id: string, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type ProjectionDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectionDocumentsQuery = { __typename?: 'Query', projectionDocuments: Array<{ __typename?: 'ProjectionDocument', id: string, fileName: string, active: boolean, createdBy: string, createdDate: string }> };

export type ProjectionValuesQueryVariables = Exact<{
  filter?: Maybe<ProjectionValueFilter>;
}>;


export type ProjectionValuesQuery = { __typename?: 'Query', projectionValues: Array<{ __typename?: 'ProjectionValue', id: string, year: number, value: number, scenario: { __typename?: 'Scenario', id: string }, sector: { __typename?: 'GhgSector', id: string } }> };

export type PublicAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicAvailabilityQuery = { __typename?: 'Query', publicAvailability: { __typename?: 'PublicAvailability', externalSources: Array<{ __typename?: 'PublicExternalSourceAvailability', scope: ExternalSourceScope, available: boolean }>, infoDocuments: Array<{ __typename?: 'PublicInfoDocumentAvailability', scope: InfoDocumentScope, available: boolean }>, modules: Array<{ __typename?: 'PublicModuleAvailability', scope: ModuleScope, available: boolean }> } };

export type PublicExternalSourcesQueryVariables = Exact<{
  scope: ExternalSourceScope;
  language: Scalars['String'];
}>;


export type PublicExternalSourcesQuery = { __typename?: 'Query', publicExternalSources: Array<{ __typename?: 'ExternalSource', id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type PublicInfoDocumentsQueryVariables = Exact<{
  scope: InfoDocumentScope;
  language: Scalars['String'];
}>;


export type PublicInfoDocumentsQuery = { __typename?: 'Query', publicInfoDocuments: Array<{ __typename?: 'InfoDocument', id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type PublicPamDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  language: Scalars['String'];
}>;


export type PublicPamDetailsQuery = { __typename?: 'Query', policyAndMeasure: { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined } };

export type RefuseArticle9SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseArticle9SupportNeededMutation = { __typename?: 'Mutation', refuseArticle9SupportNeeded: { __typename?: 'Article9SupportNeeded', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefuseArticle9SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseArticle9SupportReceivedMutation = { __typename?: 'Mutation', refuseArticle9SupportReceived: { __typename?: 'Article9SupportReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefuseArticle10SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseArticle10SupportNeededMutation = { __typename?: 'Mutation', refuseArticle10SupportNeeded: { __typename?: 'Article10SupportNeeded', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefuseArticle10SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseArticle10SupportReceivedMutation = { __typename?: 'Mutation', refuseArticle10SupportReceived: { __typename?: 'Article10SupportReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefuseArticle11SupportNeededMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseArticle11SupportNeededMutation = { __typename?: 'Mutation', refuseArticle11SupportNeeded: { __typename?: 'Article11SupportNeeded', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefuseArticle11SupportReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseArticle11SupportReceivedMutation = { __typename?: 'Mutation', refuseArticle11SupportReceived: { __typename?: 'Article11SupportReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefuseArticle13SupportNeededReceivedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseArticle13SupportNeededReceivedMutation = { __typename?: 'Mutation', refuseArticle13SupportNeededReceived: { __typename?: 'Article13SupportNeededReceived', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefuseDataCollectionDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseDataCollectionDocumentMutation = { __typename?: 'Mutation', refuseDataCollectionDocument: { __typename?: 'DataCollectionDocument', id: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined } };

export type RefuseMeasureMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefuseMeasureMutation = { __typename?: 'Mutation', refuseMeasure: { __typename?: 'Measure', id: string, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type RefusePolicyAndMeasureMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefusePolicyAndMeasureMutation = { __typename?: 'Mutation', refusePolicyAndMeasure: { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string }> | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string } | null | undefined } };

export type ResetPasswordMutationVariables = Exact<{
  username: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type ScenarioChartQueryVariables = Exact<{
  scenarioId: Scalars['ID'];
  language: Scalars['String'];
}>;


export type ScenarioChartQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, code: string, orderIndex: number, values: Array<{ __typename?: 'ProjectionValue', id: string, year: number, value: number, scenario: { __typename?: 'Scenario', id: string }, sector: { __typename?: 'GhgSector', id: string } }>, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } | null | undefined, ghgSectors: Array<{ __typename?: 'GhgSector', id: string, code: string, orderIndex: number, specialSector: boolean, usableInProjections: boolean, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, parentSector?: { __typename?: 'GhgSector', id: string } | null | undefined }> };

export type ScenariosQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type ScenariosQuery = { __typename?: 'Query', scenarios: Array<{ __typename?: 'Scenario', id: string, code: string, orderIndex: number, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type SetDataCollectionYearLockMutationVariables = Exact<{
  year: Scalars['Int'];
  locked: Scalars['Boolean'];
}>;


export type SetDataCollectionYearLockMutation = { __typename?: 'Mutation', setDataCollectionYearLock: { __typename?: 'DataCollectionYear', id: string, year: number, yearLocked: boolean, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type SharedDocumentsQueryVariables = Exact<{
  scope: SharedDocumentScope;
  year?: Maybe<Scalars['Int']>;
  language: Scalars['String'];
}>;


export type SharedDocumentsQuery = { __typename?: 'Query', sharedDocuments: Array<{ __typename?: 'SharedDocument', id: string, fileName: string, year: number, visibleByAllOrganizations: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, name: string, description: string, organization: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } }> };

export type SustainableDevelopmentGoalsListQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type SustainableDevelopmentGoalsListQuery = { __typename?: 'Query', sustainableDevelopmentGoals: Array<{ __typename?: 'SustainableDevelopmentGoal', id: string, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type TranslatedTextQueryVariables = Exact<{
  translationKey: TranslationKey;
  language: Scalars['String'];
}>;


export type TranslatedTextQuery = { __typename?: 'Query', translation: { __typename?: 'TranslatedItem', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string } | null | undefined } };

export type TranslationQueryVariables = Exact<{
  translationKey: TranslationKey;
}>;


export type TranslationQuery = { __typename?: 'Query', translation: { __typename?: 'TranslatedItem', id: string, translationKey: TranslationKey, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } };

export type UpdateArticle10NeededMutationVariables = Exact<{
  dto: UpdateArticle10SupportNeeded;
}>;


export type UpdateArticle10NeededMutation = { __typename?: 'Mutation', updateArticle10SupportNeeded: { __typename?: 'Article10SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article10SupportReceived', id: string }> } };

export type UpdateArticle10ReceivedMutationVariables = Exact<{
  dto: UpdateArticle10SupportReceived;
}>;


export type UpdateArticle10ReceivedMutation = { __typename?: 'Mutation', updateArticle10SupportReceived: { __typename?: 'Article10SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article10SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } } };

export type UpdateArticle11NeededMutationVariables = Exact<{
  dto: UpdateArticle11SupportNeeded;
}>;


export type UpdateArticle11NeededMutation = { __typename?: 'Mutation', updateArticle11SupportNeeded: { __typename?: 'Article11SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, supportType?: SupportType | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article11SupportReceived', id: string }> } };

export type UpdateArticle11ReceivedMutationVariables = Exact<{
  dto: UpdateArticle11SupportReceived;
}>;


export type UpdateArticle11ReceivedMutation = { __typename?: 'Mutation', updateArticle11SupportReceived: { __typename?: 'Article11SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article11SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } } };

export type UpdateArticle13NeededReceivedMutationVariables = Exact<{
  dto: UpdateArticle13SupportNeededReceived;
}>;


export type UpdateArticle13NeededReceivedMutation = { __typename?: 'Mutation', updateArticle13SupportNeededReceived: { __typename?: 'Article13SupportNeededReceived', id: string, recipientEntity?: string | null | undefined, channel?: string | null | undefined, amountRsd: number, amountUsd: number, timeframeStart: number, timeframeEnd: number, statusOfActivity?: ActivityStatus | null | undefined, useImpactAndEstimatedResults?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } };

export type UpdateArticle9NeededMutationVariables = Exact<{
  dto: UpdateArticle9SupportNeeded;
}>;


export type UpdateArticle9NeededMutation = { __typename?: 'Mutation', updateArticle9SupportNeeded: { __typename?: 'Article9SupportNeeded', id: string, expectedTimeframeStart: number, expectedTimeframeEnd: number, expectedUseImpactAndEstimatedResults?: string | null | undefined, supportType?: SupportType | null | undefined, expectedFinancialInstrument?: FinancialInstrument | null | undefined, estimatedAmountRsd: number, estimatedAmountUsd: number, sector?: string | null | undefined, activityContribution?: string | null | undefined, activityAnchored?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined }, supportReceived: Array<{ __typename?: 'Article9SupportReceived', id: string }> } };

export type UpdateArticle9ReceivedMutationVariables = Exact<{
  dto: UpdateArticle9SupportReceived;
}>;


export type UpdateArticle9ReceivedMutation = { __typename?: 'Mutation', updateArticle9SupportReceived: { __typename?: 'Article9SupportReceived', id: string, timeframeStart: number, timeframeEnd: number, sector?: string | null | undefined, supportType?: SupportType | null | undefined, statusOfActivity?: ActivityStatus | null | undefined, channel?: string | null | undefined, amountRsd: number, amountUsd: number, financialInstrument?: FinancialInstrument | null | undefined, activityContribution?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, description?: string | null | undefined, supportNeeded: { __typename?: 'Article9SupportNeeded', id: string, project: { __typename?: 'CfProject', id: string, title: string, description?: string | null | undefined } } } };

export type UpdateDataCollectionTemplateMutationVariables = Exact<{
  documentId: Scalars['ID'];
  dto: UpdateDataCollectionTemplate;
  language: Scalars['String'];
}>;


export type UpdateDataCollectionTemplateMutation = { __typename?: 'Mutation', updateDataCollectionTemplate: { __typename?: 'DataCollectionTemplate', id: string, name: string, description: string, fileName?: string | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, reportingOrganization: { __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }, notificationReceivers: Array<{ __typename?: 'ApplicationUser', id: string }> } };

export type UpdateDataCollectionDocumentAccessMutationVariables = Exact<{
  id: Scalars['ID'];
  organizations: Array<Scalars['ID']> | Scalars['ID'];
  language: Scalars['String'];
}>;


export type UpdateDataCollectionDocumentAccessMutation = { __typename?: 'Mutation', updateDataCollectionDocumentAccess: { __typename?: 'DataCollectionDocument', id: string, name: string, fileName: string, description?: string | null | undefined, year: number, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, accessOrganizations: Array<{ __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> } };

export type UpdateDataCollectionDocumentContentMutationVariables = Exact<{
  documentId: Scalars['ID'];
  dto: UpdateDataCollectionDocumentContent;
  language: Scalars['String'];
}>;


export type UpdateDataCollectionDocumentContentMutation = { __typename?: 'Mutation', updateDataCollectionDocumentContent: { __typename?: 'DataCollectionDocument', id: string, name: string, fileName: string, description?: string | null | undefined, year: number, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, accessOrganizations: Array<{ __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> } };

export type UpdateDataCollectionDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
  dto: UpdateDataCollectionDocument;
  language: Scalars['String'];
}>;


export type UpdateDataCollectionDocumentMutation = { __typename?: 'Mutation', updateDataCollectionDocument: { __typename?: 'DataCollectionDocument', id: string, name: string, fileName: string, description?: string | null | undefined, year: number, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, accessOrganizations: Array<{ __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> } };

export type UpdateExternalApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
  dto: UpdateExternalApplication;
  language: Scalars['String'];
}>;


export type UpdateExternalApplicationMutation = { __typename?: 'Mutation', updateExternalApplication: { __typename?: 'ExternalApplication', id: string, applicationUrl: string, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type UpdateExternalSourceMutationVariables = Exact<{
  sourceId: Scalars['ID'];
  dto: UpdateExternalSource;
  language: Scalars['String'];
}>;


export type UpdateExternalSourceMutation = { __typename?: 'Mutation', updateExternalSource: { __typename?: 'ExternalSource', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, sourceUrl: string, active: boolean, primarySource: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type UpdateIndicatorMutationVariables = Exact<{
  id: Scalars['ID'];
  dto: UpdateIndicator;
}>;


export type UpdateIndicatorMutation = { __typename?: 'Mutation', updateIndicator: { __typename?: 'Indicator', id: string, number?: number | null | undefined, name: string, datasets: Array<{ __typename?: 'IndicatorDataset', id: string, code?: string | null | undefined, name: string, numeratorDenominator?: string | null | undefined, guidanceDefinitions?: string | null | undefined, additionalRemarks?: string | null | undefined, comments?: string | null | undefined }> } };

export type UpdateIndicatorValueMutationVariables = Exact<{
  values: Array<UpdateIndicatorDatasetValue> | UpdateIndicatorDatasetValue;
}>;


export type UpdateIndicatorValueMutation = { __typename?: 'Mutation', updateIndicatorValues: Array<{ __typename?: 'IndicatorDatasetValue', id: string, year: number, value: number }> };

export type UpdateInfoDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
  dto: UpdateInfoDocument;
  language: Scalars['String'];
}>;


export type UpdateInfoDocumentMutation = { __typename?: 'Mutation', updateInfoDocument: { __typename?: 'InfoDocument', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type UpdateIntroductionTextMutationVariables = Exact<{
  headerDto: UpdateTranslation;
  textDto: UpdateTranslation;
}>;


export type UpdateIntroductionTextMutation = { __typename?: 'Mutation', headerTranslation: { __typename?: 'TranslatedItem', id: string, translationKey: TranslationKey, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> }, textTranslation: { __typename?: 'TranslatedItem', id: string, translationKey: TranslationKey, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } };

export type UpdateMeasureMutationVariables = Exact<{
  dto: UpdateMeasure;
}>;


export type UpdateMeasureMutation = { __typename?: 'Mutation', updateMeasure: { __typename?: 'Measure', id: string, reportingInMrv: string, name: string, objective: string, description: string, territorialCoverage: TerritorialCoverage, measureType: MeasureType, lifetimeStart: string, lifetimeEnd: string, legalAndPolicyBasis?: string | null | undefined, implementationPhases?: string | null | undefined, problemsAndBarriers?: string | null | undefined, expectedImprovements?: string | null | undefined, achievedResults?: string | null | undefined, responsibilityFor?: Responsibility | null | undefined, publicConsultationProcess?: string | null | undefined, totalExpectedInvestmentRsd?: number | null | undefined, totalExpectedInvestmentUsd?: number | null | undefined, expectedSourceOfFunding?: string | null | undefined, linkToOtherMeasures?: string | null | undefined, indicators?: string | null | undefined, linkz?: string | null | undefined, extensionOfMeasure?: string | null | undefined, otherBenefits?: string | null | undefined, impactOnGhgEmissions?: string | null | undefined, lossesAndDamages?: string | null | undefined, extremeEvents?: string | null | undefined, climateChangeImpacts?: Array<ClimateChangeImpactState> | null | undefined, ndcRelevant?: boolean | null | undefined, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, reportingPeriods: Array<{ __typename?: 'ReportingPeriod', id: string, name: string, startYear: number, endYear: number }>, periodData?: Array<{ __typename?: 'MeasurePeriodData', reportingPeriod: { __typename?: 'ReportingPeriod', id: string } }> | null | undefined } };

export type UpdateMeasureNcRelevancyMutationVariables = Exact<{
  id: Scalars['ID'];
  ncRelevant: Scalars['Boolean'];
}>;


export type UpdateMeasureNcRelevancyMutation = { __typename?: 'Mutation', updateMeasureNcRelevancy: { __typename?: 'Measure', id: string, ncRelevant?: boolean | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type UpdateMeasureNdcRelevancyMutationVariables = Exact<{
  id: Scalars['ID'];
  ndcRelevant: Scalars['Boolean'];
}>;


export type UpdateMeasureNdcRelevancyMutation = { __typename?: 'Mutation', updateMeasureNdcRelevancy: { __typename?: 'Measure', id: string, ndcRelevant?: boolean | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined } };

export type UpdateMeasurePeriodDataMutationVariables = Exact<{
  dto: UpdateMeasurePeriodData;
}>;


export type UpdateMeasurePeriodDataMutation = { __typename?: 'Mutation', updateMeasurePeriodData: { __typename?: 'MeasurePeriodData', id: string, status: MeasureStatus, sourceOfFunding?: SourceOfFunding | null | undefined, realized: boolean, investmentRsd?: number | null | undefined, investmentUsd?: number | null | undefined, measure: { __typename?: 'Measure', id: string }, reportingPeriod: { __typename?: 'ReportingPeriod', id: string, name: string } } };

export type UpdateModuleVisibilityMutationVariables = Exact<{
  dto: UpdateModuleVisibility;
}>;


export type UpdateModuleVisibilityMutation = { __typename?: 'Mutation', updateModuleVisibility: Array<{ __typename?: 'ModuleVisibility', id: string, scope: ModuleScope, publiclyVisible: boolean, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined }> };

export type UpdateNdcTargetsMutationVariables = Exact<{
  dtos: Array<UpdateNdcTarget> | UpdateNdcTarget;
  language: Scalars['String'];
}>;


export type UpdateNdcTargetsMutation = { __typename?: 'Mutation', updateNdcTargets: Array<{ __typename?: 'NdcTarget', id: string, code: string, orderIndex: number, targetValues: Array<{ __typename?: 'NdcTargetValue', id: string, year: number, value: number }>, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, ghgSector?: { __typename?: 'GhgSector', id: string } | null | undefined }> };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
  dto: UpdateOrganization;
  language: Scalars['String'];
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } };

export type UpdatePamMutationVariables = Exact<{
  id: Scalars['ID'];
  dto: UpdatePolicyMeasure;
}>;


export type UpdatePamMutation = { __typename?: 'Mutation', updatePolicyAndMeasure: { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string }> | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string } | null | undefined } };

export type UpdatePamNcRelevancyMutationVariables = Exact<{
  id: Scalars['ID'];
  ncRelevant: Scalars['Boolean'];
}>;


export type UpdatePamNcRelevancyMutation = { __typename?: 'Mutation', updatePolicyAndMeasureNcRelevancy: { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string }> | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string } | null | undefined } };

export type UpdatePamNdcRelevancyMutationVariables = Exact<{
  id: Scalars['ID'];
  ndcRelevant: Scalars['Boolean'];
}>;


export type UpdatePamNdcRelevancyMutation = { __typename?: 'Mutation', updatePolicyAndMeasureNdcRelevancy: { __typename?: 'PolicyMeasure', id: string, pamNumber: number, name: string, localName?: string | null | undefined, pamType?: PolicyMeasureType | null | undefined, policiesOrMeasureCoverage?: string | null | undefined, shortDescription?: string | null | undefined, geographicalCoverage?: PolicyMeasureGeographicalCoverage | null | undefined, affectedSectors?: Array<PolicyMeasureSectors> | null | undefined, affectedGhgGases?: Array<PolicyMeasureGhgGas> | null | undefined, quantifiedObjective?: string | null | undefined, article15ContributionAssessment?: string | null | undefined, policyInstrumentType?: Array<PolicyMeasureInstrument> | null | undefined, relatedToUnionPolicy?: boolean | null | undefined, relatedSerbianPolicy?: string | null | undefined, implementationStatus?: PolicyMeasureImplementationStatus | null | undefined, implementationPeriodStart?: number | null | undefined, implementationPeriodEnd?: number | null | undefined, implementationStatusDetails?: string | null | undefined, includingProjectionsScenario?: PolicyMeasureProjectionScenario | null | undefined, implementationResponsibleEntityType?: PolicyMeasureResponsibleEntityType | null | undefined, implementationResponsibleEntityName?: string | null | undefined, responsibilityDetails?: string | null | undefined, indicatorsDescription?: string | null | undefined, generalComments?: string | null | undefined, policyImpactType?: Array<PolicyMeasureImpactType> | null | undefined, interactsWithOtherPoliciesAndMeasures?: boolean | null | undefined, interactionWithOtherPoliciesAndMeasuresDescription?: string | null | undefined, genderEqualityImpact?: string | null | undefined, additionalComment?: string | null | undefined, informationSourceName?: string | null | undefined, informationAccess?: PolicyMeasureInformationAccess | null | undefined, neededImprovements?: string | null | undefined, createdDate: string, createdBy: string, lastModifiedDate?: string | null | undefined, lastModifiedBy?: string | null | undefined, ndcRelevant?: boolean | null | undefined, ncRelevant?: boolean | null | undefined, approvedBy?: string | null | undefined, approvedDate?: string | null | undefined, objectives?: Array<{ __typename?: 'PamObjective', id: string }> | null | undefined, relatedUnionPolicy?: Array<{ __typename?: 'PamUnionPolicy', id: string }> | null | undefined, indicatorValues?: Array<{ __typename?: 'PolicyMeasureIndicator', id: string, year: number, value: number }> | null | undefined, assesmentsAndTechnicalReports?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined, exAnteAssessment?: { __typename?: 'PolicyMeasureExAnteAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: Array<{ __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined }> | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, exPostAssessment?: { __typename?: 'PolicyMeasureExPostAssessment', id: string, mitigationEstimateBasisExplanation?: string | null | undefined, affectedFactors?: string | null | undefined, ghgEmissionsReduction?: { __typename?: 'PolicyMeasureGhgEmissionsReduction', id: string, yearOffset: number, euEts?: number | null | undefined, esr?: number | null | undefined, lulucf?: number | null | undefined, total?: number | null | undefined } | null | undefined, documentationOfEstimation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, projectedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, realizedCostsAndBenefits?: { __typename?: 'PolicyMeasureCostsAndBenefits', id: string, calculatedYears?: string | null | undefined, grossCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteGrossCostsPerYearEur?: number | null | undefined, benefitsEurPerTonCO2eReduced?: number | null | undefined, absoluteBenefitPerYearEur?: number | null | undefined, netCostsEurPerTonCO2eReduced?: number | null | undefined, absoluteNetCostsPerYearEur?: number | null | undefined, priceYear?: number | null | undefined, costEstimatesDescription?: string | null | undefined, nonGhgMitigationBenefitsDescription?: string | null | undefined, estimationSourceDocumentation?: { __typename?: 'PolicyMeasureExternalReference', id: string, referenceName?: string | null | undefined, referenceUrl?: string | null | undefined } | null | undefined } | null | undefined, sdgImpact?: { __typename?: 'SustainableDevelopmentGoal', id: string } | null | undefined } };

export type UpdateSharedDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
  dto: UpdateSharedDocument;
  language: Scalars['String'];
}>;


export type UpdateSharedDocumentMutation = { __typename?: 'Mutation', updateSharedDocument: { __typename?: 'SharedDocument', id: string, fileName: string, year: number, visibleByAllOrganizations: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, name: string, description: string, organization: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } } };

export type UpdateTranslationMutationVariables = Exact<{
  dto: UpdateTranslation;
}>;


export type UpdateTranslationMutation = { __typename?: 'Mutation', updateTranslation: { __typename?: 'TranslatedItem', id: string, translationKey: TranslationKey, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  dto: UpdateUser;
  language: Scalars['String'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'ApplicationUser', id: string, displayName?: string | null | undefined, username: string, email: string, enabled: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, groupMemberships: Array<{ __typename?: 'UserGroup', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }>, organization?: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } | null | undefined } };

export type UpdateUserStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  language: Scalars['String'];
}>;


export type UpdateUserStatusMutation = { __typename?: 'Mutation', updateUserStatus: { __typename?: 'ApplicationUser', id: string, displayName?: string | null | undefined, username: string, email: string, enabled: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, organization?: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } | null | undefined } };

export type UploadCrfDocumentMutationVariables = Exact<{
  dto: SimpleFileUpload;
}>;


export type UploadCrfDocumentMutation = { __typename?: 'Mutation', uploadCrfDocument: { __typename?: 'CrfDocument', id: string, fileName: string, active: boolean, createdBy: string, createdDate: string } };

export type CreateDataCollectionTemplateMutationVariables = Exact<{
  dto: CreateDataCollectionTemplate;
}>;


export type CreateDataCollectionTemplateMutation = { __typename?: 'Mutation', createDataCollectionTemplate: { __typename?: 'DataCollectionTemplate', id: string } };

export type CreateDataCollectionDocumentMutationVariables = Exact<{
  dto: CreateDataCollectionDocument;
}>;


export type CreateDataCollectionDocumentMutation = { __typename?: 'Mutation', createDataCollectionDocument: { __typename?: 'DataCollectionDocument', id: string } };

export type UploadInfoDocumentMutationVariables = Exact<{
  dto: CreateInfoDocument;
  language: Scalars['String'];
}>;


export type UploadInfoDocumentMutation = { __typename?: 'Mutation', uploadInfoDocument: { __typename?: 'InfoDocument', deletedDate?: string | null | undefined, deletedBy?: string | null | undefined, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, id: string, fileName: string, active: boolean, primaryDocument: boolean, createdBy: string, createdDate: string, nameTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, descriptionTranslations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }>, preferredNameTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, preferredDescriptionTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } };

export type UploadProjectionDocumentMutationVariables = Exact<{
  dto: SimpleFileUpload;
}>;


export type UploadProjectionDocumentMutation = { __typename?: 'Mutation', uploadProjectionDocument: { __typename?: 'ProjectionDocument', id: string, fileName: string, active: boolean, createdBy: string, createdDate: string } };

export type UploadSharedDocumentMutationVariables = Exact<{
  dto: CreateSharedDocument;
  language: Scalars['String'];
}>;


export type UploadSharedDocumentMutation = { __typename?: 'Mutation', uploadSharedDocument: { __typename?: 'SharedDocument', id: string, fileName: string, year: number, visibleByAllOrganizations: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, name: string, description: string, organization: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } } };

export type UserGroupsQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type UserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }> };

export type UserDetailsQueryVariables = Exact<{
  username: Scalars['String'];
  language: Scalars['String'];
}>;


export type UserDetailsQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'ApplicationUser', id: string, email: string, displayName?: string | null | undefined, organization?: { __typename?: 'Organization', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined } | null | undefined } | null | undefined };

export type UsersQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'ApplicationUser', id: string, displayName?: string | null | undefined, username: string, email: string, enabled: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, groupMemberships: Array<{ __typename?: 'UserGroup', id: string, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined }>, organization?: { __typename?: 'Organization', id: string, orderIndex: number, mainOrganization: boolean, createdBy: string, createdDate: string, lastModifiedBy?: string | null | undefined, lastModifiedDate?: string | null | undefined, preferredTranslation?: { __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } } | null | undefined, translations: Array<{ __typename?: 'TranslatedText', id: string, translation: string, language: { __typename?: 'Language', id: string, code: string } }> } | null | undefined }> };

export type VerifyTokenQueryVariables = Exact<{
  token: Scalars['ID'];
}>;


export type VerifyTokenQuery = { __typename?: 'Query', verifyToken: TokenStatus };

export const CrfDocumentDataFragmentDoc = gql`
    fragment CrfDocumentData on CrfDocument {
  id
  fileName
  active
  createdBy
  createdDate
}
    `;
export const TranslatedTextDataFragmentDoc = gql`
    fragment TranslatedTextData on TranslatedText {
  id
  language {
    id
    code
  }
  translation
}
    `;
export const DataCollectionTemplateDataFragmentDoc = gql`
    fragment DataCollectionTemplateData on DataCollectionTemplate {
  id
  name
  description
  reportingOrganization {
    id
    preferredTranslation(preferredLanguage: $language) {
      ...TranslatedTextData
    }
  }
  notificationReceivers {
    id
  }
  fileName
  createdBy
  createdDate
  lastModifiedBy
  lastModifiedDate
}
    ${TranslatedTextDataFragmentDoc}`;
export const DataCollectionDocumentDataFragmentDoc = gql`
    fragment DataCollectionDocumentData on DataCollectionDocument {
  id
  name
  fileName
  description
  year
  createdBy
  createdDate
  lastModifiedBy
  lastModifiedDate
  approvedBy
  approvedDate
  accessOrganizations {
    id
    preferredTranslation(preferredLanguage: $language) {
      ...TranslatedTextData
    }
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const ExternalApplicationDataFragmentDoc = gql`
    fragment ExternalApplicationData on ExternalApplication {
  id
  applicationUrl
  nameTranslations {
    ...TranslatedTextData
  }
  preferredNameTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
  createdBy
  createdDate
  lastModifiedBy
  lastModifiedDate
}
    ${TranslatedTextDataFragmentDoc}`;
export const PublicExternalSourceDataFragmentDoc = gql`
    fragment PublicExternalSourceData on ExternalSource {
  id
  sourceUrl
  active
  primarySource
  createdBy
  createdDate
  preferredNameTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
  preferredDescriptionTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const ExternalSourceDataFragmentDoc = gql`
    fragment ExternalSourceData on ExternalSource {
  ...PublicExternalSourceData
  deletedDate
  deletedBy
  lastModifiedBy
  lastModifiedDate
  nameTranslations {
    ...TranslatedTextData
  }
  descriptionTranslations {
    ...TranslatedTextData
  }
}
    ${PublicExternalSourceDataFragmentDoc}
${TranslatedTextDataFragmentDoc}`;
export const GhgCategoryDataFragmentDoc = gql`
    fragment GhgCategoryData on GhgCategory {
  id
  code
  orderIndex
  preferredTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const GhgSectorDataFragmentDoc = gql`
    fragment GhgSectorData on GhgSector {
  id
  code
  orderIndex
  specialSector
  usableInProjections
  preferredTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
  parentSector {
    id
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const GhgValueDataFragmentDoc = gql`
    fragment GhgValueData on GhgValue {
  id
  year
  value
  category {
    id
  }
  sector {
    id
  }
}
    `;
export const GhgValueRangeDataFragmentDoc = gql`
    fragment GhgValueRangeData on GhgValueRange {
  minYear
  maxYear
}
    `;
export const PublicInfoDocumentDataFragmentDoc = gql`
    fragment PublicInfoDocumentData on InfoDocument {
  id
  fileName
  active
  primaryDocument
  createdBy
  createdDate
  preferredNameTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
  preferredDescriptionTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const InfoDocumentDataFragmentDoc = gql`
    fragment InfoDocumentData on InfoDocument {
  ...PublicInfoDocumentData
  deletedDate
  deletedBy
  lastModifiedBy
  lastModifiedDate
  nameTranslations {
    ...TranslatedTextData
  }
  descriptionTranslations {
    ...TranslatedTextData
  }
}
    ${PublicInfoDocumentDataFragmentDoc}
${TranslatedTextDataFragmentDoc}`;
export const NdcTargetDataFragmentDoc = gql`
    fragment NdcTargetData on NdcTarget {
  id
  code
  orderIndex
  preferredTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
  ghgSector {
    id
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const NdcTargetValueDataFragmentDoc = gql`
    fragment NdcTargetValueData on NdcTargetValue {
  id
  year
  value
}
    `;
export const PamEmissionReductionDataFragmentDoc = gql`
    fragment PamEmissionReductionData on PolicyMeasureGhgEmissionsReduction {
  id
  yearOffset
  euEts
  esr
  lulucf
  total
}
    `;
export const PamDataFragmentDoc = gql`
    fragment PamData on PolicyMeasure {
  id
  pamNumber
  name
  localName
  pamType
  policiesOrMeasureCoverage
  shortDescription
  geographicalCoverage
  affectedSectors
  affectedGhgGases
  objectives {
    id
  }
  quantifiedObjective
  article15ContributionAssessment
  policyInstrumentType
  relatedToUnionPolicy
  relatedUnionPolicy {
    id
  }
  relatedSerbianPolicy
  implementationStatus
  implementationPeriodStart
  implementationPeriodEnd
  implementationStatusDetails
  includingProjectionsScenario
  implementationResponsibleEntityType
  implementationResponsibleEntityName
  responsibilityDetails
  indicatorsDescription
  indicatorValues {
    id
    year
    value
  }
  assesmentsAndTechnicalReports {
    id
    referenceName
    referenceUrl
  }
  generalComments
  policyImpactType
  exAnteAssessment {
    id
    ghgEmissionsReduction {
      ...PamEmissionReductionData
    }
    mitigationEstimateBasisExplanation
    affectedFactors
    documentationOfEstimation {
      id
      referenceName
      referenceUrl
    }
  }
  exPostAssessment {
    id
    ghgEmissionsReduction {
      ...PamEmissionReductionData
    }
    mitigationEstimateBasisExplanation
    affectedFactors
    documentationOfEstimation {
      id
      referenceName
      referenceUrl
    }
  }
  projectedCostsAndBenefits {
    id
    calculatedYears
    grossCostsEurPerTonCO2eReduced
    absoluteGrossCostsPerYearEur
    benefitsEurPerTonCO2eReduced
    absoluteBenefitPerYearEur
    netCostsEurPerTonCO2eReduced
    absoluteNetCostsPerYearEur
    priceYear
    costEstimatesDescription
    estimationSourceDocumentation {
      id
      referenceName
      referenceUrl
    }
    nonGhgMitigationBenefitsDescription
  }
  realizedCostsAndBenefits {
    id
    calculatedYears
    grossCostsEurPerTonCO2eReduced
    absoluteGrossCostsPerYearEur
    benefitsEurPerTonCO2eReduced
    absoluteBenefitPerYearEur
    netCostsEurPerTonCO2eReduced
    absoluteNetCostsPerYearEur
    priceYear
    costEstimatesDescription
    estimationSourceDocumentation {
      id
      referenceName
      referenceUrl
    }
    nonGhgMitigationBenefitsDescription
  }
  interactsWithOtherPoliciesAndMeasures
  interactionWithOtherPoliciesAndMeasuresDescription
  sdgImpact {
    id
  }
  genderEqualityImpact
  additionalComment
  informationSourceName
  informationAccess
  neededImprovements
  createdDate
  createdBy
  lastModifiedDate
  lastModifiedBy
  ndcRelevant
  ncRelevant
  approvedBy
  approvedDate
}
    ${PamEmissionReductionDataFragmentDoc}`;
export const ProjectionDocumentDataFragmentDoc = gql`
    fragment ProjectionDocumentData on ProjectionDocument {
  id
  fileName
  active
  createdBy
  createdDate
}
    `;
export const ProjectionValueDataFragmentDoc = gql`
    fragment ProjectionValueData on ProjectionValue {
  id
  year
  value
  scenario {
    id
  }
  sector {
    id
  }
}
    `;
export const ScenarioDataFragmentDoc = gql`
    fragment ScenarioData on Scenario {
  id
  code
  orderIndex
  preferredTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const OrganizationDataFragmentDoc = gql`
    fragment OrganizationData on Organization {
  id
  orderIndex
  mainOrganization
  createdBy
  createdDate
  lastModifiedBy
  lastModifiedDate
  preferredTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
  translations {
    ...TranslatedTextData
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const SharedDocumentDataFragmentDoc = gql`
    fragment SharedDocumentData on SharedDocument {
  id
  fileName
  year
  organization {
    ...OrganizationData
  }
  visibleByAllOrganizations
  createdBy
  createdDate
  lastModifiedBy
  lastModifiedDate
  name
  description
}
    ${OrganizationDataFragmentDoc}`;
export const TranslationItemDataFragmentDoc = gql`
    fragment TranslationItemData on TranslatedItem {
  id
  translationKey
  translations {
    ...TranslatedTextData
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const UserDataFragmentDoc = gql`
    fragment UserData on ApplicationUser {
  id
  displayName
  username
  email
  enabled
  createdBy
  createdDate
  lastModifiedBy
  lastModifiedDate
  organization {
    ...OrganizationData
  }
}
    ${OrganizationDataFragmentDoc}`;
export const UserGroupDataFragmentDoc = gql`
    fragment UserGroupData on UserGroup {
  id
  preferredTranslation(preferredLanguage: $language) {
    ...TranslatedTextData
  }
}
    ${TranslatedTextDataFragmentDoc}`;
export const ApproveArticle9SupportNeededDocument = gql`
    mutation ApproveArticle9SupportNeeded($id: ID!) {
  approveArticle9SupportNeeded(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveArticle9SupportNeededMutationFn = Apollo.MutationFunction<ApproveArticle9SupportNeededMutation, ApproveArticle9SupportNeededMutationVariables>;

/**
 * __useApproveArticle9SupportNeededMutation__
 *
 * To run a mutation, you first call `useApproveArticle9SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveArticle9SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveArticle9SupportNeededMutation, { data, loading, error }] = useApproveArticle9SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveArticle9SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<ApproveArticle9SupportNeededMutation, ApproveArticle9SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveArticle9SupportNeededMutation, ApproveArticle9SupportNeededMutationVariables>(ApproveArticle9SupportNeededDocument, options);
      }
export type ApproveArticle9SupportNeededMutationHookResult = ReturnType<typeof useApproveArticle9SupportNeededMutation>;
export type ApproveArticle9SupportNeededMutationResult = Apollo.MutationResult<ApproveArticle9SupportNeededMutation>;
export type ApproveArticle9SupportNeededMutationOptions = Apollo.BaseMutationOptions<ApproveArticle9SupportNeededMutation, ApproveArticle9SupportNeededMutationVariables>;
export const ApproveArticle9SupportReceivedDocument = gql`
    mutation ApproveArticle9SupportReceived($id: ID!) {
  approveArticle9SupportReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveArticle9SupportReceivedMutationFn = Apollo.MutationFunction<ApproveArticle9SupportReceivedMutation, ApproveArticle9SupportReceivedMutationVariables>;

/**
 * __useApproveArticle9SupportReceivedMutation__
 *
 * To run a mutation, you first call `useApproveArticle9SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveArticle9SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveArticle9SupportReceivedMutation, { data, loading, error }] = useApproveArticle9SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveArticle9SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<ApproveArticle9SupportReceivedMutation, ApproveArticle9SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveArticle9SupportReceivedMutation, ApproveArticle9SupportReceivedMutationVariables>(ApproveArticle9SupportReceivedDocument, options);
      }
export type ApproveArticle9SupportReceivedMutationHookResult = ReturnType<typeof useApproveArticle9SupportReceivedMutation>;
export type ApproveArticle9SupportReceivedMutationResult = Apollo.MutationResult<ApproveArticle9SupportReceivedMutation>;
export type ApproveArticle9SupportReceivedMutationOptions = Apollo.BaseMutationOptions<ApproveArticle9SupportReceivedMutation, ApproveArticle9SupportReceivedMutationVariables>;
export const ApproveArticle10SupportNeededDocument = gql`
    mutation ApproveArticle10SupportNeeded($id: ID!) {
  approveArticle10SupportNeeded(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveArticle10SupportNeededMutationFn = Apollo.MutationFunction<ApproveArticle10SupportNeededMutation, ApproveArticle10SupportNeededMutationVariables>;

/**
 * __useApproveArticle10SupportNeededMutation__
 *
 * To run a mutation, you first call `useApproveArticle10SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveArticle10SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveArticle10SupportNeededMutation, { data, loading, error }] = useApproveArticle10SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveArticle10SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<ApproveArticle10SupportNeededMutation, ApproveArticle10SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveArticle10SupportNeededMutation, ApproveArticle10SupportNeededMutationVariables>(ApproveArticle10SupportNeededDocument, options);
      }
export type ApproveArticle10SupportNeededMutationHookResult = ReturnType<typeof useApproveArticle10SupportNeededMutation>;
export type ApproveArticle10SupportNeededMutationResult = Apollo.MutationResult<ApproveArticle10SupportNeededMutation>;
export type ApproveArticle10SupportNeededMutationOptions = Apollo.BaseMutationOptions<ApproveArticle10SupportNeededMutation, ApproveArticle10SupportNeededMutationVariables>;
export const ApproveArticle10SupportReceivedDocument = gql`
    mutation ApproveArticle10SupportReceived($id: ID!) {
  approveArticle10SupportReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveArticle10SupportReceivedMutationFn = Apollo.MutationFunction<ApproveArticle10SupportReceivedMutation, ApproveArticle10SupportReceivedMutationVariables>;

/**
 * __useApproveArticle10SupportReceivedMutation__
 *
 * To run a mutation, you first call `useApproveArticle10SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveArticle10SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveArticle10SupportReceivedMutation, { data, loading, error }] = useApproveArticle10SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveArticle10SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<ApproveArticle10SupportReceivedMutation, ApproveArticle10SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveArticle10SupportReceivedMutation, ApproveArticle10SupportReceivedMutationVariables>(ApproveArticle10SupportReceivedDocument, options);
      }
export type ApproveArticle10SupportReceivedMutationHookResult = ReturnType<typeof useApproveArticle10SupportReceivedMutation>;
export type ApproveArticle10SupportReceivedMutationResult = Apollo.MutationResult<ApproveArticle10SupportReceivedMutation>;
export type ApproveArticle10SupportReceivedMutationOptions = Apollo.BaseMutationOptions<ApproveArticle10SupportReceivedMutation, ApproveArticle10SupportReceivedMutationVariables>;
export const ApproveArticle11SupportNeededDocument = gql`
    mutation ApproveArticle11SupportNeeded($id: ID!) {
  approveArticle11SupportNeeded(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveArticle11SupportNeededMutationFn = Apollo.MutationFunction<ApproveArticle11SupportNeededMutation, ApproveArticle11SupportNeededMutationVariables>;

/**
 * __useApproveArticle11SupportNeededMutation__
 *
 * To run a mutation, you first call `useApproveArticle11SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveArticle11SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveArticle11SupportNeededMutation, { data, loading, error }] = useApproveArticle11SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveArticle11SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<ApproveArticle11SupportNeededMutation, ApproveArticle11SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveArticle11SupportNeededMutation, ApproveArticle11SupportNeededMutationVariables>(ApproveArticle11SupportNeededDocument, options);
      }
export type ApproveArticle11SupportNeededMutationHookResult = ReturnType<typeof useApproveArticle11SupportNeededMutation>;
export type ApproveArticle11SupportNeededMutationResult = Apollo.MutationResult<ApproveArticle11SupportNeededMutation>;
export type ApproveArticle11SupportNeededMutationOptions = Apollo.BaseMutationOptions<ApproveArticle11SupportNeededMutation, ApproveArticle11SupportNeededMutationVariables>;
export const ApproveArticle11SupportReceivedDocument = gql`
    mutation ApproveArticle11SupportReceived($id: ID!) {
  approveArticle11SupportReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveArticle11SupportReceivedMutationFn = Apollo.MutationFunction<ApproveArticle11SupportReceivedMutation, ApproveArticle11SupportReceivedMutationVariables>;

/**
 * __useApproveArticle11SupportReceivedMutation__
 *
 * To run a mutation, you first call `useApproveArticle11SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveArticle11SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveArticle11SupportReceivedMutation, { data, loading, error }] = useApproveArticle11SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveArticle11SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<ApproveArticle11SupportReceivedMutation, ApproveArticle11SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveArticle11SupportReceivedMutation, ApproveArticle11SupportReceivedMutationVariables>(ApproveArticle11SupportReceivedDocument, options);
      }
export type ApproveArticle11SupportReceivedMutationHookResult = ReturnType<typeof useApproveArticle11SupportReceivedMutation>;
export type ApproveArticle11SupportReceivedMutationResult = Apollo.MutationResult<ApproveArticle11SupportReceivedMutation>;
export type ApproveArticle11SupportReceivedMutationOptions = Apollo.BaseMutationOptions<ApproveArticle11SupportReceivedMutation, ApproveArticle11SupportReceivedMutationVariables>;
export const ApproveArticle13SupportNeededReceivedDocument = gql`
    mutation ApproveArticle13SupportNeededReceived($id: ID!) {
  approveArticle13SupportNeededReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveArticle13SupportNeededReceivedMutationFn = Apollo.MutationFunction<ApproveArticle13SupportNeededReceivedMutation, ApproveArticle13SupportNeededReceivedMutationVariables>;

/**
 * __useApproveArticle13SupportNeededReceivedMutation__
 *
 * To run a mutation, you first call `useApproveArticle13SupportNeededReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveArticle13SupportNeededReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveArticle13SupportNeededReceivedMutation, { data, loading, error }] = useApproveArticle13SupportNeededReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveArticle13SupportNeededReceivedMutation(baseOptions?: Apollo.MutationHookOptions<ApproveArticle13SupportNeededReceivedMutation, ApproveArticle13SupportNeededReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveArticle13SupportNeededReceivedMutation, ApproveArticle13SupportNeededReceivedMutationVariables>(ApproveArticle13SupportNeededReceivedDocument, options);
      }
export type ApproveArticle13SupportNeededReceivedMutationHookResult = ReturnType<typeof useApproveArticle13SupportNeededReceivedMutation>;
export type ApproveArticle13SupportNeededReceivedMutationResult = Apollo.MutationResult<ApproveArticle13SupportNeededReceivedMutation>;
export type ApproveArticle13SupportNeededReceivedMutationOptions = Apollo.BaseMutationOptions<ApproveArticle13SupportNeededReceivedMutation, ApproveArticle13SupportNeededReceivedMutationVariables>;
export const ApproveDataCollectionDocumentDocument = gql`
    mutation ApproveDataCollectionDocument($id: ID!) {
  approveDataCollectionDocument(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;
export type ApproveDataCollectionDocumentMutationFn = Apollo.MutationFunction<ApproveDataCollectionDocumentMutation, ApproveDataCollectionDocumentMutationVariables>;

/**
 * __useApproveDataCollectionDocumentMutation__
 *
 * To run a mutation, you first call `useApproveDataCollectionDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDataCollectionDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDataCollectionDocumentMutation, { data, loading, error }] = useApproveDataCollectionDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveDataCollectionDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDataCollectionDocumentMutation, ApproveDataCollectionDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDataCollectionDocumentMutation, ApproveDataCollectionDocumentMutationVariables>(ApproveDataCollectionDocumentDocument, options);
      }
export type ApproveDataCollectionDocumentMutationHookResult = ReturnType<typeof useApproveDataCollectionDocumentMutation>;
export type ApproveDataCollectionDocumentMutationResult = Apollo.MutationResult<ApproveDataCollectionDocumentMutation>;
export type ApproveDataCollectionDocumentMutationOptions = Apollo.BaseMutationOptions<ApproveDataCollectionDocumentMutation, ApproveDataCollectionDocumentMutationVariables>;
export const ApproveMeasureDocument = gql`
    mutation ApproveMeasure($id: ID!) {
  approveMeasure(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type ApproveMeasureMutationFn = Apollo.MutationFunction<ApproveMeasureMutation, ApproveMeasureMutationVariables>;

/**
 * __useApproveMeasureMutation__
 *
 * To run a mutation, you first call `useApproveMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMeasureMutation, { data, loading, error }] = useApproveMeasureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveMeasureMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMeasureMutation, ApproveMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMeasureMutation, ApproveMeasureMutationVariables>(ApproveMeasureDocument, options);
      }
export type ApproveMeasureMutationHookResult = ReturnType<typeof useApproveMeasureMutation>;
export type ApproveMeasureMutationResult = Apollo.MutationResult<ApproveMeasureMutation>;
export type ApproveMeasureMutationOptions = Apollo.BaseMutationOptions<ApproveMeasureMutation, ApproveMeasureMutationVariables>;
export const ApprovePolicyAndMeasureDocument = gql`
    mutation ApprovePolicyAndMeasure($id: ID!) {
  approvePolicyAndMeasure(id: $id) {
    ...PamData
  }
}
    ${PamDataFragmentDoc}`;
export type ApprovePolicyAndMeasureMutationFn = Apollo.MutationFunction<ApprovePolicyAndMeasureMutation, ApprovePolicyAndMeasureMutationVariables>;

/**
 * __useApprovePolicyAndMeasureMutation__
 *
 * To run a mutation, you first call `useApprovePolicyAndMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePolicyAndMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePolicyAndMeasureMutation, { data, loading, error }] = useApprovePolicyAndMeasureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovePolicyAndMeasureMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePolicyAndMeasureMutation, ApprovePolicyAndMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePolicyAndMeasureMutation, ApprovePolicyAndMeasureMutationVariables>(ApprovePolicyAndMeasureDocument, options);
      }
export type ApprovePolicyAndMeasureMutationHookResult = ReturnType<typeof useApprovePolicyAndMeasureMutation>;
export type ApprovePolicyAndMeasureMutationResult = Apollo.MutationResult<ApprovePolicyAndMeasureMutation>;
export type ApprovePolicyAndMeasureMutationOptions = Apollo.BaseMutationOptions<ApprovePolicyAndMeasureMutation, ApprovePolicyAndMeasureMutationVariables>;
export const Article10NeededDetailsDocument = gql`
    query Article10NeededDetails($id: ID!) {
  article10SupportNeeded(filter: {common: {id: $id}}) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    sector
    supportType
    typeOfTechnology
    expectedUseImpactAndEstimatedResults
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useArticle10NeededDetailsQuery__
 *
 * To run a query within a React component, call `useArticle10NeededDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle10NeededDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle10NeededDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticle10NeededDetailsQuery(baseOptions: Apollo.QueryHookOptions<Article10NeededDetailsQuery, Article10NeededDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article10NeededDetailsQuery, Article10NeededDetailsQueryVariables>(Article10NeededDetailsDocument, options);
      }
export function useArticle10NeededDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article10NeededDetailsQuery, Article10NeededDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article10NeededDetailsQuery, Article10NeededDetailsQueryVariables>(Article10NeededDetailsDocument, options);
        }
export type Article10NeededDetailsQueryHookResult = ReturnType<typeof useArticle10NeededDetailsQuery>;
export type Article10NeededDetailsLazyQueryHookResult = ReturnType<typeof useArticle10NeededDetailsLazyQuery>;
export type Article10NeededDetailsQueryResult = Apollo.QueryResult<Article10NeededDetailsQuery, Article10NeededDetailsQueryVariables>;
export const Article10NeededListDocument = gql`
    query Article10NeededList($filter: SupportNeededFilter) {
  supportNeeded: article10SupportNeeded(filter: $filter) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    sector
    supportType
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useArticle10NeededListQuery__
 *
 * To run a query within a React component, call `useArticle10NeededListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle10NeededListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle10NeededListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle10NeededListQuery(baseOptions?: Apollo.QueryHookOptions<Article10NeededListQuery, Article10NeededListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article10NeededListQuery, Article10NeededListQueryVariables>(Article10NeededListDocument, options);
      }
export function useArticle10NeededListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article10NeededListQuery, Article10NeededListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article10NeededListQuery, Article10NeededListQueryVariables>(Article10NeededListDocument, options);
        }
export type Article10NeededListQueryHookResult = ReturnType<typeof useArticle10NeededListQuery>;
export type Article10NeededListLazyQueryHookResult = ReturnType<typeof useArticle10NeededListLazyQuery>;
export type Article10NeededListQueryResult = Apollo.QueryResult<Article10NeededListQuery, Article10NeededListQueryVariables>;
export const Article10ReceivedDetailsDocument = gql`
    query Article10ReceivedDetails($id: ID!) {
  article10SupportReceived(filter: {common: {id: $id}}) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    sector
    supportType
    statusOfActivity
    typeOfTechnology
    useImpactAndEstimatedResults
    recipientEntity
    implementingEntity
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    description
  }
}
    `;

/**
 * __useArticle10ReceivedDetailsQuery__
 *
 * To run a query within a React component, call `useArticle10ReceivedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle10ReceivedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle10ReceivedDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticle10ReceivedDetailsQuery(baseOptions: Apollo.QueryHookOptions<Article10ReceivedDetailsQuery, Article10ReceivedDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article10ReceivedDetailsQuery, Article10ReceivedDetailsQueryVariables>(Article10ReceivedDetailsDocument, options);
      }
export function useArticle10ReceivedDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article10ReceivedDetailsQuery, Article10ReceivedDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article10ReceivedDetailsQuery, Article10ReceivedDetailsQueryVariables>(Article10ReceivedDetailsDocument, options);
        }
export type Article10ReceivedDetailsQueryHookResult = ReturnType<typeof useArticle10ReceivedDetailsQuery>;
export type Article10ReceivedDetailsLazyQueryHookResult = ReturnType<typeof useArticle10ReceivedDetailsLazyQuery>;
export type Article10ReceivedDetailsQueryResult = Apollo.QueryResult<Article10ReceivedDetailsQuery, Article10ReceivedDetailsQueryVariables>;
export const Article10ReceivedListDocument = gql`
    query Article10ReceivedList($filter: SupportReceivedFilter) {
  supportReceived: article10SupportReceived(filter: $filter) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    sector
    supportType
    statusOfActivity
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    description
  }
}
    `;

/**
 * __useArticle10ReceivedListQuery__
 *
 * To run a query within a React component, call `useArticle10ReceivedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle10ReceivedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle10ReceivedListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle10ReceivedListQuery(baseOptions?: Apollo.QueryHookOptions<Article10ReceivedListQuery, Article10ReceivedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article10ReceivedListQuery, Article10ReceivedListQueryVariables>(Article10ReceivedListDocument, options);
      }
export function useArticle10ReceivedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article10ReceivedListQuery, Article10ReceivedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article10ReceivedListQuery, Article10ReceivedListQueryVariables>(Article10ReceivedListDocument, options);
        }
export type Article10ReceivedListQueryHookResult = ReturnType<typeof useArticle10ReceivedListQuery>;
export type Article10ReceivedListLazyQueryHookResult = ReturnType<typeof useArticle10ReceivedListLazyQuery>;
export type Article10ReceivedListQueryResult = Apollo.QueryResult<Article10ReceivedListQuery, Article10ReceivedListQueryVariables>;
export const Article10StatisticsDocument = gql`
    query Article10Statistics($filter: CommonSupportFilter) {
  supportNeededStatistic: article10SupportNeededStatistic(
    filter: {common: $filter}
  ) {
    year
    amount
  }
  supportReceivedStatistic: article10SupportReceivedStatistic(
    filter: {common: $filter}
  ) {
    year
    amount
  }
}
    `;

/**
 * __useArticle10StatisticsQuery__
 *
 * To run a query within a React component, call `useArticle10StatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle10StatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle10StatisticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle10StatisticsQuery(baseOptions?: Apollo.QueryHookOptions<Article10StatisticsQuery, Article10StatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article10StatisticsQuery, Article10StatisticsQueryVariables>(Article10StatisticsDocument, options);
      }
export function useArticle10StatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article10StatisticsQuery, Article10StatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article10StatisticsQuery, Article10StatisticsQueryVariables>(Article10StatisticsDocument, options);
        }
export type Article10StatisticsQueryHookResult = ReturnType<typeof useArticle10StatisticsQuery>;
export type Article10StatisticsLazyQueryHookResult = ReturnType<typeof useArticle10StatisticsLazyQuery>;
export type Article10StatisticsQueryResult = Apollo.QueryResult<Article10StatisticsQuery, Article10StatisticsQueryVariables>;
export const Article11NeededDetailsDocument = gql`
    query Article11NeededDetails($id: ID!) {
  article11SupportNeeded(filter: {common: {id: $id}}) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    supportType
    expectedUseImpactAndEstimatedResults
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useArticle11NeededDetailsQuery__
 *
 * To run a query within a React component, call `useArticle11NeededDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle11NeededDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle11NeededDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticle11NeededDetailsQuery(baseOptions: Apollo.QueryHookOptions<Article11NeededDetailsQuery, Article11NeededDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article11NeededDetailsQuery, Article11NeededDetailsQueryVariables>(Article11NeededDetailsDocument, options);
      }
export function useArticle11NeededDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article11NeededDetailsQuery, Article11NeededDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article11NeededDetailsQuery, Article11NeededDetailsQueryVariables>(Article11NeededDetailsDocument, options);
        }
export type Article11NeededDetailsQueryHookResult = ReturnType<typeof useArticle11NeededDetailsQuery>;
export type Article11NeededDetailsLazyQueryHookResult = ReturnType<typeof useArticle11NeededDetailsLazyQuery>;
export type Article11NeededDetailsQueryResult = Apollo.QueryResult<Article11NeededDetailsQuery, Article11NeededDetailsQueryVariables>;
export const Article11NeededListDocument = gql`
    query Article11NeededList($filter: SupportNeededFilter) {
  supportNeeded: article11SupportNeeded(filter: $filter) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    supportType
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useArticle11NeededListQuery__
 *
 * To run a query within a React component, call `useArticle11NeededListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle11NeededListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle11NeededListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle11NeededListQuery(baseOptions?: Apollo.QueryHookOptions<Article11NeededListQuery, Article11NeededListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article11NeededListQuery, Article11NeededListQueryVariables>(Article11NeededListDocument, options);
      }
export function useArticle11NeededListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article11NeededListQuery, Article11NeededListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article11NeededListQuery, Article11NeededListQueryVariables>(Article11NeededListDocument, options);
        }
export type Article11NeededListQueryHookResult = ReturnType<typeof useArticle11NeededListQuery>;
export type Article11NeededListLazyQueryHookResult = ReturnType<typeof useArticle11NeededListLazyQuery>;
export type Article11NeededListQueryResult = Apollo.QueryResult<Article11NeededListQuery, Article11NeededListQueryVariables>;
export const Article11ReceivedDetailsDocument = gql`
    query Article11ReceivedDetails($id: ID!) {
  article11SupportReceived(filter: {common: {id: $id}}) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    supportType
    statusOfActivity
    useImpactAndEstimatedResults
    recipientEntity
    implementingEntity
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    description
  }
}
    `;

/**
 * __useArticle11ReceivedDetailsQuery__
 *
 * To run a query within a React component, call `useArticle11ReceivedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle11ReceivedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle11ReceivedDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticle11ReceivedDetailsQuery(baseOptions: Apollo.QueryHookOptions<Article11ReceivedDetailsQuery, Article11ReceivedDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article11ReceivedDetailsQuery, Article11ReceivedDetailsQueryVariables>(Article11ReceivedDetailsDocument, options);
      }
export function useArticle11ReceivedDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article11ReceivedDetailsQuery, Article11ReceivedDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article11ReceivedDetailsQuery, Article11ReceivedDetailsQueryVariables>(Article11ReceivedDetailsDocument, options);
        }
export type Article11ReceivedDetailsQueryHookResult = ReturnType<typeof useArticle11ReceivedDetailsQuery>;
export type Article11ReceivedDetailsLazyQueryHookResult = ReturnType<typeof useArticle11ReceivedDetailsLazyQuery>;
export type Article11ReceivedDetailsQueryResult = Apollo.QueryResult<Article11ReceivedDetailsQuery, Article11ReceivedDetailsQueryVariables>;
export const Article11ReceivedListDocument = gql`
    query Article11ReceivedList($filter: SupportReceivedFilter) {
  supportReceived: article11SupportReceived(filter: $filter) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    supportType
    statusOfActivity
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    description
  }
}
    `;

/**
 * __useArticle11ReceivedListQuery__
 *
 * To run a query within a React component, call `useArticle11ReceivedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle11ReceivedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle11ReceivedListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle11ReceivedListQuery(baseOptions?: Apollo.QueryHookOptions<Article11ReceivedListQuery, Article11ReceivedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article11ReceivedListQuery, Article11ReceivedListQueryVariables>(Article11ReceivedListDocument, options);
      }
export function useArticle11ReceivedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article11ReceivedListQuery, Article11ReceivedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article11ReceivedListQuery, Article11ReceivedListQueryVariables>(Article11ReceivedListDocument, options);
        }
export type Article11ReceivedListQueryHookResult = ReturnType<typeof useArticle11ReceivedListQuery>;
export type Article11ReceivedListLazyQueryHookResult = ReturnType<typeof useArticle11ReceivedListLazyQuery>;
export type Article11ReceivedListQueryResult = Apollo.QueryResult<Article11ReceivedListQuery, Article11ReceivedListQueryVariables>;
export const Article11StatisticsDocument = gql`
    query Article11Statistics($filter: CommonSupportFilter) {
  supportNeededStatistic: article11SupportNeededStatistic(
    filter: {common: $filter}
  ) {
    year
    amount
  }
  supportReceivedStatistic: article11SupportReceivedStatistic(
    filter: {common: $filter}
  ) {
    year
    amount
  }
}
    `;

/**
 * __useArticle11StatisticsQuery__
 *
 * To run a query within a React component, call `useArticle11StatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle11StatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle11StatisticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle11StatisticsQuery(baseOptions?: Apollo.QueryHookOptions<Article11StatisticsQuery, Article11StatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article11StatisticsQuery, Article11StatisticsQueryVariables>(Article11StatisticsDocument, options);
      }
export function useArticle11StatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article11StatisticsQuery, Article11StatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article11StatisticsQuery, Article11StatisticsQueryVariables>(Article11StatisticsDocument, options);
        }
export type Article11StatisticsQueryHookResult = ReturnType<typeof useArticle11StatisticsQuery>;
export type Article11StatisticsLazyQueryHookResult = ReturnType<typeof useArticle11StatisticsLazyQuery>;
export type Article11StatisticsQueryResult = Apollo.QueryResult<Article11StatisticsQuery, Article11StatisticsQueryVariables>;
export const Article13NeededReceivedDetailsDocument = gql`
    query Article13NeededReceivedDetails($id: ID!) {
  article13SupportNeededReceived(filter: {common: {id: $id}}) {
    id
    project {
      id
      title
      description
    }
    recipientEntity
    channel
    amountRsd
    amountUsd
    timeframeStart
    timeframeEnd
    statusOfActivity
    useImpactAndEstimatedResults
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useArticle13NeededReceivedDetailsQuery__
 *
 * To run a query within a React component, call `useArticle13NeededReceivedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle13NeededReceivedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle13NeededReceivedDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticle13NeededReceivedDetailsQuery(baseOptions: Apollo.QueryHookOptions<Article13NeededReceivedDetailsQuery, Article13NeededReceivedDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article13NeededReceivedDetailsQuery, Article13NeededReceivedDetailsQueryVariables>(Article13NeededReceivedDetailsDocument, options);
      }
export function useArticle13NeededReceivedDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article13NeededReceivedDetailsQuery, Article13NeededReceivedDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article13NeededReceivedDetailsQuery, Article13NeededReceivedDetailsQueryVariables>(Article13NeededReceivedDetailsDocument, options);
        }
export type Article13NeededReceivedDetailsQueryHookResult = ReturnType<typeof useArticle13NeededReceivedDetailsQuery>;
export type Article13NeededReceivedDetailsLazyQueryHookResult = ReturnType<typeof useArticle13NeededReceivedDetailsLazyQuery>;
export type Article13NeededReceivedDetailsQueryResult = Apollo.QueryResult<Article13NeededReceivedDetailsQuery, Article13NeededReceivedDetailsQueryVariables>;
export const Article13NeededReceivedListDocument = gql`
    query Article13NeededReceivedList($filter: SupportNeededFilter) {
  supportNeeded: article13SupportNeededReceived(filter: $filter) {
    id
    project {
      id
      title
      description
    }
    timeframeStart
    timeframeEnd
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useArticle13NeededReceivedListQuery__
 *
 * To run a query within a React component, call `useArticle13NeededReceivedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle13NeededReceivedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle13NeededReceivedListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle13NeededReceivedListQuery(baseOptions?: Apollo.QueryHookOptions<Article13NeededReceivedListQuery, Article13NeededReceivedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article13NeededReceivedListQuery, Article13NeededReceivedListQueryVariables>(Article13NeededReceivedListDocument, options);
      }
export function useArticle13NeededReceivedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article13NeededReceivedListQuery, Article13NeededReceivedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article13NeededReceivedListQuery, Article13NeededReceivedListQueryVariables>(Article13NeededReceivedListDocument, options);
        }
export type Article13NeededReceivedListQueryHookResult = ReturnType<typeof useArticle13NeededReceivedListQuery>;
export type Article13NeededReceivedListLazyQueryHookResult = ReturnType<typeof useArticle13NeededReceivedListLazyQuery>;
export type Article13NeededReceivedListQueryResult = Apollo.QueryResult<Article13NeededReceivedListQuery, Article13NeededReceivedListQueryVariables>;
export const Article13StatisticsDocument = gql`
    query Article13Statistics($filter: CommonSupportFilter) {
  supportStatistic: article13SupportNeededReceivedStatistic(
    filter: {common: $filter}
  ) {
    year
    amount
    valueRsd
    valueUsd
  }
}
    `;

/**
 * __useArticle13StatisticsQuery__
 *
 * To run a query within a React component, call `useArticle13StatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle13StatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle13StatisticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle13StatisticsQuery(baseOptions?: Apollo.QueryHookOptions<Article13StatisticsQuery, Article13StatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article13StatisticsQuery, Article13StatisticsQueryVariables>(Article13StatisticsDocument, options);
      }
export function useArticle13StatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article13StatisticsQuery, Article13StatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article13StatisticsQuery, Article13StatisticsQueryVariables>(Article13StatisticsDocument, options);
        }
export type Article13StatisticsQueryHookResult = ReturnType<typeof useArticle13StatisticsQuery>;
export type Article13StatisticsLazyQueryHookResult = ReturnType<typeof useArticle13StatisticsLazyQuery>;
export type Article13StatisticsQueryResult = Apollo.QueryResult<Article13StatisticsQuery, Article13StatisticsQueryVariables>;
export const Article9NeededDetailsDocument = gql`
    query Article9NeededDetails($id: ID!) {
  article9SupportNeeded(filter: {common: {id: $id}}) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    expectedUseImpactAndEstimatedResults
    supportType
    expectedFinancialInstrument
    estimatedAmountRsd
    estimatedAmountUsd
    sector
    activityContribution
    activityAnchored
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useArticle9NeededDetailsQuery__
 *
 * To run a query within a React component, call `useArticle9NeededDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle9NeededDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle9NeededDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticle9NeededDetailsQuery(baseOptions: Apollo.QueryHookOptions<Article9NeededDetailsQuery, Article9NeededDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article9NeededDetailsQuery, Article9NeededDetailsQueryVariables>(Article9NeededDetailsDocument, options);
      }
export function useArticle9NeededDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article9NeededDetailsQuery, Article9NeededDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article9NeededDetailsQuery, Article9NeededDetailsQueryVariables>(Article9NeededDetailsDocument, options);
        }
export type Article9NeededDetailsQueryHookResult = ReturnType<typeof useArticle9NeededDetailsQuery>;
export type Article9NeededDetailsLazyQueryHookResult = ReturnType<typeof useArticle9NeededDetailsLazyQuery>;
export type Article9NeededDetailsQueryResult = Apollo.QueryResult<Article9NeededDetailsQuery, Article9NeededDetailsQueryVariables>;
export const Article9NeededListDocument = gql`
    query Article9NeededList($filter: SupportNeededFilter) {
  supportNeeded: article9SupportNeeded(filter: $filter) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    sector
    supportType
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    supportReceived {
      id
    }
  }
}
    `;

/**
 * __useArticle9NeededListQuery__
 *
 * To run a query within a React component, call `useArticle9NeededListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle9NeededListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle9NeededListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle9NeededListQuery(baseOptions?: Apollo.QueryHookOptions<Article9NeededListQuery, Article9NeededListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article9NeededListQuery, Article9NeededListQueryVariables>(Article9NeededListDocument, options);
      }
export function useArticle9NeededListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article9NeededListQuery, Article9NeededListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article9NeededListQuery, Article9NeededListQueryVariables>(Article9NeededListDocument, options);
        }
export type Article9NeededListQueryHookResult = ReturnType<typeof useArticle9NeededListQuery>;
export type Article9NeededListLazyQueryHookResult = ReturnType<typeof useArticle9NeededListLazyQuery>;
export type Article9NeededListQueryResult = Apollo.QueryResult<Article9NeededListQuery, Article9NeededListQueryVariables>;
export const Article9ReceivedDetailsDocument = gql`
    query Article9ReceivedDetails($id: ID!) {
  article9SupportReceived(filter: {common: {id: $id}}) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    sector
    supportType
    statusOfActivity
    channel
    sector
    amountRsd
    amountUsd
    financialInstrument
    activityContribution
    recipientEntity
    implementingEntity
    useImpactAndEstimatedResults
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    description
  }
}
    `;

/**
 * __useArticle9ReceivedDetailsQuery__
 *
 * To run a query within a React component, call `useArticle9ReceivedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle9ReceivedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle9ReceivedDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticle9ReceivedDetailsQuery(baseOptions: Apollo.QueryHookOptions<Article9ReceivedDetailsQuery, Article9ReceivedDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article9ReceivedDetailsQuery, Article9ReceivedDetailsQueryVariables>(Article9ReceivedDetailsDocument, options);
      }
export function useArticle9ReceivedDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article9ReceivedDetailsQuery, Article9ReceivedDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article9ReceivedDetailsQuery, Article9ReceivedDetailsQueryVariables>(Article9ReceivedDetailsDocument, options);
        }
export type Article9ReceivedDetailsQueryHookResult = ReturnType<typeof useArticle9ReceivedDetailsQuery>;
export type Article9ReceivedDetailsLazyQueryHookResult = ReturnType<typeof useArticle9ReceivedDetailsLazyQuery>;
export type Article9ReceivedDetailsQueryResult = Apollo.QueryResult<Article9ReceivedDetailsQuery, Article9ReceivedDetailsQueryVariables>;
export const Article9ReceivedListDocument = gql`
    query Article9ReceivedList($filter: SupportReceivedFilter) {
  supportReceived: article9SupportReceived(filter: $filter) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    sector
    supportType
    statusOfActivity
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    description
  }
}
    `;

/**
 * __useArticle9ReceivedListQuery__
 *
 * To run a query within a React component, call `useArticle9ReceivedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle9ReceivedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle9ReceivedListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle9ReceivedListQuery(baseOptions?: Apollo.QueryHookOptions<Article9ReceivedListQuery, Article9ReceivedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article9ReceivedListQuery, Article9ReceivedListQueryVariables>(Article9ReceivedListDocument, options);
      }
export function useArticle9ReceivedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article9ReceivedListQuery, Article9ReceivedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article9ReceivedListQuery, Article9ReceivedListQueryVariables>(Article9ReceivedListDocument, options);
        }
export type Article9ReceivedListQueryHookResult = ReturnType<typeof useArticle9ReceivedListQuery>;
export type Article9ReceivedListLazyQueryHookResult = ReturnType<typeof useArticle9ReceivedListLazyQuery>;
export type Article9ReceivedListQueryResult = Apollo.QueryResult<Article9ReceivedListQuery, Article9ReceivedListQueryVariables>;
export const Article9StatisticsDocument = gql`
    query Article9Statistics($filter: CommonSupportFilter) {
  supportNeededStatistic: article9SupportNeededStatistic(
    filter: {common: $filter}
  ) {
    year
    amount
    valueRsd
    valueUsd
  }
  supportReceivedStatistic: article9SupportReceivedStatistic(
    filter: {common: $filter}
  ) {
    year
    amount
    valueRsd
    valueUsd
  }
}
    `;

/**
 * __useArticle9StatisticsQuery__
 *
 * To run a query within a React component, call `useArticle9StatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticle9StatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticle9StatisticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArticle9StatisticsQuery(baseOptions?: Apollo.QueryHookOptions<Article9StatisticsQuery, Article9StatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Article9StatisticsQuery, Article9StatisticsQueryVariables>(Article9StatisticsDocument, options);
      }
export function useArticle9StatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Article9StatisticsQuery, Article9StatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Article9StatisticsQuery, Article9StatisticsQueryVariables>(Article9StatisticsDocument, options);
        }
export type Article9StatisticsQueryHookResult = ReturnType<typeof useArticle9StatisticsQuery>;
export type Article9StatisticsLazyQueryHookResult = ReturnType<typeof useArticle9StatisticsLazyQuery>;
export type Article9StatisticsQueryResult = Apollo.QueryResult<Article9StatisticsQuery, Article9StatisticsQueryVariables>;
export const ChangeExternalSourcePrimaryDocument = gql`
    mutation ChangeExternalSourcePrimary($sourceId: ID!, $primary: Boolean!, $language: String!) {
  changeSourcePrimary(sourceId: $sourceId, primary: $primary) {
    ...ExternalSourceData
  }
}
    ${ExternalSourceDataFragmentDoc}`;
export type ChangeExternalSourcePrimaryMutationFn = Apollo.MutationFunction<ChangeExternalSourcePrimaryMutation, ChangeExternalSourcePrimaryMutationVariables>;

/**
 * __useChangeExternalSourcePrimaryMutation__
 *
 * To run a mutation, you first call `useChangeExternalSourcePrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeExternalSourcePrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeExternalSourcePrimaryMutation, { data, loading, error }] = useChangeExternalSourcePrimaryMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      primary: // value for 'primary'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeExternalSourcePrimaryMutation(baseOptions?: Apollo.MutationHookOptions<ChangeExternalSourcePrimaryMutation, ChangeExternalSourcePrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeExternalSourcePrimaryMutation, ChangeExternalSourcePrimaryMutationVariables>(ChangeExternalSourcePrimaryDocument, options);
      }
export type ChangeExternalSourcePrimaryMutationHookResult = ReturnType<typeof useChangeExternalSourcePrimaryMutation>;
export type ChangeExternalSourcePrimaryMutationResult = Apollo.MutationResult<ChangeExternalSourcePrimaryMutation>;
export type ChangeExternalSourcePrimaryMutationOptions = Apollo.BaseMutationOptions<ChangeExternalSourcePrimaryMutation, ChangeExternalSourcePrimaryMutationVariables>;
export const ChangeExternalSourceVisibilityDocument = gql`
    mutation ChangeExternalSourceVisibility($sourceId: ID!, $visible: Boolean!, $language: String!) {
  changeSourceVisibility(sourceId: $sourceId, visible: $visible) {
    ...ExternalSourceData
  }
}
    ${ExternalSourceDataFragmentDoc}`;
export type ChangeExternalSourceVisibilityMutationFn = Apollo.MutationFunction<ChangeExternalSourceVisibilityMutation, ChangeExternalSourceVisibilityMutationVariables>;

/**
 * __useChangeExternalSourceVisibilityMutation__
 *
 * To run a mutation, you first call `useChangeExternalSourceVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeExternalSourceVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeExternalSourceVisibilityMutation, { data, loading, error }] = useChangeExternalSourceVisibilityMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      visible: // value for 'visible'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeExternalSourceVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeExternalSourceVisibilityMutation, ChangeExternalSourceVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeExternalSourceVisibilityMutation, ChangeExternalSourceVisibilityMutationVariables>(ChangeExternalSourceVisibilityDocument, options);
      }
export type ChangeExternalSourceVisibilityMutationHookResult = ReturnType<typeof useChangeExternalSourceVisibilityMutation>;
export type ChangeExternalSourceVisibilityMutationResult = Apollo.MutationResult<ChangeExternalSourceVisibilityMutation>;
export type ChangeExternalSourceVisibilityMutationOptions = Apollo.BaseMutationOptions<ChangeExternalSourceVisibilityMutation, ChangeExternalSourceVisibilityMutationVariables>;
export const ChangeInfoDocumentPrimaryDocument = gql`
    mutation ChangeInfoDocumentPrimary($documentId: ID!, $primary: Boolean!, $language: String!) {
  changeInfoDocumentPrimary(documentId: $documentId, primary: $primary) {
    ...InfoDocumentData
  }
}
    ${InfoDocumentDataFragmentDoc}`;
export type ChangeInfoDocumentPrimaryMutationFn = Apollo.MutationFunction<ChangeInfoDocumentPrimaryMutation, ChangeInfoDocumentPrimaryMutationVariables>;

/**
 * __useChangeInfoDocumentPrimaryMutation__
 *
 * To run a mutation, you first call `useChangeInfoDocumentPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeInfoDocumentPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeInfoDocumentPrimaryMutation, { data, loading, error }] = useChangeInfoDocumentPrimaryMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      primary: // value for 'primary'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeInfoDocumentPrimaryMutation(baseOptions?: Apollo.MutationHookOptions<ChangeInfoDocumentPrimaryMutation, ChangeInfoDocumentPrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeInfoDocumentPrimaryMutation, ChangeInfoDocumentPrimaryMutationVariables>(ChangeInfoDocumentPrimaryDocument, options);
      }
export type ChangeInfoDocumentPrimaryMutationHookResult = ReturnType<typeof useChangeInfoDocumentPrimaryMutation>;
export type ChangeInfoDocumentPrimaryMutationResult = Apollo.MutationResult<ChangeInfoDocumentPrimaryMutation>;
export type ChangeInfoDocumentPrimaryMutationOptions = Apollo.BaseMutationOptions<ChangeInfoDocumentPrimaryMutation, ChangeInfoDocumentPrimaryMutationVariables>;
export const ChangeInfoDocumentVisibilityDocument = gql`
    mutation ChangeInfoDocumentVisibility($documentId: ID!, $visible: Boolean!, $language: String!) {
  changeInfoDocumentVisibility(documentId: $documentId, visible: $visible) {
    ...InfoDocumentData
  }
}
    ${InfoDocumentDataFragmentDoc}`;
export type ChangeInfoDocumentVisibilityMutationFn = Apollo.MutationFunction<ChangeInfoDocumentVisibilityMutation, ChangeInfoDocumentVisibilityMutationVariables>;

/**
 * __useChangeInfoDocumentVisibilityMutation__
 *
 * To run a mutation, you first call `useChangeInfoDocumentVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeInfoDocumentVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeInfoDocumentVisibilityMutation, { data, loading, error }] = useChangeInfoDocumentVisibilityMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      visible: // value for 'visible'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeInfoDocumentVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeInfoDocumentVisibilityMutation, ChangeInfoDocumentVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeInfoDocumentVisibilityMutation, ChangeInfoDocumentVisibilityMutationVariables>(ChangeInfoDocumentVisibilityDocument, options);
      }
export type ChangeInfoDocumentVisibilityMutationHookResult = ReturnType<typeof useChangeInfoDocumentVisibilityMutation>;
export type ChangeInfoDocumentVisibilityMutationResult = Apollo.MutationResult<ChangeInfoDocumentVisibilityMutation>;
export type ChangeInfoDocumentVisibilityMutationOptions = Apollo.BaseMutationOptions<ChangeInfoDocumentVisibilityMutation, ChangeInfoDocumentVisibilityMutationVariables>;
export const ChangePasswordByTokenDocument = gql`
    mutation ChangePasswordByToken($token: ID!, $dto: ChangePasswordToken!) {
  changePasswordByToken(token: $token, dto: $dto) {
    id
    username
  }
}
    `;
export type ChangePasswordByTokenMutationFn = Apollo.MutationFunction<ChangePasswordByTokenMutation, ChangePasswordByTokenMutationVariables>;

/**
 * __useChangePasswordByTokenMutation__
 *
 * To run a mutation, you first call `useChangePasswordByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordByTokenMutation, { data, loading, error }] = useChangePasswordByTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useChangePasswordByTokenMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordByTokenMutation, ChangePasswordByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordByTokenMutation, ChangePasswordByTokenMutationVariables>(ChangePasswordByTokenDocument, options);
      }
export type ChangePasswordByTokenMutationHookResult = ReturnType<typeof useChangePasswordByTokenMutation>;
export type ChangePasswordByTokenMutationResult = Apollo.MutationResult<ChangePasswordByTokenMutation>;
export type ChangePasswordByTokenMutationOptions = Apollo.BaseMutationOptions<ChangePasswordByTokenMutation, ChangePasswordByTokenMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($username: String!, $dto: ChangePassword!) {
  changePassword(username: $username, dto: $dto) {
    id
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      username: // value for 'username'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ChangeSharedDocumentVisibilityDocument = gql`
    mutation ChangeSharedDocumentVisibility($documentId: ID!, $visible: Boolean!, $language: String!) {
  changeSharedDocumentVisibility(documentId: $documentId, visible: $visible) {
    ...SharedDocumentData
  }
}
    ${SharedDocumentDataFragmentDoc}`;
export type ChangeSharedDocumentVisibilityMutationFn = Apollo.MutationFunction<ChangeSharedDocumentVisibilityMutation, ChangeSharedDocumentVisibilityMutationVariables>;

/**
 * __useChangeSharedDocumentVisibilityMutation__
 *
 * To run a mutation, you first call `useChangeSharedDocumentVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSharedDocumentVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSharedDocumentVisibilityMutation, { data, loading, error }] = useChangeSharedDocumentVisibilityMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      visible: // value for 'visible'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeSharedDocumentVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSharedDocumentVisibilityMutation, ChangeSharedDocumentVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSharedDocumentVisibilityMutation, ChangeSharedDocumentVisibilityMutationVariables>(ChangeSharedDocumentVisibilityDocument, options);
      }
export type ChangeSharedDocumentVisibilityMutationHookResult = ReturnType<typeof useChangeSharedDocumentVisibilityMutation>;
export type ChangeSharedDocumentVisibilityMutationResult = Apollo.MutationResult<ChangeSharedDocumentVisibilityMutation>;
export type ChangeSharedDocumentVisibilityMutationOptions = Apollo.BaseMutationOptions<ChangeSharedDocumentVisibilityMutation, ChangeSharedDocumentVisibilityMutationVariables>;
export const CreateArticle10NeededDocument = gql`
    mutation CreateArticle10Needed($dto: CreateArticle10SupportNeeded!) {
  createArticle10SupportNeeded(dto: $dto) {
    id
  }
}
    `;
export type CreateArticle10NeededMutationFn = Apollo.MutationFunction<CreateArticle10NeededMutation, CreateArticle10NeededMutationVariables>;

/**
 * __useCreateArticle10NeededMutation__
 *
 * To run a mutation, you first call `useCreateArticle10NeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle10NeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticle10NeededMutation, { data, loading, error }] = useCreateArticle10NeededMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateArticle10NeededMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticle10NeededMutation, CreateArticle10NeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticle10NeededMutation, CreateArticle10NeededMutationVariables>(CreateArticle10NeededDocument, options);
      }
export type CreateArticle10NeededMutationHookResult = ReturnType<typeof useCreateArticle10NeededMutation>;
export type CreateArticle10NeededMutationResult = Apollo.MutationResult<CreateArticle10NeededMutation>;
export type CreateArticle10NeededMutationOptions = Apollo.BaseMutationOptions<CreateArticle10NeededMutation, CreateArticle10NeededMutationVariables>;
export const CreateArticle10ReceivedDocument = gql`
    mutation CreateArticle10Received($dto: CreateArticle10SupportReceived!) {
  createArticle10SupportReceived(dto: $dto) {
    id
  }
}
    `;
export type CreateArticle10ReceivedMutationFn = Apollo.MutationFunction<CreateArticle10ReceivedMutation, CreateArticle10ReceivedMutationVariables>;

/**
 * __useCreateArticle10ReceivedMutation__
 *
 * To run a mutation, you first call `useCreateArticle10ReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle10ReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticle10ReceivedMutation, { data, loading, error }] = useCreateArticle10ReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateArticle10ReceivedMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticle10ReceivedMutation, CreateArticle10ReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticle10ReceivedMutation, CreateArticle10ReceivedMutationVariables>(CreateArticle10ReceivedDocument, options);
      }
export type CreateArticle10ReceivedMutationHookResult = ReturnType<typeof useCreateArticle10ReceivedMutation>;
export type CreateArticle10ReceivedMutationResult = Apollo.MutationResult<CreateArticle10ReceivedMutation>;
export type CreateArticle10ReceivedMutationOptions = Apollo.BaseMutationOptions<CreateArticle10ReceivedMutation, CreateArticle10ReceivedMutationVariables>;
export const CreateArticle11NeededDocument = gql`
    mutation CreateArticle11Needed($dto: CreateArticle11SupportNeeded!) {
  createArticle11SupportNeeded(dto: $dto) {
    id
  }
}
    `;
export type CreateArticle11NeededMutationFn = Apollo.MutationFunction<CreateArticle11NeededMutation, CreateArticle11NeededMutationVariables>;

/**
 * __useCreateArticle11NeededMutation__
 *
 * To run a mutation, you first call `useCreateArticle11NeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle11NeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticle11NeededMutation, { data, loading, error }] = useCreateArticle11NeededMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateArticle11NeededMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticle11NeededMutation, CreateArticle11NeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticle11NeededMutation, CreateArticle11NeededMutationVariables>(CreateArticle11NeededDocument, options);
      }
export type CreateArticle11NeededMutationHookResult = ReturnType<typeof useCreateArticle11NeededMutation>;
export type CreateArticle11NeededMutationResult = Apollo.MutationResult<CreateArticle11NeededMutation>;
export type CreateArticle11NeededMutationOptions = Apollo.BaseMutationOptions<CreateArticle11NeededMutation, CreateArticle11NeededMutationVariables>;
export const CreateArticle11ReceivedDocument = gql`
    mutation CreateArticle11Received($dto: CreateArticle11SupportReceived!) {
  createArticle11SupportReceived(dto: $dto) {
    id
  }
}
    `;
export type CreateArticle11ReceivedMutationFn = Apollo.MutationFunction<CreateArticle11ReceivedMutation, CreateArticle11ReceivedMutationVariables>;

/**
 * __useCreateArticle11ReceivedMutation__
 *
 * To run a mutation, you first call `useCreateArticle11ReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle11ReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticle11ReceivedMutation, { data, loading, error }] = useCreateArticle11ReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateArticle11ReceivedMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticle11ReceivedMutation, CreateArticle11ReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticle11ReceivedMutation, CreateArticle11ReceivedMutationVariables>(CreateArticle11ReceivedDocument, options);
      }
export type CreateArticle11ReceivedMutationHookResult = ReturnType<typeof useCreateArticle11ReceivedMutation>;
export type CreateArticle11ReceivedMutationResult = Apollo.MutationResult<CreateArticle11ReceivedMutation>;
export type CreateArticle11ReceivedMutationOptions = Apollo.BaseMutationOptions<CreateArticle11ReceivedMutation, CreateArticle11ReceivedMutationVariables>;
export const CreateArticle13NeededReceivedDocument = gql`
    mutation CreateArticle13NeededReceived($dto: CreateArticle13SupportNeededReceived!) {
  createArticle13SupportNeededReceived(dto: $dto) {
    id
  }
}
    `;
export type CreateArticle13NeededReceivedMutationFn = Apollo.MutationFunction<CreateArticle13NeededReceivedMutation, CreateArticle13NeededReceivedMutationVariables>;

/**
 * __useCreateArticle13NeededReceivedMutation__
 *
 * To run a mutation, you first call `useCreateArticle13NeededReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle13NeededReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticle13NeededReceivedMutation, { data, loading, error }] = useCreateArticle13NeededReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateArticle13NeededReceivedMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticle13NeededReceivedMutation, CreateArticle13NeededReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticle13NeededReceivedMutation, CreateArticle13NeededReceivedMutationVariables>(CreateArticle13NeededReceivedDocument, options);
      }
export type CreateArticle13NeededReceivedMutationHookResult = ReturnType<typeof useCreateArticle13NeededReceivedMutation>;
export type CreateArticle13NeededReceivedMutationResult = Apollo.MutationResult<CreateArticle13NeededReceivedMutation>;
export type CreateArticle13NeededReceivedMutationOptions = Apollo.BaseMutationOptions<CreateArticle13NeededReceivedMutation, CreateArticle13NeededReceivedMutationVariables>;
export const CreateArticle9NeededDocument = gql`
    mutation CreateArticle9Needed($dto: CreateArticle9SupportNeeded!) {
  createArticle9SupportNeeded(dto: $dto) {
    id
  }
}
    `;
export type CreateArticle9NeededMutationFn = Apollo.MutationFunction<CreateArticle9NeededMutation, CreateArticle9NeededMutationVariables>;

/**
 * __useCreateArticle9NeededMutation__
 *
 * To run a mutation, you first call `useCreateArticle9NeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle9NeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticle9NeededMutation, { data, loading, error }] = useCreateArticle9NeededMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateArticle9NeededMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticle9NeededMutation, CreateArticle9NeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticle9NeededMutation, CreateArticle9NeededMutationVariables>(CreateArticle9NeededDocument, options);
      }
export type CreateArticle9NeededMutationHookResult = ReturnType<typeof useCreateArticle9NeededMutation>;
export type CreateArticle9NeededMutationResult = Apollo.MutationResult<CreateArticle9NeededMutation>;
export type CreateArticle9NeededMutationOptions = Apollo.BaseMutationOptions<CreateArticle9NeededMutation, CreateArticle9NeededMutationVariables>;
export const CreateArticle9ReceivedDocument = gql`
    mutation CreateArticle9Received($dto: CreateArticle9SupportReceived!) {
  createArticle9SupportReceived(dto: $dto) {
    id
  }
}
    `;
export type CreateArticle9ReceivedMutationFn = Apollo.MutationFunction<CreateArticle9ReceivedMutation, CreateArticle9ReceivedMutationVariables>;

/**
 * __useCreateArticle9ReceivedMutation__
 *
 * To run a mutation, you first call `useCreateArticle9ReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticle9ReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticle9ReceivedMutation, { data, loading, error }] = useCreateArticle9ReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateArticle9ReceivedMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticle9ReceivedMutation, CreateArticle9ReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticle9ReceivedMutation, CreateArticle9ReceivedMutationVariables>(CreateArticle9ReceivedDocument, options);
      }
export type CreateArticle9ReceivedMutationHookResult = ReturnType<typeof useCreateArticle9ReceivedMutation>;
export type CreateArticle9ReceivedMutationResult = Apollo.MutationResult<CreateArticle9ReceivedMutation>;
export type CreateArticle9ReceivedMutationOptions = Apollo.BaseMutationOptions<CreateArticle9ReceivedMutation, CreateArticle9ReceivedMutationVariables>;
export const CreateExternalApplicationDocument = gql`
    mutation CreateExternalApplication($dto: UpdateExternalApplication!, $language: String!) {
  createExternalApplication(dto: $dto) {
    ...ExternalApplicationData
  }
}
    ${ExternalApplicationDataFragmentDoc}`;
export type CreateExternalApplicationMutationFn = Apollo.MutationFunction<CreateExternalApplicationMutation, CreateExternalApplicationMutationVariables>;

/**
 * __useCreateExternalApplicationMutation__
 *
 * To run a mutation, you first call `useCreateExternalApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalApplicationMutation, { data, loading, error }] = useCreateExternalApplicationMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateExternalApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalApplicationMutation, CreateExternalApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalApplicationMutation, CreateExternalApplicationMutationVariables>(CreateExternalApplicationDocument, options);
      }
export type CreateExternalApplicationMutationHookResult = ReturnType<typeof useCreateExternalApplicationMutation>;
export type CreateExternalApplicationMutationResult = Apollo.MutationResult<CreateExternalApplicationMutation>;
export type CreateExternalApplicationMutationOptions = Apollo.BaseMutationOptions<CreateExternalApplicationMutation, CreateExternalApplicationMutationVariables>;
export const CreateExternalSourceDocument = gql`
    mutation CreateExternalSource($dto: CreateExternalSource!, $language: String!) {
  createExternalSource(dto: $dto) {
    ...ExternalSourceData
  }
}
    ${ExternalSourceDataFragmentDoc}`;
export type CreateExternalSourceMutationFn = Apollo.MutationFunction<CreateExternalSourceMutation, CreateExternalSourceMutationVariables>;

/**
 * __useCreateExternalSourceMutation__
 *
 * To run a mutation, you first call `useCreateExternalSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalSourceMutation, { data, loading, error }] = useCreateExternalSourceMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateExternalSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalSourceMutation, CreateExternalSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalSourceMutation, CreateExternalSourceMutationVariables>(CreateExternalSourceDocument, options);
      }
export type CreateExternalSourceMutationHookResult = ReturnType<typeof useCreateExternalSourceMutation>;
export type CreateExternalSourceMutationResult = Apollo.MutationResult<CreateExternalSourceMutation>;
export type CreateExternalSourceMutationOptions = Apollo.BaseMutationOptions<CreateExternalSourceMutation, CreateExternalSourceMutationVariables>;
export const CreateIndicatorDocument = gql`
    mutation CreateIndicator($dto: CreateIndicator!) {
  createIndicator(dto: $dto) {
    id
    number
    name
    datasets {
      id
      code
      name
      numeratorDenominator
      guidanceDefinitions
      additionalRemarks
      comments
    }
  }
}
    `;
export type CreateIndicatorMutationFn = Apollo.MutationFunction<CreateIndicatorMutation, CreateIndicatorMutationVariables>;

/**
 * __useCreateIndicatorMutation__
 *
 * To run a mutation, you first call `useCreateIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndicatorMutation, { data, loading, error }] = useCreateIndicatorMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndicatorMutation, CreateIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndicatorMutation, CreateIndicatorMutationVariables>(CreateIndicatorDocument, options);
      }
export type CreateIndicatorMutationHookResult = ReturnType<typeof useCreateIndicatorMutation>;
export type CreateIndicatorMutationResult = Apollo.MutationResult<CreateIndicatorMutation>;
export type CreateIndicatorMutationOptions = Apollo.BaseMutationOptions<CreateIndicatorMutation, CreateIndicatorMutationVariables>;
export const CreateMeasureDocument = gql`
    mutation CreateMeasure($dto: CreateMeasure!) {
  createMeasure(dto: $dto) {
    id
    name
    lifetimeStart
    lifetimeEnd
    measureType
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    reportingPeriods {
      id
      name
      startYear
      endYear
    }
    periodData {
      reportingPeriod {
        id
      }
    }
  }
}
    `;
export type CreateMeasureMutationFn = Apollo.MutationFunction<CreateMeasureMutation, CreateMeasureMutationVariables>;

/**
 * __useCreateMeasureMutation__
 *
 * To run a mutation, you first call `useCreateMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasureMutation, { data, loading, error }] = useCreateMeasureMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateMeasureMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeasureMutation, CreateMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeasureMutation, CreateMeasureMutationVariables>(CreateMeasureDocument, options);
      }
export type CreateMeasureMutationHookResult = ReturnType<typeof useCreateMeasureMutation>;
export type CreateMeasureMutationResult = Apollo.MutationResult<CreateMeasureMutation>;
export type CreateMeasureMutationOptions = Apollo.BaseMutationOptions<CreateMeasureMutation, CreateMeasureMutationVariables>;
export const CreateMeasurePeriodDataDocument = gql`
    mutation CreateMeasurePeriodData($dto: CreateMeasurePeriodData!) {
  createMeasurePeriodData(dto: $dto) {
    id
    measure {
      id
    }
    reportingPeriod {
      id
      name
    }
    status
    sourceOfFunding
    realized
    investmentRsd
    investmentUsd
  }
}
    `;
export type CreateMeasurePeriodDataMutationFn = Apollo.MutationFunction<CreateMeasurePeriodDataMutation, CreateMeasurePeriodDataMutationVariables>;

/**
 * __useCreateMeasurePeriodDataMutation__
 *
 * To run a mutation, you first call `useCreateMeasurePeriodDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasurePeriodDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasurePeriodDataMutation, { data, loading, error }] = useCreateMeasurePeriodDataMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateMeasurePeriodDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeasurePeriodDataMutation, CreateMeasurePeriodDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeasurePeriodDataMutation, CreateMeasurePeriodDataMutationVariables>(CreateMeasurePeriodDataDocument, options);
      }
export type CreateMeasurePeriodDataMutationHookResult = ReturnType<typeof useCreateMeasurePeriodDataMutation>;
export type CreateMeasurePeriodDataMutationResult = Apollo.MutationResult<CreateMeasurePeriodDataMutation>;
export type CreateMeasurePeriodDataMutationOptions = Apollo.BaseMutationOptions<CreateMeasurePeriodDataMutation, CreateMeasurePeriodDataMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($dto: UpdateOrganization!, $language: String!) {
  createOrganization(dto: $dto) {
    ...OrganizationData
  }
}
    ${OrganizationDataFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreatePamDocument = gql`
    mutation CreatePam($dto: UpdatePolicyMeasure!) {
  createPolicyAndMeasure(dto: $dto) {
    id
  }
}
    `;
export type CreatePamMutationFn = Apollo.MutationFunction<CreatePamMutation, CreatePamMutationVariables>;

/**
 * __useCreatePamMutation__
 *
 * To run a mutation, you first call `useCreatePamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPamMutation, { data, loading, error }] = useCreatePamMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreatePamMutation(baseOptions?: Apollo.MutationHookOptions<CreatePamMutation, CreatePamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePamMutation, CreatePamMutationVariables>(CreatePamDocument, options);
      }
export type CreatePamMutationHookResult = ReturnType<typeof useCreatePamMutation>;
export type CreatePamMutationResult = Apollo.MutationResult<CreatePamMutation>;
export type CreatePamMutationOptions = Apollo.BaseMutationOptions<CreatePamMutation, CreatePamMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($dto: CreateUser!, $language: String!) {
  createUser(dto: $dto) {
    ...UserData
    groupMemberships {
      ...UserGroupData
    }
  }
}
    ${UserDataFragmentDoc}
${UserGroupDataFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CrfDocumentsDocument = gql`
    query CrfDocuments {
  crfDocuments {
    ...CrfDocumentData
  }
}
    ${CrfDocumentDataFragmentDoc}`;

/**
 * __useCrfDocumentsQuery__
 *
 * To run a query within a React component, call `useCrfDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrfDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrfDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrfDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<CrfDocumentsQuery, CrfDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrfDocumentsQuery, CrfDocumentsQueryVariables>(CrfDocumentsDocument, options);
      }
export function useCrfDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrfDocumentsQuery, CrfDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrfDocumentsQuery, CrfDocumentsQueryVariables>(CrfDocumentsDocument, options);
        }
export type CrfDocumentsQueryHookResult = ReturnType<typeof useCrfDocumentsQuery>;
export type CrfDocumentsLazyQueryHookResult = ReturnType<typeof useCrfDocumentsLazyQuery>;
export type CrfDocumentsQueryResult = Apollo.QueryResult<CrfDocumentsQuery, CrfDocumentsQueryVariables>;
export const CurrentUserDetailsDocument = gql`
    query CurrentUserDetails($language: String!) {
  currentUser {
    ...UserData
    groupMemberships {
      ...UserGroupData
    }
  }
}
    ${UserDataFragmentDoc}
${UserGroupDataFragmentDoc}`;

/**
 * __useCurrentUserDetailsQuery__
 *
 * To run a query within a React component, call `useCurrentUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserDetailsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCurrentUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<CurrentUserDetailsQuery, CurrentUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserDetailsQuery, CurrentUserDetailsQueryVariables>(CurrentUserDetailsDocument, options);
      }
export function useCurrentUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserDetailsQuery, CurrentUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserDetailsQuery, CurrentUserDetailsQueryVariables>(CurrentUserDetailsDocument, options);
        }
export type CurrentUserDetailsQueryHookResult = ReturnType<typeof useCurrentUserDetailsQuery>;
export type CurrentUserDetailsLazyQueryHookResult = ReturnType<typeof useCurrentUserDetailsLazyQuery>;
export type CurrentUserDetailsQueryResult = Apollo.QueryResult<CurrentUserDetailsQuery, CurrentUserDetailsQueryVariables>;
export const CurrentUserPingDocument = gql`
    query CurrentUserPing {
  currentUser {
    id
  }
}
    `;

/**
 * __useCurrentUserPingQuery__
 *
 * To run a query within a React component, call `useCurrentUserPingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPingQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPingQuery, CurrentUserPingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPingQuery, CurrentUserPingQueryVariables>(CurrentUserPingDocument, options);
      }
export function useCurrentUserPingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPingQuery, CurrentUserPingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPingQuery, CurrentUserPingQueryVariables>(CurrentUserPingDocument, options);
        }
export type CurrentUserPingQueryHookResult = ReturnType<typeof useCurrentUserPingQuery>;
export type CurrentUserPingLazyQueryHookResult = ReturnType<typeof useCurrentUserPingLazyQuery>;
export type CurrentUserPingQueryResult = Apollo.QueryResult<CurrentUserPingQuery, CurrentUserPingQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    username
    authorities
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DataCollectionListDocument = gql`
    query DataCollectionList($language: String!, $year: Int!) {
  dataCollectionTemplates(year: $year) {
    ...DataCollectionTemplateData
    documents(year: $year) {
      ...DataCollectionDocumentData
    }
  }
}
    ${DataCollectionTemplateDataFragmentDoc}
${DataCollectionDocumentDataFragmentDoc}`;

/**
 * __useDataCollectionListQuery__
 *
 * To run a query within a React component, call `useDataCollectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCollectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCollectionListQuery({
 *   variables: {
 *      language: // value for 'language'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDataCollectionListQuery(baseOptions: Apollo.QueryHookOptions<DataCollectionListQuery, DataCollectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataCollectionListQuery, DataCollectionListQueryVariables>(DataCollectionListDocument, options);
      }
export function useDataCollectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataCollectionListQuery, DataCollectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataCollectionListQuery, DataCollectionListQueryVariables>(DataCollectionListDocument, options);
        }
export type DataCollectionListQueryHookResult = ReturnType<typeof useDataCollectionListQuery>;
export type DataCollectionListLazyQueryHookResult = ReturnType<typeof useDataCollectionListLazyQuery>;
export type DataCollectionListQueryResult = Apollo.QueryResult<DataCollectionListQuery, DataCollectionListQueryVariables>;
export const DataCollectionTemplateListDocument = gql`
    query DataCollectionTemplateList($year: Int, $language: String!) {
  dataCollectionTemplates(year: $year) {
    ...DataCollectionTemplateData
  }
}
    ${DataCollectionTemplateDataFragmentDoc}`;

/**
 * __useDataCollectionTemplateListQuery__
 *
 * To run a query within a React component, call `useDataCollectionTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCollectionTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCollectionTemplateListQuery({
 *   variables: {
 *      year: // value for 'year'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useDataCollectionTemplateListQuery(baseOptions: Apollo.QueryHookOptions<DataCollectionTemplateListQuery, DataCollectionTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataCollectionTemplateListQuery, DataCollectionTemplateListQueryVariables>(DataCollectionTemplateListDocument, options);
      }
export function useDataCollectionTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataCollectionTemplateListQuery, DataCollectionTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataCollectionTemplateListQuery, DataCollectionTemplateListQueryVariables>(DataCollectionTemplateListDocument, options);
        }
export type DataCollectionTemplateListQueryHookResult = ReturnType<typeof useDataCollectionTemplateListQuery>;
export type DataCollectionTemplateListLazyQueryHookResult = ReturnType<typeof useDataCollectionTemplateListLazyQuery>;
export type DataCollectionTemplateListQueryResult = Apollo.QueryResult<DataCollectionTemplateListQuery, DataCollectionTemplateListQueryVariables>;
export const DataCollectionYearsDocument = gql`
    query DataCollectionYears {
  dataCollectionYears {
    id
    year
    yearLocked
    lastModifiedBy
    lastModifiedDate
  }
}
    `;

/**
 * __useDataCollectionYearsQuery__
 *
 * To run a query within a React component, call `useDataCollectionYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCollectionYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCollectionYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataCollectionYearsQuery(baseOptions?: Apollo.QueryHookOptions<DataCollectionYearsQuery, DataCollectionYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataCollectionYearsQuery, DataCollectionYearsQueryVariables>(DataCollectionYearsDocument, options);
      }
export function useDataCollectionYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataCollectionYearsQuery, DataCollectionYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataCollectionYearsQuery, DataCollectionYearsQueryVariables>(DataCollectionYearsDocument, options);
        }
export type DataCollectionYearsQueryHookResult = ReturnType<typeof useDataCollectionYearsQuery>;
export type DataCollectionYearsLazyQueryHookResult = ReturnType<typeof useDataCollectionYearsLazyQuery>;
export type DataCollectionYearsQueryResult = Apollo.QueryResult<DataCollectionYearsQuery, DataCollectionYearsQueryVariables>;
export const DeleteArticle9SupportNeededDocument = gql`
    mutation DeleteArticle9SupportNeeded($id: ID!) {
  deleteArticle9SupportNeeded(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type DeleteArticle9SupportNeededMutationFn = Apollo.MutationFunction<DeleteArticle9SupportNeededMutation, DeleteArticle9SupportNeededMutationVariables>;

/**
 * __useDeleteArticle9SupportNeededMutation__
 *
 * To run a mutation, you first call `useDeleteArticle9SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle9SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticle9SupportNeededMutation, { data, loading, error }] = useDeleteArticle9SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticle9SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticle9SupportNeededMutation, DeleteArticle9SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticle9SupportNeededMutation, DeleteArticle9SupportNeededMutationVariables>(DeleteArticle9SupportNeededDocument, options);
      }
export type DeleteArticle9SupportNeededMutationHookResult = ReturnType<typeof useDeleteArticle9SupportNeededMutation>;
export type DeleteArticle9SupportNeededMutationResult = Apollo.MutationResult<DeleteArticle9SupportNeededMutation>;
export type DeleteArticle9SupportNeededMutationOptions = Apollo.BaseMutationOptions<DeleteArticle9SupportNeededMutation, DeleteArticle9SupportNeededMutationVariables>;
export const DeleteArticle9SupportReceivedDocument = gql`
    mutation DeleteArticle9SupportReceived($id: ID!) {
  deleteArticle9SupportReceived(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type DeleteArticle9SupportReceivedMutationFn = Apollo.MutationFunction<DeleteArticle9SupportReceivedMutation, DeleteArticle9SupportReceivedMutationVariables>;

/**
 * __useDeleteArticle9SupportReceivedMutation__
 *
 * To run a mutation, you first call `useDeleteArticle9SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle9SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticle9SupportReceivedMutation, { data, loading, error }] = useDeleteArticle9SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticle9SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticle9SupportReceivedMutation, DeleteArticle9SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticle9SupportReceivedMutation, DeleteArticle9SupportReceivedMutationVariables>(DeleteArticle9SupportReceivedDocument, options);
      }
export type DeleteArticle9SupportReceivedMutationHookResult = ReturnType<typeof useDeleteArticle9SupportReceivedMutation>;
export type DeleteArticle9SupportReceivedMutationResult = Apollo.MutationResult<DeleteArticle9SupportReceivedMutation>;
export type DeleteArticle9SupportReceivedMutationOptions = Apollo.BaseMutationOptions<DeleteArticle9SupportReceivedMutation, DeleteArticle9SupportReceivedMutationVariables>;
export const DeleteArticle10SupportNeededDocument = gql`
    mutation DeleteArticle10SupportNeeded($id: ID!) {
  deleteArticle10SupportNeeded(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type DeleteArticle10SupportNeededMutationFn = Apollo.MutationFunction<DeleteArticle10SupportNeededMutation, DeleteArticle10SupportNeededMutationVariables>;

/**
 * __useDeleteArticle10SupportNeededMutation__
 *
 * To run a mutation, you first call `useDeleteArticle10SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle10SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticle10SupportNeededMutation, { data, loading, error }] = useDeleteArticle10SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticle10SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticle10SupportNeededMutation, DeleteArticle10SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticle10SupportNeededMutation, DeleteArticle10SupportNeededMutationVariables>(DeleteArticle10SupportNeededDocument, options);
      }
export type DeleteArticle10SupportNeededMutationHookResult = ReturnType<typeof useDeleteArticle10SupportNeededMutation>;
export type DeleteArticle10SupportNeededMutationResult = Apollo.MutationResult<DeleteArticle10SupportNeededMutation>;
export type DeleteArticle10SupportNeededMutationOptions = Apollo.BaseMutationOptions<DeleteArticle10SupportNeededMutation, DeleteArticle10SupportNeededMutationVariables>;
export const DeleteArticle10SupportReceivedDocument = gql`
    mutation DeleteArticle10SupportReceived($id: ID!) {
  deleteArticle10SupportReceived(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type DeleteArticle10SupportReceivedMutationFn = Apollo.MutationFunction<DeleteArticle10SupportReceivedMutation, DeleteArticle10SupportReceivedMutationVariables>;

/**
 * __useDeleteArticle10SupportReceivedMutation__
 *
 * To run a mutation, you first call `useDeleteArticle10SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle10SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticle10SupportReceivedMutation, { data, loading, error }] = useDeleteArticle10SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticle10SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticle10SupportReceivedMutation, DeleteArticle10SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticle10SupportReceivedMutation, DeleteArticle10SupportReceivedMutationVariables>(DeleteArticle10SupportReceivedDocument, options);
      }
export type DeleteArticle10SupportReceivedMutationHookResult = ReturnType<typeof useDeleteArticle10SupportReceivedMutation>;
export type DeleteArticle10SupportReceivedMutationResult = Apollo.MutationResult<DeleteArticle10SupportReceivedMutation>;
export type DeleteArticle10SupportReceivedMutationOptions = Apollo.BaseMutationOptions<DeleteArticle10SupportReceivedMutation, DeleteArticle10SupportReceivedMutationVariables>;
export const DeleteArticle11SupportNeededDocument = gql`
    mutation DeleteArticle11SupportNeeded($id: ID!) {
  deleteArticle11SupportNeeded(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type DeleteArticle11SupportNeededMutationFn = Apollo.MutationFunction<DeleteArticle11SupportNeededMutation, DeleteArticle11SupportNeededMutationVariables>;

/**
 * __useDeleteArticle11SupportNeededMutation__
 *
 * To run a mutation, you first call `useDeleteArticle11SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle11SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticle11SupportNeededMutation, { data, loading, error }] = useDeleteArticle11SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticle11SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticle11SupportNeededMutation, DeleteArticle11SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticle11SupportNeededMutation, DeleteArticle11SupportNeededMutationVariables>(DeleteArticle11SupportNeededDocument, options);
      }
export type DeleteArticle11SupportNeededMutationHookResult = ReturnType<typeof useDeleteArticle11SupportNeededMutation>;
export type DeleteArticle11SupportNeededMutationResult = Apollo.MutationResult<DeleteArticle11SupportNeededMutation>;
export type DeleteArticle11SupportNeededMutationOptions = Apollo.BaseMutationOptions<DeleteArticle11SupportNeededMutation, DeleteArticle11SupportNeededMutationVariables>;
export const DeleteArticle11SupportReceivedDocument = gql`
    mutation DeleteArticle11SupportReceived($id: ID!) {
  deleteArticle11SupportReceived(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type DeleteArticle11SupportReceivedMutationFn = Apollo.MutationFunction<DeleteArticle11SupportReceivedMutation, DeleteArticle11SupportReceivedMutationVariables>;

/**
 * __useDeleteArticle11SupportReceivedMutation__
 *
 * To run a mutation, you first call `useDeleteArticle11SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle11SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticle11SupportReceivedMutation, { data, loading, error }] = useDeleteArticle11SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticle11SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticle11SupportReceivedMutation, DeleteArticle11SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticle11SupportReceivedMutation, DeleteArticle11SupportReceivedMutationVariables>(DeleteArticle11SupportReceivedDocument, options);
      }
export type DeleteArticle11SupportReceivedMutationHookResult = ReturnType<typeof useDeleteArticle11SupportReceivedMutation>;
export type DeleteArticle11SupportReceivedMutationResult = Apollo.MutationResult<DeleteArticle11SupportReceivedMutation>;
export type DeleteArticle11SupportReceivedMutationOptions = Apollo.BaseMutationOptions<DeleteArticle11SupportReceivedMutation, DeleteArticle11SupportReceivedMutationVariables>;
export const DeleteArticle13SupportNeededReceivedDocument = gql`
    mutation DeleteArticle13SupportNeededReceived($id: ID!) {
  deleteArticle13SupportNeededReceived(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type DeleteArticle13SupportNeededReceivedMutationFn = Apollo.MutationFunction<DeleteArticle13SupportNeededReceivedMutation, DeleteArticle13SupportNeededReceivedMutationVariables>;

/**
 * __useDeleteArticle13SupportNeededReceivedMutation__
 *
 * To run a mutation, you first call `useDeleteArticle13SupportNeededReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticle13SupportNeededReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticle13SupportNeededReceivedMutation, { data, loading, error }] = useDeleteArticle13SupportNeededReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticle13SupportNeededReceivedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticle13SupportNeededReceivedMutation, DeleteArticle13SupportNeededReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticle13SupportNeededReceivedMutation, DeleteArticle13SupportNeededReceivedMutationVariables>(DeleteArticle13SupportNeededReceivedDocument, options);
      }
export type DeleteArticle13SupportNeededReceivedMutationHookResult = ReturnType<typeof useDeleteArticle13SupportNeededReceivedMutation>;
export type DeleteArticle13SupportNeededReceivedMutationResult = Apollo.MutationResult<DeleteArticle13SupportNeededReceivedMutation>;
export type DeleteArticle13SupportNeededReceivedMutationOptions = Apollo.BaseMutationOptions<DeleteArticle13SupportNeededReceivedMutation, DeleteArticle13SupportNeededReceivedMutationVariables>;
export const DeleteExternalApplicationDocument = gql`
    mutation DeleteExternalApplication($id: ID!) {
  deleteExternalApplication(id: $id) {
    id
  }
}
    `;
export type DeleteExternalApplicationMutationFn = Apollo.MutationFunction<DeleteExternalApplicationMutation, DeleteExternalApplicationMutationVariables>;

/**
 * __useDeleteExternalApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteExternalApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalApplicationMutation, { data, loading, error }] = useDeleteExternalApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExternalApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExternalApplicationMutation, DeleteExternalApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExternalApplicationMutation, DeleteExternalApplicationMutationVariables>(DeleteExternalApplicationDocument, options);
      }
export type DeleteExternalApplicationMutationHookResult = ReturnType<typeof useDeleteExternalApplicationMutation>;
export type DeleteExternalApplicationMutationResult = Apollo.MutationResult<DeleteExternalApplicationMutation>;
export type DeleteExternalApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteExternalApplicationMutation, DeleteExternalApplicationMutationVariables>;
export const DeleteExternalSourceDocument = gql`
    mutation DeleteExternalSource($sourceId: ID!, $language: String!) {
  deleteExternalSource(sourceId: $sourceId) {
    ...ExternalSourceData
  }
}
    ${ExternalSourceDataFragmentDoc}`;
export type DeleteExternalSourceMutationFn = Apollo.MutationFunction<DeleteExternalSourceMutation, DeleteExternalSourceMutationVariables>;

/**
 * __useDeleteExternalSourceMutation__
 *
 * To run a mutation, you first call `useDeleteExternalSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalSourceMutation, { data, loading, error }] = useDeleteExternalSourceMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useDeleteExternalSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExternalSourceMutation, DeleteExternalSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExternalSourceMutation, DeleteExternalSourceMutationVariables>(DeleteExternalSourceDocument, options);
      }
export type DeleteExternalSourceMutationHookResult = ReturnType<typeof useDeleteExternalSourceMutation>;
export type DeleteExternalSourceMutationResult = Apollo.MutationResult<DeleteExternalSourceMutation>;
export type DeleteExternalSourceMutationOptions = Apollo.BaseMutationOptions<DeleteExternalSourceMutation, DeleteExternalSourceMutationVariables>;
export const DeleteIndicatorDocument = gql`
    mutation DeleteIndicator($id: ID!) {
  deleteIndicator(id: $id) {
    id
  }
}
    `;
export type DeleteIndicatorMutationFn = Apollo.MutationFunction<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>;

/**
 * __useDeleteIndicatorMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorMutation, { data, loading, error }] = useDeleteIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>(DeleteIndicatorDocument, options);
      }
export type DeleteIndicatorMutationHookResult = ReturnType<typeof useDeleteIndicatorMutation>;
export type DeleteIndicatorMutationResult = Apollo.MutationResult<DeleteIndicatorMutation>;
export type DeleteIndicatorMutationOptions = Apollo.BaseMutationOptions<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>;
export const DeleteInfoDocumentDocument = gql`
    mutation DeleteInfoDocument($documentId: ID!, $language: String!) {
  deleteInfoDocument(documentId: $documentId) {
    ...InfoDocumentData
  }
}
    ${InfoDocumentDataFragmentDoc}`;
export type DeleteInfoDocumentMutationFn = Apollo.MutationFunction<DeleteInfoDocumentMutation, DeleteInfoDocumentMutationVariables>;

/**
 * __useDeleteInfoDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteInfoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInfoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInfoDocumentMutation, { data, loading, error }] = useDeleteInfoDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useDeleteInfoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInfoDocumentMutation, DeleteInfoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInfoDocumentMutation, DeleteInfoDocumentMutationVariables>(DeleteInfoDocumentDocument, options);
      }
export type DeleteInfoDocumentMutationHookResult = ReturnType<typeof useDeleteInfoDocumentMutation>;
export type DeleteInfoDocumentMutationResult = Apollo.MutationResult<DeleteInfoDocumentMutation>;
export type DeleteInfoDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteInfoDocumentMutation, DeleteInfoDocumentMutationVariables>;
export const DeleteMeasureDocument = gql`
    mutation DeleteMeasure($id: ID!) {
  deleteMeasure(id: $id) {
    id
  }
}
    `;
export type DeleteMeasureMutationFn = Apollo.MutationFunction<DeleteMeasureMutation, DeleteMeasureMutationVariables>;

/**
 * __useDeleteMeasureMutation__
 *
 * To run a mutation, you first call `useDeleteMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeasureMutation, { data, loading, error }] = useDeleteMeasureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMeasureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMeasureMutation, DeleteMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMeasureMutation, DeleteMeasureMutationVariables>(DeleteMeasureDocument, options);
      }
export type DeleteMeasureMutationHookResult = ReturnType<typeof useDeleteMeasureMutation>;
export type DeleteMeasureMutationResult = Apollo.MutationResult<DeleteMeasureMutation>;
export type DeleteMeasureMutationOptions = Apollo.BaseMutationOptions<DeleteMeasureMutation, DeleteMeasureMutationVariables>;
export const DeletePamDocument = gql`
    mutation DeletePam($id: ID!) {
  deletePolicyAndMeasure(id: $id) {
    id
  }
}
    `;
export type DeletePamMutationFn = Apollo.MutationFunction<DeletePamMutation, DeletePamMutationVariables>;

/**
 * __useDeletePamMutation__
 *
 * To run a mutation, you first call `useDeletePamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePamMutation, { data, loading, error }] = useDeletePamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePamMutation(baseOptions?: Apollo.MutationHookOptions<DeletePamMutation, DeletePamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePamMutation, DeletePamMutationVariables>(DeletePamDocument, options);
      }
export type DeletePamMutationHookResult = ReturnType<typeof useDeletePamMutation>;
export type DeletePamMutationResult = Apollo.MutationResult<DeletePamMutation>;
export type DeletePamMutationOptions = Apollo.BaseMutationOptions<DeletePamMutation, DeletePamMutationVariables>;
export const DeleteSharedDocumentDocument = gql`
    mutation DeleteSharedDocument($documentId: ID!) {
  deleteSharedDocument(documentId: $documentId)
}
    `;
export type DeleteSharedDocumentMutationFn = Apollo.MutationFunction<DeleteSharedDocumentMutation, DeleteSharedDocumentMutationVariables>;

/**
 * __useDeleteSharedDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteSharedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharedDocumentMutation, { data, loading, error }] = useDeleteSharedDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteSharedDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSharedDocumentMutation, DeleteSharedDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSharedDocumentMutation, DeleteSharedDocumentMutationVariables>(DeleteSharedDocumentDocument, options);
      }
export type DeleteSharedDocumentMutationHookResult = ReturnType<typeof useDeleteSharedDocumentMutation>;
export type DeleteSharedDocumentMutationResult = Apollo.MutationResult<DeleteSharedDocumentMutation>;
export type DeleteSharedDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteSharedDocumentMutation, DeleteSharedDocumentMutationVariables>;
export const ExternalApplicationDocument = gql`
    query ExternalApplication($id: ID!, $language: String!) {
  externalApplication(id: $id) {
    ...ExternalApplicationData
  }
}
    ${ExternalApplicationDataFragmentDoc}`;

/**
 * __useExternalApplicationQuery__
 *
 * To run a query within a React component, call `useExternalApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useExternalApplicationQuery(baseOptions: Apollo.QueryHookOptions<ExternalApplicationQuery, ExternalApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalApplicationQuery, ExternalApplicationQueryVariables>(ExternalApplicationDocument, options);
      }
export function useExternalApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalApplicationQuery, ExternalApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalApplicationQuery, ExternalApplicationQueryVariables>(ExternalApplicationDocument, options);
        }
export type ExternalApplicationQueryHookResult = ReturnType<typeof useExternalApplicationQuery>;
export type ExternalApplicationLazyQueryHookResult = ReturnType<typeof useExternalApplicationLazyQuery>;
export type ExternalApplicationQueryResult = Apollo.QueryResult<ExternalApplicationQuery, ExternalApplicationQueryVariables>;
export const ExternalApplicationsDocument = gql`
    query ExternalApplications($language: String!) {
  externalApplications {
    ...ExternalApplicationData
  }
}
    ${ExternalApplicationDataFragmentDoc}`;

/**
 * __useExternalApplicationsQuery__
 *
 * To run a query within a React component, call `useExternalApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalApplicationsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useExternalApplicationsQuery(baseOptions: Apollo.QueryHookOptions<ExternalApplicationsQuery, ExternalApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalApplicationsQuery, ExternalApplicationsQueryVariables>(ExternalApplicationsDocument, options);
      }
export function useExternalApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalApplicationsQuery, ExternalApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalApplicationsQuery, ExternalApplicationsQueryVariables>(ExternalApplicationsDocument, options);
        }
export type ExternalApplicationsQueryHookResult = ReturnType<typeof useExternalApplicationsQuery>;
export type ExternalApplicationsLazyQueryHookResult = ReturnType<typeof useExternalApplicationsLazyQuery>;
export type ExternalApplicationsQueryResult = Apollo.QueryResult<ExternalApplicationsQuery, ExternalApplicationsQueryVariables>;
export const ExternalSourcesDocument = gql`
    query ExternalSources($scope: ExternalSourceScope!, $language: String!) {
  externalSources(scope: $scope) {
    ...ExternalSourceData
  }
}
    ${ExternalSourceDataFragmentDoc}`;

/**
 * __useExternalSourcesQuery__
 *
 * To run a query within a React component, call `useExternalSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalSourcesQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useExternalSourcesQuery(baseOptions: Apollo.QueryHookOptions<ExternalSourcesQuery, ExternalSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalSourcesQuery, ExternalSourcesQueryVariables>(ExternalSourcesDocument, options);
      }
export function useExternalSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalSourcesQuery, ExternalSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalSourcesQuery, ExternalSourcesQueryVariables>(ExternalSourcesDocument, options);
        }
export type ExternalSourcesQueryHookResult = ReturnType<typeof useExternalSourcesQuery>;
export type ExternalSourcesLazyQueryHookResult = ReturnType<typeof useExternalSourcesLazyQuery>;
export type ExternalSourcesQueryResult = Apollo.QueryResult<ExternalSourcesQuery, ExternalSourcesQueryVariables>;
export const GhgCategoriesDocument = gql`
    query GhgCategories($language: String!) {
  ghgCategories {
    ...GhgCategoryData
  }
}
    ${GhgCategoryDataFragmentDoc}`;

/**
 * __useGhgCategoriesQuery__
 *
 * To run a query within a React component, call `useGhgCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhgCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhgCategoriesQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGhgCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GhgCategoriesQuery, GhgCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhgCategoriesQuery, GhgCategoriesQueryVariables>(GhgCategoriesDocument, options);
      }
export function useGhgCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhgCategoriesQuery, GhgCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhgCategoriesQuery, GhgCategoriesQueryVariables>(GhgCategoriesDocument, options);
        }
export type GhgCategoriesQueryHookResult = ReturnType<typeof useGhgCategoriesQuery>;
export type GhgCategoriesLazyQueryHookResult = ReturnType<typeof useGhgCategoriesLazyQuery>;
export type GhgCategoriesQueryResult = Apollo.QueryResult<GhgCategoriesQuery, GhgCategoriesQueryVariables>;
export const GhgSectorsDocument = gql`
    query GhgSectors($language: String!) {
  ghgSectors {
    ...GhgSectorData
  }
}
    ${GhgSectorDataFragmentDoc}`;

/**
 * __useGhgSectorsQuery__
 *
 * To run a query within a React component, call `useGhgSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhgSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhgSectorsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGhgSectorsQuery(baseOptions: Apollo.QueryHookOptions<GhgSectorsQuery, GhgSectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhgSectorsQuery, GhgSectorsQueryVariables>(GhgSectorsDocument, options);
      }
export function useGhgSectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhgSectorsQuery, GhgSectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhgSectorsQuery, GhgSectorsQueryVariables>(GhgSectorsDocument, options);
        }
export type GhgSectorsQueryHookResult = ReturnType<typeof useGhgSectorsQuery>;
export type GhgSectorsLazyQueryHookResult = ReturnType<typeof useGhgSectorsLazyQuery>;
export type GhgSectorsQueryResult = Apollo.QueryResult<GhgSectorsQuery, GhgSectorsQueryVariables>;
export const GhgValueRangeDocument = gql`
    query GhgValueRange {
  ghgValueRange {
    ...GhgValueRangeData
  }
}
    ${GhgValueRangeDataFragmentDoc}`;

/**
 * __useGhgValueRangeQuery__
 *
 * To run a query within a React component, call `useGhgValueRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhgValueRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhgValueRangeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGhgValueRangeQuery(baseOptions?: Apollo.QueryHookOptions<GhgValueRangeQuery, GhgValueRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhgValueRangeQuery, GhgValueRangeQueryVariables>(GhgValueRangeDocument, options);
      }
export function useGhgValueRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhgValueRangeQuery, GhgValueRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhgValueRangeQuery, GhgValueRangeQueryVariables>(GhgValueRangeDocument, options);
        }
export type GhgValueRangeQueryHookResult = ReturnType<typeof useGhgValueRangeQuery>;
export type GhgValueRangeLazyQueryHookResult = ReturnType<typeof useGhgValueRangeLazyQuery>;
export type GhgValueRangeQueryResult = Apollo.QueryResult<GhgValueRangeQuery, GhgValueRangeQueryVariables>;
export const GhgValuesDocument = gql`
    query GhgValues($filter: GhgValueFilter) {
  ghgValues(filter: $filter) {
    ...GhgValueData
  }
}
    ${GhgValueDataFragmentDoc}`;

/**
 * __useGhgValuesQuery__
 *
 * To run a query within a React component, call `useGhgValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhgValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhgValuesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGhgValuesQuery(baseOptions?: Apollo.QueryHookOptions<GhgValuesQuery, GhgValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhgValuesQuery, GhgValuesQueryVariables>(GhgValuesDocument, options);
      }
export function useGhgValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhgValuesQuery, GhgValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhgValuesQuery, GhgValuesQueryVariables>(GhgValuesDocument, options);
        }
export type GhgValuesQueryHookResult = ReturnType<typeof useGhgValuesQuery>;
export type GhgValuesLazyQueryHookResult = ReturnType<typeof useGhgValuesLazyQuery>;
export type GhgValuesQueryResult = Apollo.QueryResult<GhgValuesQuery, GhgValuesQueryVariables>;
export const IndicatorDataViewerDocument = gql`
    query IndicatorDataViewer($filter: IndicatorsFilterDTO, $valueFilter: IndicatorDatasetValuesFilterDTO) {
  indicators(filter: $filter) {
    id
    number
    name
    datasets {
      id
      code
      name
      numeratorDenominator
      guidanceDefinitions
      additionalRemarks
      comments
      crfSourceSector {
        id
      }
      crfSourceCategory {
        id
      }
      values(filter: $valueFilter) {
        id
        year
        value
      }
    }
  }
}
    `;

/**
 * __useIndicatorDataViewerQuery__
 *
 * To run a query within a React component, call `useIndicatorDataViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorDataViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorDataViewerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      valueFilter: // value for 'valueFilter'
 *   },
 * });
 */
export function useIndicatorDataViewerQuery(baseOptions?: Apollo.QueryHookOptions<IndicatorDataViewerQuery, IndicatorDataViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorDataViewerQuery, IndicatorDataViewerQueryVariables>(IndicatorDataViewerDocument, options);
      }
export function useIndicatorDataViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorDataViewerQuery, IndicatorDataViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorDataViewerQuery, IndicatorDataViewerQueryVariables>(IndicatorDataViewerDocument, options);
        }
export type IndicatorDataViewerQueryHookResult = ReturnType<typeof useIndicatorDataViewerQuery>;
export type IndicatorDataViewerLazyQueryHookResult = ReturnType<typeof useIndicatorDataViewerLazyQuery>;
export type IndicatorDataViewerQueryResult = Apollo.QueryResult<IndicatorDataViewerQuery, IndicatorDataViewerQueryVariables>;
export const IndicatorDatasetDocument = gql`
    query indicatorDataset($id: ID!, $valueFilter: IndicatorDatasetValuesFilterDTO) {
  dataset(id: $id) {
    id
    code
    name
    numeratorDenominator
    indicator {
      id
      number
      name
    }
    values(filter: $valueFilter) {
      id
      year
      value
    }
  }
}
    `;

/**
 * __useIndicatorDatasetQuery__
 *
 * To run a query within a React component, call `useIndicatorDatasetQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorDatasetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorDatasetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      valueFilter: // value for 'valueFilter'
 *   },
 * });
 */
export function useIndicatorDatasetQuery(baseOptions: Apollo.QueryHookOptions<IndicatorDatasetQuery, IndicatorDatasetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorDatasetQuery, IndicatorDatasetQueryVariables>(IndicatorDatasetDocument, options);
      }
export function useIndicatorDatasetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorDatasetQuery, IndicatorDatasetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorDatasetQuery, IndicatorDatasetQueryVariables>(IndicatorDatasetDocument, options);
        }
export type IndicatorDatasetQueryHookResult = ReturnType<typeof useIndicatorDatasetQuery>;
export type IndicatorDatasetLazyQueryHookResult = ReturnType<typeof useIndicatorDatasetLazyQuery>;
export type IndicatorDatasetQueryResult = Apollo.QueryResult<IndicatorDatasetQuery, IndicatorDatasetQueryVariables>;
export const IndicatorListDocument = gql`
    query IndicatorList($filter: IndicatorsFilterDTO) {
  indicators(filter: $filter) {
    id
    number
    name
    category
    datasets {
      id
      code
      name
      numeratorDenominator
      crfSourceSector {
        id
      }
      crfSourceCategory {
        id
      }
    }
  }
}
    `;

/**
 * __useIndicatorListQuery__
 *
 * To run a query within a React component, call `useIndicatorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIndicatorListQuery(baseOptions?: Apollo.QueryHookOptions<IndicatorListQuery, IndicatorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorListQuery, IndicatorListQueryVariables>(IndicatorListDocument, options);
      }
export function useIndicatorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorListQuery, IndicatorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorListQuery, IndicatorListQueryVariables>(IndicatorListDocument, options);
        }
export type IndicatorListQueryHookResult = ReturnType<typeof useIndicatorListQuery>;
export type IndicatorListLazyQueryHookResult = ReturnType<typeof useIndicatorListLazyQuery>;
export type IndicatorListQueryResult = Apollo.QueryResult<IndicatorListQuery, IndicatorListQueryVariables>;
export const InfoDocumentsDocument = gql`
    query InfoDocuments($scope: InfoDocumentScope!, $language: String!) {
  infoDocuments(scope: $scope) {
    ...InfoDocumentData
  }
}
    ${InfoDocumentDataFragmentDoc}`;

/**
 * __useInfoDocumentsQuery__
 *
 * To run a query within a React component, call `useInfoDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoDocumentsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useInfoDocumentsQuery(baseOptions: Apollo.QueryHookOptions<InfoDocumentsQuery, InfoDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoDocumentsQuery, InfoDocumentsQueryVariables>(InfoDocumentsDocument, options);
      }
export function useInfoDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoDocumentsQuery, InfoDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoDocumentsQuery, InfoDocumentsQueryVariables>(InfoDocumentsDocument, options);
        }
export type InfoDocumentsQueryHookResult = ReturnType<typeof useInfoDocumentsQuery>;
export type InfoDocumentsLazyQueryHookResult = ReturnType<typeof useInfoDocumentsLazyQuery>;
export type InfoDocumentsQueryResult = Apollo.QueryResult<InfoDocumentsQuery, InfoDocumentsQueryVariables>;
export const IntroductionTextDocument = gql`
    query IntroductionText {
  headerTranslation: translation(key: INTRODUCTION_HEADER) {
    ...TranslationItemData
  }
  textTranslation: translation(key: INTRODUCTION_TEXT) {
    ...TranslationItemData
  }
}
    ${TranslationItemDataFragmentDoc}`;

/**
 * __useIntroductionTextQuery__
 *
 * To run a query within a React component, call `useIntroductionTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntroductionTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntroductionTextQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntroductionTextQuery(baseOptions?: Apollo.QueryHookOptions<IntroductionTextQuery, IntroductionTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntroductionTextQuery, IntroductionTextQueryVariables>(IntroductionTextDocument, options);
      }
export function useIntroductionTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntroductionTextQuery, IntroductionTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntroductionTextQuery, IntroductionTextQueryVariables>(IntroductionTextDocument, options);
        }
export type IntroductionTextQueryHookResult = ReturnType<typeof useIntroductionTextQuery>;
export type IntroductionTextLazyQueryHookResult = ReturnType<typeof useIntroductionTextLazyQuery>;
export type IntroductionTextQueryResult = Apollo.QueryResult<IntroductionTextQuery, IntroductionTextQueryVariables>;
export const MeasureDetailsDocument = gql`
    query MeasureDetails($id: ID!) {
  measure(id: $id) {
    id
    reportingInMrv
    name
    objective
    description
    territorialCoverage
    measureType
    lifetimeStart
    lifetimeEnd
    legalAndPolicyBasis
    implementationPhases
    problemsAndBarriers
    expectedImprovements
    achievedResults
    responsibilityFor
    publicConsultationProcess
    totalExpectedInvestmentRsd
    totalExpectedInvestmentUsd
    expectedSourceOfFunding
    linkToOtherMeasures
    indicators
    linkz
    extensionOfMeasure
    otherBenefits
    impactOnGhgEmissions
    lossesAndDamages
    extremeEvents
    climateChangeImpacts
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __useMeasureDetailsQuery__
 *
 * To run a query within a React component, call `useMeasureDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasureDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasureDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeasureDetailsQuery(baseOptions: Apollo.QueryHookOptions<MeasureDetailsQuery, MeasureDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeasureDetailsQuery, MeasureDetailsQueryVariables>(MeasureDetailsDocument, options);
      }
export function useMeasureDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeasureDetailsQuery, MeasureDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeasureDetailsQuery, MeasureDetailsQueryVariables>(MeasureDetailsDocument, options);
        }
export type MeasureDetailsQueryHookResult = ReturnType<typeof useMeasureDetailsQuery>;
export type MeasureDetailsLazyQueryHookResult = ReturnType<typeof useMeasureDetailsLazyQuery>;
export type MeasureDetailsQueryResult = Apollo.QueryResult<MeasureDetailsQuery, MeasureDetailsQueryVariables>;
export const MeasurePeriodDataDetailsDocument = gql`
    query MeasurePeriodDataDetails($id: ID!) {
  measurePeriodData(id: $id) {
    id
    measure {
      id
    }
    reportingPeriod {
      id
      name
    }
    status
    sourceOfFunding
    realized
    investmentRsd
    investmentUsd
  }
}
    `;

/**
 * __useMeasurePeriodDataDetailsQuery__
 *
 * To run a query within a React component, call `useMeasurePeriodDataDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasurePeriodDataDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasurePeriodDataDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeasurePeriodDataDetailsQuery(baseOptions: Apollo.QueryHookOptions<MeasurePeriodDataDetailsQuery, MeasurePeriodDataDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeasurePeriodDataDetailsQuery, MeasurePeriodDataDetailsQueryVariables>(MeasurePeriodDataDetailsDocument, options);
      }
export function useMeasurePeriodDataDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeasurePeriodDataDetailsQuery, MeasurePeriodDataDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeasurePeriodDataDetailsQuery, MeasurePeriodDataDetailsQueryVariables>(MeasurePeriodDataDetailsDocument, options);
        }
export type MeasurePeriodDataDetailsQueryHookResult = ReturnType<typeof useMeasurePeriodDataDetailsQuery>;
export type MeasurePeriodDataDetailsLazyQueryHookResult = ReturnType<typeof useMeasurePeriodDataDetailsLazyQuery>;
export type MeasurePeriodDataDetailsQueryResult = Apollo.QueryResult<MeasurePeriodDataDetailsQuery, MeasurePeriodDataDetailsQueryVariables>;
export const MeasureStatisticsDocument = gql`
    query MeasureStatistics($onlyApproved: Boolean) {
  measureStatistics(onlyApproved: $onlyApproved) {
    totalAmount
    amountPerTerritorialCoverage {
      territorialCoverage
      amount
    }
  }
}
    `;

/**
 * __useMeasureStatisticsQuery__
 *
 * To run a query within a React component, call `useMeasureStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasureStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasureStatisticsQuery({
 *   variables: {
 *      onlyApproved: // value for 'onlyApproved'
 *   },
 * });
 */
export function useMeasureStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<MeasureStatisticsQuery, MeasureStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeasureStatisticsQuery, MeasureStatisticsQueryVariables>(MeasureStatisticsDocument, options);
      }
export function useMeasureStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeasureStatisticsQuery, MeasureStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeasureStatisticsQuery, MeasureStatisticsQueryVariables>(MeasureStatisticsDocument, options);
        }
export type MeasureStatisticsQueryHookResult = ReturnType<typeof useMeasureStatisticsQuery>;
export type MeasureStatisticsLazyQueryHookResult = ReturnType<typeof useMeasureStatisticsLazyQuery>;
export type MeasureStatisticsQueryResult = Apollo.QueryResult<MeasureStatisticsQuery, MeasureStatisticsQueryVariables>;
export const MeasuresListDocument = gql`
    query MeasuresList($filter: MeasuresQueryFilter) {
  measures(filter: $filter) {
    id
    name
    lifetimeStart
    lifetimeEnd
    measureType
    totalExpectedInvestmentRsd
    totalExpectedInvestmentUsd
    ndcRelevant
    ncRelevant
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    reportingPeriods {
      id
      name
      startYear
      endYear
    }
    periodData {
      id
      investmentRsd
      investmentUsd
      reportingPeriod {
        id
        name
        startYear
        endYear
      }
    }
  }
}
    `;

/**
 * __useMeasuresListQuery__
 *
 * To run a query within a React component, call `useMeasuresListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasuresListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasuresListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMeasuresListQuery(baseOptions?: Apollo.QueryHookOptions<MeasuresListQuery, MeasuresListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeasuresListQuery, MeasuresListQueryVariables>(MeasuresListDocument, options);
      }
export function useMeasuresListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeasuresListQuery, MeasuresListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeasuresListQuery, MeasuresListQueryVariables>(MeasuresListDocument, options);
        }
export type MeasuresListQueryHookResult = ReturnType<typeof useMeasuresListQuery>;
export type MeasuresListLazyQueryHookResult = ReturnType<typeof useMeasuresListLazyQuery>;
export type MeasuresListQueryResult = Apollo.QueryResult<MeasuresListQuery, MeasuresListQueryVariables>;
export const ModuleVisibilityDocument = gql`
    query ModuleVisibility {
  moduleVisibilities {
    id
    scope
    parentScope
    publiclyVisible
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;

/**
 * __useModuleVisibilityQuery__
 *
 * To run a query within a React component, call `useModuleVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleVisibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useModuleVisibilityQuery(baseOptions?: Apollo.QueryHookOptions<ModuleVisibilityQuery, ModuleVisibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleVisibilityQuery, ModuleVisibilityQueryVariables>(ModuleVisibilityDocument, options);
      }
export function useModuleVisibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleVisibilityQuery, ModuleVisibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleVisibilityQuery, ModuleVisibilityQueryVariables>(ModuleVisibilityDocument, options);
        }
export type ModuleVisibilityQueryHookResult = ReturnType<typeof useModuleVisibilityQuery>;
export type ModuleVisibilityLazyQueryHookResult = ReturnType<typeof useModuleVisibilityLazyQuery>;
export type ModuleVisibilityQueryResult = Apollo.QueryResult<ModuleVisibilityQuery, ModuleVisibilityQueryVariables>;
export const NdcChartDocument = gql`
    query NdcChart($sectorCode: String!, $targetFilter: NdcTargetFilter, $language: String!) {
  ghgSectorByCode(code: $sectorCode) {
    ...GhgSectorData
    values(filter: {categoryCodes: ["totals"]}) {
      ...GhgValueData
    }
  }
  ndcTargets(filter: $targetFilter) {
    ...NdcTargetData
    targetValues {
      ...NdcTargetValueData
    }
  }
  scenarios {
    ...ScenarioData
    values(filter: {sectorCodes: [$sectorCode]}) {
      ...ProjectionValueData
    }
  }
}
    ${GhgSectorDataFragmentDoc}
${GhgValueDataFragmentDoc}
${NdcTargetDataFragmentDoc}
${NdcTargetValueDataFragmentDoc}
${ScenarioDataFragmentDoc}
${ProjectionValueDataFragmentDoc}`;

/**
 * __useNdcChartQuery__
 *
 * To run a query within a React component, call `useNdcChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useNdcChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNdcChartQuery({
 *   variables: {
 *      sectorCode: // value for 'sectorCode'
 *      targetFilter: // value for 'targetFilter'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useNdcChartQuery(baseOptions: Apollo.QueryHookOptions<NdcChartQuery, NdcChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NdcChartQuery, NdcChartQueryVariables>(NdcChartDocument, options);
      }
export function useNdcChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NdcChartQuery, NdcChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NdcChartQuery, NdcChartQueryVariables>(NdcChartDocument, options);
        }
export type NdcChartQueryHookResult = ReturnType<typeof useNdcChartQuery>;
export type NdcChartLazyQueryHookResult = ReturnType<typeof useNdcChartLazyQuery>;
export type NdcChartQueryResult = Apollo.QueryResult<NdcChartQuery, NdcChartQueryVariables>;
export const NdcTargetsDocument = gql`
    query NdcTargets($language: String!, $filter: NdcTargetFilter) {
  ndcTargets(filter: $filter) {
    ...NdcTargetData
    ghgSector {
      ...GhgSectorData
    }
  }
}
    ${NdcTargetDataFragmentDoc}
${GhgSectorDataFragmentDoc}`;

/**
 * __useNdcTargetsQuery__
 *
 * To run a query within a React component, call `useNdcTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNdcTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNdcTargetsQuery({
 *   variables: {
 *      language: // value for 'language'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNdcTargetsQuery(baseOptions: Apollo.QueryHookOptions<NdcTargetsQuery, NdcTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NdcTargetsQuery, NdcTargetsQueryVariables>(NdcTargetsDocument, options);
      }
export function useNdcTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NdcTargetsQuery, NdcTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NdcTargetsQuery, NdcTargetsQueryVariables>(NdcTargetsDocument, options);
        }
export type NdcTargetsQueryHookResult = ReturnType<typeof useNdcTargetsQuery>;
export type NdcTargetsLazyQueryHookResult = ReturnType<typeof useNdcTargetsLazyQuery>;
export type NdcTargetsQueryResult = Apollo.QueryResult<NdcTargetsQuery, NdcTargetsQueryVariables>;
export const NdcTargetsWithValuesDocument = gql`
    query NdcTargetsWithValues($language: String!, $filter: NdcTargetFilter) {
  ndcTargets(filter: $filter) {
    ...NdcTargetData
    targetValues {
      ...NdcTargetValueData
    }
  }
}
    ${NdcTargetDataFragmentDoc}
${NdcTargetValueDataFragmentDoc}`;

/**
 * __useNdcTargetsWithValuesQuery__
 *
 * To run a query within a React component, call `useNdcTargetsWithValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNdcTargetsWithValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNdcTargetsWithValuesQuery({
 *   variables: {
 *      language: // value for 'language'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNdcTargetsWithValuesQuery(baseOptions: Apollo.QueryHookOptions<NdcTargetsWithValuesQuery, NdcTargetsWithValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NdcTargetsWithValuesQuery, NdcTargetsWithValuesQueryVariables>(NdcTargetsWithValuesDocument, options);
      }
export function useNdcTargetsWithValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NdcTargetsWithValuesQuery, NdcTargetsWithValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NdcTargetsWithValuesQuery, NdcTargetsWithValuesQueryVariables>(NdcTargetsWithValuesDocument, options);
        }
export type NdcTargetsWithValuesQueryHookResult = ReturnType<typeof useNdcTargetsWithValuesQuery>;
export type NdcTargetsWithValuesLazyQueryHookResult = ReturnType<typeof useNdcTargetsWithValuesLazyQuery>;
export type NdcTargetsWithValuesQueryResult = Apollo.QueryResult<NdcTargetsWithValuesQuery, NdcTargetsWithValuesQueryVariables>;
export const OrganizationsDocument = gql`
    query Organizations($language: String!) {
  organizations {
    ...OrganizationData
  }
}
    ${OrganizationDataFragmentDoc}`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a React component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
      }
export function useOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
        }
export type OrganizationsQueryHookResult = ReturnType<typeof useOrganizationsQuery>;
export type OrganizationsLazyQueryHookResult = ReturnType<typeof useOrganizationsLazyQuery>;
export type OrganizationsQueryResult = Apollo.QueryResult<OrganizationsQuery, OrganizationsQueryVariables>;
export const PamDetailsDocument = gql`
    query PamDetails($id: ID!) {
  policyAndMeasure(id: $id) {
    ...PamData
  }
}
    ${PamDataFragmentDoc}`;

/**
 * __usePamDetailsQuery__
 *
 * To run a query within a React component, call `usePamDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePamDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePamDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePamDetailsQuery(baseOptions: Apollo.QueryHookOptions<PamDetailsQuery, PamDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PamDetailsQuery, PamDetailsQueryVariables>(PamDetailsDocument, options);
      }
export function usePamDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PamDetailsQuery, PamDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PamDetailsQuery, PamDetailsQueryVariables>(PamDetailsDocument, options);
        }
export type PamDetailsQueryHookResult = ReturnType<typeof usePamDetailsQuery>;
export type PamDetailsLazyQueryHookResult = ReturnType<typeof usePamDetailsLazyQuery>;
export type PamDetailsQueryResult = Apollo.QueryResult<PamDetailsQuery, PamDetailsQueryVariables>;
export const PamListDocument = gql`
    query PamList($filter: PolicyMeasureFilter) {
  policiesAndMeasures(filter: $filter) {
    id
    pamNumber
    name
    shortDescription
    implementationStatus
    ndcRelevant
    ncRelevant
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;

/**
 * __usePamListQuery__
 *
 * To run a query within a React component, call `usePamListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePamListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePamListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePamListQuery(baseOptions?: Apollo.QueryHookOptions<PamListQuery, PamListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PamListQuery, PamListQueryVariables>(PamListDocument, options);
      }
export function usePamListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PamListQuery, PamListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PamListQuery, PamListQueryVariables>(PamListDocument, options);
        }
export type PamListQueryHookResult = ReturnType<typeof usePamListQuery>;
export type PamListLazyQueryHookResult = ReturnType<typeof usePamListLazyQuery>;
export type PamListQueryResult = Apollo.QueryResult<PamListQuery, PamListQueryVariables>;
export const PamObjectivesListDocument = gql`
    query PamObjectivesList($language: String!) {
  pamObjectives {
    id
    code
    preferredTranslation(preferredLanguage: $language) {
      ...TranslatedTextData
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
    ${TranslatedTextDataFragmentDoc}`;

/**
 * __usePamObjectivesListQuery__
 *
 * To run a query within a React component, call `usePamObjectivesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePamObjectivesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePamObjectivesListQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePamObjectivesListQuery(baseOptions: Apollo.QueryHookOptions<PamObjectivesListQuery, PamObjectivesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PamObjectivesListQuery, PamObjectivesListQueryVariables>(PamObjectivesListDocument, options);
      }
export function usePamObjectivesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PamObjectivesListQuery, PamObjectivesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PamObjectivesListQuery, PamObjectivesListQueryVariables>(PamObjectivesListDocument, options);
        }
export type PamObjectivesListQueryHookResult = ReturnType<typeof usePamObjectivesListQuery>;
export type PamObjectivesListLazyQueryHookResult = ReturnType<typeof usePamObjectivesListLazyQuery>;
export type PamObjectivesListQueryResult = Apollo.QueryResult<PamObjectivesListQuery, PamObjectivesListQueryVariables>;
export const PamStatisticsDocument = gql`
    query PamStatistics($onlyApproved: Boolean) {
  pamStatistics(onlyApproved: $onlyApproved) {
    totalAmount
    amountPerStatus {
      status
      amount
    }
  }
}
    `;

/**
 * __usePamStatisticsQuery__
 *
 * To run a query within a React component, call `usePamStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePamStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePamStatisticsQuery({
 *   variables: {
 *      onlyApproved: // value for 'onlyApproved'
 *   },
 * });
 */
export function usePamStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<PamStatisticsQuery, PamStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PamStatisticsQuery, PamStatisticsQueryVariables>(PamStatisticsDocument, options);
      }
export function usePamStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PamStatisticsQuery, PamStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PamStatisticsQuery, PamStatisticsQueryVariables>(PamStatisticsDocument, options);
        }
export type PamStatisticsQueryHookResult = ReturnType<typeof usePamStatisticsQuery>;
export type PamStatisticsLazyQueryHookResult = ReturnType<typeof usePamStatisticsLazyQuery>;
export type PamStatisticsQueryResult = Apollo.QueryResult<PamStatisticsQuery, PamStatisticsQueryVariables>;
export const PamUnionPoliciesListDocument = gql`
    query PamUnionPoliciesList($language: String!) {
  pamUnionPolicies {
    id
    preferredTranslation(preferredLanguage: $language) {
      ...TranslatedTextData
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
    ${TranslatedTextDataFragmentDoc}`;

/**
 * __usePamUnionPoliciesListQuery__
 *
 * To run a query within a React component, call `usePamUnionPoliciesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePamUnionPoliciesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePamUnionPoliciesListQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePamUnionPoliciesListQuery(baseOptions: Apollo.QueryHookOptions<PamUnionPoliciesListQuery, PamUnionPoliciesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PamUnionPoliciesListQuery, PamUnionPoliciesListQueryVariables>(PamUnionPoliciesListDocument, options);
      }
export function usePamUnionPoliciesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PamUnionPoliciesListQuery, PamUnionPoliciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PamUnionPoliciesListQuery, PamUnionPoliciesListQueryVariables>(PamUnionPoliciesListDocument, options);
        }
export type PamUnionPoliciesListQueryHookResult = ReturnType<typeof usePamUnionPoliciesListQuery>;
export type PamUnionPoliciesListLazyQueryHookResult = ReturnType<typeof usePamUnionPoliciesListLazyQuery>;
export type PamUnionPoliciesListQueryResult = Apollo.QueryResult<PamUnionPoliciesListQuery, PamUnionPoliciesListQueryVariables>;
export const ProjectionDocumentsDocument = gql`
    query ProjectionDocuments {
  projectionDocuments {
    ...ProjectionDocumentData
  }
}
    ${ProjectionDocumentDataFragmentDoc}`;

/**
 * __useProjectionDocumentsQuery__
 *
 * To run a query within a React component, call `useProjectionDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectionDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectionDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectionDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectionDocumentsQuery, ProjectionDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectionDocumentsQuery, ProjectionDocumentsQueryVariables>(ProjectionDocumentsDocument, options);
      }
export function useProjectionDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectionDocumentsQuery, ProjectionDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectionDocumentsQuery, ProjectionDocumentsQueryVariables>(ProjectionDocumentsDocument, options);
        }
export type ProjectionDocumentsQueryHookResult = ReturnType<typeof useProjectionDocumentsQuery>;
export type ProjectionDocumentsLazyQueryHookResult = ReturnType<typeof useProjectionDocumentsLazyQuery>;
export type ProjectionDocumentsQueryResult = Apollo.QueryResult<ProjectionDocumentsQuery, ProjectionDocumentsQueryVariables>;
export const ProjectionValuesDocument = gql`
    query ProjectionValues($filter: ProjectionValueFilter) {
  projectionValues(filter: $filter) {
    ...ProjectionValueData
  }
}
    ${ProjectionValueDataFragmentDoc}`;

/**
 * __useProjectionValuesQuery__
 *
 * To run a query within a React component, call `useProjectionValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectionValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectionValuesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProjectionValuesQuery(baseOptions?: Apollo.QueryHookOptions<ProjectionValuesQuery, ProjectionValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectionValuesQuery, ProjectionValuesQueryVariables>(ProjectionValuesDocument, options);
      }
export function useProjectionValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectionValuesQuery, ProjectionValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectionValuesQuery, ProjectionValuesQueryVariables>(ProjectionValuesDocument, options);
        }
export type ProjectionValuesQueryHookResult = ReturnType<typeof useProjectionValuesQuery>;
export type ProjectionValuesLazyQueryHookResult = ReturnType<typeof useProjectionValuesLazyQuery>;
export type ProjectionValuesQueryResult = Apollo.QueryResult<ProjectionValuesQuery, ProjectionValuesQueryVariables>;
export const PublicAvailabilityDocument = gql`
    query PublicAvailability {
  publicAvailability {
    externalSources {
      scope
      available
    }
    infoDocuments {
      scope
      available
    }
    modules {
      scope
      available
    }
  }
}
    `;

/**
 * __usePublicAvailabilityQuery__
 *
 * To run a query within a React component, call `usePublicAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<PublicAvailabilityQuery, PublicAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicAvailabilityQuery, PublicAvailabilityQueryVariables>(PublicAvailabilityDocument, options);
      }
export function usePublicAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicAvailabilityQuery, PublicAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicAvailabilityQuery, PublicAvailabilityQueryVariables>(PublicAvailabilityDocument, options);
        }
export type PublicAvailabilityQueryHookResult = ReturnType<typeof usePublicAvailabilityQuery>;
export type PublicAvailabilityLazyQueryHookResult = ReturnType<typeof usePublicAvailabilityLazyQuery>;
export type PublicAvailabilityQueryResult = Apollo.QueryResult<PublicAvailabilityQuery, PublicAvailabilityQueryVariables>;
export const PublicExternalSourcesDocument = gql`
    query PublicExternalSources($scope: ExternalSourceScope!, $language: String!) {
  publicExternalSources(scope: $scope) {
    ...PublicExternalSourceData
  }
}
    ${PublicExternalSourceDataFragmentDoc}`;

/**
 * __usePublicExternalSourcesQuery__
 *
 * To run a query within a React component, call `usePublicExternalSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicExternalSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicExternalSourcesQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePublicExternalSourcesQuery(baseOptions: Apollo.QueryHookOptions<PublicExternalSourcesQuery, PublicExternalSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicExternalSourcesQuery, PublicExternalSourcesQueryVariables>(PublicExternalSourcesDocument, options);
      }
export function usePublicExternalSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicExternalSourcesQuery, PublicExternalSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicExternalSourcesQuery, PublicExternalSourcesQueryVariables>(PublicExternalSourcesDocument, options);
        }
export type PublicExternalSourcesQueryHookResult = ReturnType<typeof usePublicExternalSourcesQuery>;
export type PublicExternalSourcesLazyQueryHookResult = ReturnType<typeof usePublicExternalSourcesLazyQuery>;
export type PublicExternalSourcesQueryResult = Apollo.QueryResult<PublicExternalSourcesQuery, PublicExternalSourcesQueryVariables>;
export const PublicInfoDocumentsDocument = gql`
    query PublicInfoDocuments($scope: InfoDocumentScope!, $language: String!) {
  publicInfoDocuments(scope: $scope) {
    ...PublicInfoDocumentData
  }
}
    ${PublicInfoDocumentDataFragmentDoc}`;

/**
 * __usePublicInfoDocumentsQuery__
 *
 * To run a query within a React component, call `usePublicInfoDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicInfoDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicInfoDocumentsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePublicInfoDocumentsQuery(baseOptions: Apollo.QueryHookOptions<PublicInfoDocumentsQuery, PublicInfoDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicInfoDocumentsQuery, PublicInfoDocumentsQueryVariables>(PublicInfoDocumentsDocument, options);
      }
export function usePublicInfoDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicInfoDocumentsQuery, PublicInfoDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicInfoDocumentsQuery, PublicInfoDocumentsQueryVariables>(PublicInfoDocumentsDocument, options);
        }
export type PublicInfoDocumentsQueryHookResult = ReturnType<typeof usePublicInfoDocumentsQuery>;
export type PublicInfoDocumentsLazyQueryHookResult = ReturnType<typeof usePublicInfoDocumentsLazyQuery>;
export type PublicInfoDocumentsQueryResult = Apollo.QueryResult<PublicInfoDocumentsQuery, PublicInfoDocumentsQueryVariables>;
export const PublicPamDetailsDocument = gql`
    query PublicPamDetails($id: ID!, $language: String!) {
  policyAndMeasure(id: $id) {
    ...PamData
    objectives {
      id
      preferredTranslation(preferredLanguage: $language) {
        ...TranslatedTextData
      }
    }
    relatedUnionPolicy {
      id
      preferredTranslation(preferredLanguage: $language) {
        ...TranslatedTextData
      }
    }
    sdgImpact {
      id
      preferredTranslation(preferredLanguage: $language) {
        ...TranslatedTextData
      }
    }
  }
}
    ${PamDataFragmentDoc}
${TranslatedTextDataFragmentDoc}`;

/**
 * __usePublicPamDetailsQuery__
 *
 * To run a query within a React component, call `usePublicPamDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPamDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPamDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePublicPamDetailsQuery(baseOptions: Apollo.QueryHookOptions<PublicPamDetailsQuery, PublicPamDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicPamDetailsQuery, PublicPamDetailsQueryVariables>(PublicPamDetailsDocument, options);
      }
export function usePublicPamDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicPamDetailsQuery, PublicPamDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicPamDetailsQuery, PublicPamDetailsQueryVariables>(PublicPamDetailsDocument, options);
        }
export type PublicPamDetailsQueryHookResult = ReturnType<typeof usePublicPamDetailsQuery>;
export type PublicPamDetailsLazyQueryHookResult = ReturnType<typeof usePublicPamDetailsLazyQuery>;
export type PublicPamDetailsQueryResult = Apollo.QueryResult<PublicPamDetailsQuery, PublicPamDetailsQueryVariables>;
export const RefuseArticle9SupportNeededDocument = gql`
    mutation RefuseArticle9SupportNeeded($id: ID!) {
  refuseArticle9SupportNeeded(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseArticle9SupportNeededMutationFn = Apollo.MutationFunction<RefuseArticle9SupportNeededMutation, RefuseArticle9SupportNeededMutationVariables>;

/**
 * __useRefuseArticle9SupportNeededMutation__
 *
 * To run a mutation, you first call `useRefuseArticle9SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseArticle9SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseArticle9SupportNeededMutation, { data, loading, error }] = useRefuseArticle9SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseArticle9SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<RefuseArticle9SupportNeededMutation, RefuseArticle9SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseArticle9SupportNeededMutation, RefuseArticle9SupportNeededMutationVariables>(RefuseArticle9SupportNeededDocument, options);
      }
export type RefuseArticle9SupportNeededMutationHookResult = ReturnType<typeof useRefuseArticle9SupportNeededMutation>;
export type RefuseArticle9SupportNeededMutationResult = Apollo.MutationResult<RefuseArticle9SupportNeededMutation>;
export type RefuseArticle9SupportNeededMutationOptions = Apollo.BaseMutationOptions<RefuseArticle9SupportNeededMutation, RefuseArticle9SupportNeededMutationVariables>;
export const RefuseArticle9SupportReceivedDocument = gql`
    mutation RefuseArticle9SupportReceived($id: ID!) {
  refuseArticle9SupportReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseArticle9SupportReceivedMutationFn = Apollo.MutationFunction<RefuseArticle9SupportReceivedMutation, RefuseArticle9SupportReceivedMutationVariables>;

/**
 * __useRefuseArticle9SupportReceivedMutation__
 *
 * To run a mutation, you first call `useRefuseArticle9SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseArticle9SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseArticle9SupportReceivedMutation, { data, loading, error }] = useRefuseArticle9SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseArticle9SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<RefuseArticle9SupportReceivedMutation, RefuseArticle9SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseArticle9SupportReceivedMutation, RefuseArticle9SupportReceivedMutationVariables>(RefuseArticle9SupportReceivedDocument, options);
      }
export type RefuseArticle9SupportReceivedMutationHookResult = ReturnType<typeof useRefuseArticle9SupportReceivedMutation>;
export type RefuseArticle9SupportReceivedMutationResult = Apollo.MutationResult<RefuseArticle9SupportReceivedMutation>;
export type RefuseArticle9SupportReceivedMutationOptions = Apollo.BaseMutationOptions<RefuseArticle9SupportReceivedMutation, RefuseArticle9SupportReceivedMutationVariables>;
export const RefuseArticle10SupportNeededDocument = gql`
    mutation RefuseArticle10SupportNeeded($id: ID!) {
  refuseArticle10SupportNeeded(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseArticle10SupportNeededMutationFn = Apollo.MutationFunction<RefuseArticle10SupportNeededMutation, RefuseArticle10SupportNeededMutationVariables>;

/**
 * __useRefuseArticle10SupportNeededMutation__
 *
 * To run a mutation, you first call `useRefuseArticle10SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseArticle10SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseArticle10SupportNeededMutation, { data, loading, error }] = useRefuseArticle10SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseArticle10SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<RefuseArticle10SupportNeededMutation, RefuseArticle10SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseArticle10SupportNeededMutation, RefuseArticle10SupportNeededMutationVariables>(RefuseArticle10SupportNeededDocument, options);
      }
export type RefuseArticle10SupportNeededMutationHookResult = ReturnType<typeof useRefuseArticle10SupportNeededMutation>;
export type RefuseArticle10SupportNeededMutationResult = Apollo.MutationResult<RefuseArticle10SupportNeededMutation>;
export type RefuseArticle10SupportNeededMutationOptions = Apollo.BaseMutationOptions<RefuseArticle10SupportNeededMutation, RefuseArticle10SupportNeededMutationVariables>;
export const RefuseArticle10SupportReceivedDocument = gql`
    mutation RefuseArticle10SupportReceived($id: ID!) {
  refuseArticle10SupportReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseArticle10SupportReceivedMutationFn = Apollo.MutationFunction<RefuseArticle10SupportReceivedMutation, RefuseArticle10SupportReceivedMutationVariables>;

/**
 * __useRefuseArticle10SupportReceivedMutation__
 *
 * To run a mutation, you first call `useRefuseArticle10SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseArticle10SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseArticle10SupportReceivedMutation, { data, loading, error }] = useRefuseArticle10SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseArticle10SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<RefuseArticle10SupportReceivedMutation, RefuseArticle10SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseArticle10SupportReceivedMutation, RefuseArticle10SupportReceivedMutationVariables>(RefuseArticle10SupportReceivedDocument, options);
      }
export type RefuseArticle10SupportReceivedMutationHookResult = ReturnType<typeof useRefuseArticle10SupportReceivedMutation>;
export type RefuseArticle10SupportReceivedMutationResult = Apollo.MutationResult<RefuseArticle10SupportReceivedMutation>;
export type RefuseArticle10SupportReceivedMutationOptions = Apollo.BaseMutationOptions<RefuseArticle10SupportReceivedMutation, RefuseArticle10SupportReceivedMutationVariables>;
export const RefuseArticle11SupportNeededDocument = gql`
    mutation RefuseArticle11SupportNeeded($id: ID!) {
  refuseArticle11SupportNeeded(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseArticle11SupportNeededMutationFn = Apollo.MutationFunction<RefuseArticle11SupportNeededMutation, RefuseArticle11SupportNeededMutationVariables>;

/**
 * __useRefuseArticle11SupportNeededMutation__
 *
 * To run a mutation, you first call `useRefuseArticle11SupportNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseArticle11SupportNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseArticle11SupportNeededMutation, { data, loading, error }] = useRefuseArticle11SupportNeededMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseArticle11SupportNeededMutation(baseOptions?: Apollo.MutationHookOptions<RefuseArticle11SupportNeededMutation, RefuseArticle11SupportNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseArticle11SupportNeededMutation, RefuseArticle11SupportNeededMutationVariables>(RefuseArticle11SupportNeededDocument, options);
      }
export type RefuseArticle11SupportNeededMutationHookResult = ReturnType<typeof useRefuseArticle11SupportNeededMutation>;
export type RefuseArticle11SupportNeededMutationResult = Apollo.MutationResult<RefuseArticle11SupportNeededMutation>;
export type RefuseArticle11SupportNeededMutationOptions = Apollo.BaseMutationOptions<RefuseArticle11SupportNeededMutation, RefuseArticle11SupportNeededMutationVariables>;
export const RefuseArticle11SupportReceivedDocument = gql`
    mutation RefuseArticle11SupportReceived($id: ID!) {
  refuseArticle11SupportReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseArticle11SupportReceivedMutationFn = Apollo.MutationFunction<RefuseArticle11SupportReceivedMutation, RefuseArticle11SupportReceivedMutationVariables>;

/**
 * __useRefuseArticle11SupportReceivedMutation__
 *
 * To run a mutation, you first call `useRefuseArticle11SupportReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseArticle11SupportReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseArticle11SupportReceivedMutation, { data, loading, error }] = useRefuseArticle11SupportReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseArticle11SupportReceivedMutation(baseOptions?: Apollo.MutationHookOptions<RefuseArticle11SupportReceivedMutation, RefuseArticle11SupportReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseArticle11SupportReceivedMutation, RefuseArticle11SupportReceivedMutationVariables>(RefuseArticle11SupportReceivedDocument, options);
      }
export type RefuseArticle11SupportReceivedMutationHookResult = ReturnType<typeof useRefuseArticle11SupportReceivedMutation>;
export type RefuseArticle11SupportReceivedMutationResult = Apollo.MutationResult<RefuseArticle11SupportReceivedMutation>;
export type RefuseArticle11SupportReceivedMutationOptions = Apollo.BaseMutationOptions<RefuseArticle11SupportReceivedMutation, RefuseArticle11SupportReceivedMutationVariables>;
export const RefuseArticle13SupportNeededReceivedDocument = gql`
    mutation RefuseArticle13SupportNeededReceived($id: ID!) {
  refuseArticle13SupportNeededReceived(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseArticle13SupportNeededReceivedMutationFn = Apollo.MutationFunction<RefuseArticle13SupportNeededReceivedMutation, RefuseArticle13SupportNeededReceivedMutationVariables>;

/**
 * __useRefuseArticle13SupportNeededReceivedMutation__
 *
 * To run a mutation, you first call `useRefuseArticle13SupportNeededReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseArticle13SupportNeededReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseArticle13SupportNeededReceivedMutation, { data, loading, error }] = useRefuseArticle13SupportNeededReceivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseArticle13SupportNeededReceivedMutation(baseOptions?: Apollo.MutationHookOptions<RefuseArticle13SupportNeededReceivedMutation, RefuseArticle13SupportNeededReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseArticle13SupportNeededReceivedMutation, RefuseArticle13SupportNeededReceivedMutationVariables>(RefuseArticle13SupportNeededReceivedDocument, options);
      }
export type RefuseArticle13SupportNeededReceivedMutationHookResult = ReturnType<typeof useRefuseArticle13SupportNeededReceivedMutation>;
export type RefuseArticle13SupportNeededReceivedMutationResult = Apollo.MutationResult<RefuseArticle13SupportNeededReceivedMutation>;
export type RefuseArticle13SupportNeededReceivedMutationOptions = Apollo.BaseMutationOptions<RefuseArticle13SupportNeededReceivedMutation, RefuseArticle13SupportNeededReceivedMutationVariables>;
export const RefuseDataCollectionDocumentDocument = gql`
    mutation RefuseDataCollectionDocument($id: ID!) {
  refuseDataCollectionDocument(id: $id) {
    id
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;
export type RefuseDataCollectionDocumentMutationFn = Apollo.MutationFunction<RefuseDataCollectionDocumentMutation, RefuseDataCollectionDocumentMutationVariables>;

/**
 * __useRefuseDataCollectionDocumentMutation__
 *
 * To run a mutation, you first call `useRefuseDataCollectionDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseDataCollectionDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseDataCollectionDocumentMutation, { data, loading, error }] = useRefuseDataCollectionDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseDataCollectionDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RefuseDataCollectionDocumentMutation, RefuseDataCollectionDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseDataCollectionDocumentMutation, RefuseDataCollectionDocumentMutationVariables>(RefuseDataCollectionDocumentDocument, options);
      }
export type RefuseDataCollectionDocumentMutationHookResult = ReturnType<typeof useRefuseDataCollectionDocumentMutation>;
export type RefuseDataCollectionDocumentMutationResult = Apollo.MutationResult<RefuseDataCollectionDocumentMutation>;
export type RefuseDataCollectionDocumentMutationOptions = Apollo.BaseMutationOptions<RefuseDataCollectionDocumentMutation, RefuseDataCollectionDocumentMutationVariables>;
export const RefuseMeasureDocument = gql`
    mutation RefuseMeasure($id: ID!) {
  refuseMeasure(id: $id) {
    id
    approvedBy
    approvedDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type RefuseMeasureMutationFn = Apollo.MutationFunction<RefuseMeasureMutation, RefuseMeasureMutationVariables>;

/**
 * __useRefuseMeasureMutation__
 *
 * To run a mutation, you first call `useRefuseMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefuseMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refuseMeasureMutation, { data, loading, error }] = useRefuseMeasureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefuseMeasureMutation(baseOptions?: Apollo.MutationHookOptions<RefuseMeasureMutation, RefuseMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefuseMeasureMutation, RefuseMeasureMutationVariables>(RefuseMeasureDocument, options);
      }
export type RefuseMeasureMutationHookResult = ReturnType<typeof useRefuseMeasureMutation>;
export type RefuseMeasureMutationResult = Apollo.MutationResult<RefuseMeasureMutation>;
export type RefuseMeasureMutationOptions = Apollo.BaseMutationOptions<RefuseMeasureMutation, RefuseMeasureMutationVariables>;
export const RefusePolicyAndMeasureDocument = gql`
    mutation RefusePolicyAndMeasure($id: ID!) {
  refusePolicyAndMeasure(id: $id) {
    ...PamData
  }
}
    ${PamDataFragmentDoc}`;
export type RefusePolicyAndMeasureMutationFn = Apollo.MutationFunction<RefusePolicyAndMeasureMutation, RefusePolicyAndMeasureMutationVariables>;

/**
 * __useRefusePolicyAndMeasureMutation__
 *
 * To run a mutation, you first call `useRefusePolicyAndMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefusePolicyAndMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refusePolicyAndMeasureMutation, { data, loading, error }] = useRefusePolicyAndMeasureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefusePolicyAndMeasureMutation(baseOptions?: Apollo.MutationHookOptions<RefusePolicyAndMeasureMutation, RefusePolicyAndMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefusePolicyAndMeasureMutation, RefusePolicyAndMeasureMutationVariables>(RefusePolicyAndMeasureDocument, options);
      }
export type RefusePolicyAndMeasureMutationHookResult = ReturnType<typeof useRefusePolicyAndMeasureMutation>;
export type RefusePolicyAndMeasureMutationResult = Apollo.MutationResult<RefusePolicyAndMeasureMutation>;
export type RefusePolicyAndMeasureMutationOptions = Apollo.BaseMutationOptions<RefusePolicyAndMeasureMutation, RefusePolicyAndMeasureMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($username: String!) {
  resetPassword(username: $username)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ScenarioChartDocument = gql`
    query ScenarioChart($scenarioId: ID!, $language: String!) {
  scenario(id: $scenarioId) {
    ...ScenarioData
    values {
      ...ProjectionValueData
    }
  }
  ghgSectors {
    ...GhgSectorData
  }
}
    ${ScenarioDataFragmentDoc}
${ProjectionValueDataFragmentDoc}
${GhgSectorDataFragmentDoc}`;

/**
 * __useScenarioChartQuery__
 *
 * To run a query within a React component, call `useScenarioChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioChartQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useScenarioChartQuery(baseOptions: Apollo.QueryHookOptions<ScenarioChartQuery, ScenarioChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioChartQuery, ScenarioChartQueryVariables>(ScenarioChartDocument, options);
      }
export function useScenarioChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioChartQuery, ScenarioChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioChartQuery, ScenarioChartQueryVariables>(ScenarioChartDocument, options);
        }
export type ScenarioChartQueryHookResult = ReturnType<typeof useScenarioChartQuery>;
export type ScenarioChartLazyQueryHookResult = ReturnType<typeof useScenarioChartLazyQuery>;
export type ScenarioChartQueryResult = Apollo.QueryResult<ScenarioChartQuery, ScenarioChartQueryVariables>;
export const ScenariosDocument = gql`
    query Scenarios($language: String!) {
  scenarios {
    ...ScenarioData
  }
}
    ${ScenarioDataFragmentDoc}`;

/**
 * __useScenariosQuery__
 *
 * To run a query within a React component, call `useScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenariosQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useScenariosQuery(baseOptions: Apollo.QueryHookOptions<ScenariosQuery, ScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenariosQuery, ScenariosQueryVariables>(ScenariosDocument, options);
      }
export function useScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenariosQuery, ScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenariosQuery, ScenariosQueryVariables>(ScenariosDocument, options);
        }
export type ScenariosQueryHookResult = ReturnType<typeof useScenariosQuery>;
export type ScenariosLazyQueryHookResult = ReturnType<typeof useScenariosLazyQuery>;
export type ScenariosQueryResult = Apollo.QueryResult<ScenariosQuery, ScenariosQueryVariables>;
export const SetDataCollectionYearLockDocument = gql`
    mutation SetDataCollectionYearLock($year: Int!, $locked: Boolean!) {
  setDataCollectionYearLock(year: $year, locked: $locked) {
    id
    year
    yearLocked
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type SetDataCollectionYearLockMutationFn = Apollo.MutationFunction<SetDataCollectionYearLockMutation, SetDataCollectionYearLockMutationVariables>;

/**
 * __useSetDataCollectionYearLockMutation__
 *
 * To run a mutation, you first call `useSetDataCollectionYearLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDataCollectionYearLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDataCollectionYearLockMutation, { data, loading, error }] = useSetDataCollectionYearLockMutation({
 *   variables: {
 *      year: // value for 'year'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useSetDataCollectionYearLockMutation(baseOptions?: Apollo.MutationHookOptions<SetDataCollectionYearLockMutation, SetDataCollectionYearLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDataCollectionYearLockMutation, SetDataCollectionYearLockMutationVariables>(SetDataCollectionYearLockDocument, options);
      }
export type SetDataCollectionYearLockMutationHookResult = ReturnType<typeof useSetDataCollectionYearLockMutation>;
export type SetDataCollectionYearLockMutationResult = Apollo.MutationResult<SetDataCollectionYearLockMutation>;
export type SetDataCollectionYearLockMutationOptions = Apollo.BaseMutationOptions<SetDataCollectionYearLockMutation, SetDataCollectionYearLockMutationVariables>;
export const SharedDocumentsDocument = gql`
    query SharedDocuments($scope: SharedDocumentScope!, $year: Int, $language: String!) {
  sharedDocuments(scope: $scope, year: $year) {
    ...SharedDocumentData
  }
}
    ${SharedDocumentDataFragmentDoc}`;

/**
 * __useSharedDocumentsQuery__
 *
 * To run a query within a React component, call `useSharedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedDocumentsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      year: // value for 'year'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSharedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<SharedDocumentsQuery, SharedDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedDocumentsQuery, SharedDocumentsQueryVariables>(SharedDocumentsDocument, options);
      }
export function useSharedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedDocumentsQuery, SharedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedDocumentsQuery, SharedDocumentsQueryVariables>(SharedDocumentsDocument, options);
        }
export type SharedDocumentsQueryHookResult = ReturnType<typeof useSharedDocumentsQuery>;
export type SharedDocumentsLazyQueryHookResult = ReturnType<typeof useSharedDocumentsLazyQuery>;
export type SharedDocumentsQueryResult = Apollo.QueryResult<SharedDocumentsQuery, SharedDocumentsQueryVariables>;
export const SustainableDevelopmentGoalsListDocument = gql`
    query SustainableDevelopmentGoalsList($language: String!) {
  sustainableDevelopmentGoals {
    id
    preferredTranslation(preferredLanguage: $language) {
      ...TranslatedTextData
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
    ${TranslatedTextDataFragmentDoc}`;

/**
 * __useSustainableDevelopmentGoalsListQuery__
 *
 * To run a query within a React component, call `useSustainableDevelopmentGoalsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSustainableDevelopmentGoalsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSustainableDevelopmentGoalsListQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSustainableDevelopmentGoalsListQuery(baseOptions: Apollo.QueryHookOptions<SustainableDevelopmentGoalsListQuery, SustainableDevelopmentGoalsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SustainableDevelopmentGoalsListQuery, SustainableDevelopmentGoalsListQueryVariables>(SustainableDevelopmentGoalsListDocument, options);
      }
export function useSustainableDevelopmentGoalsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SustainableDevelopmentGoalsListQuery, SustainableDevelopmentGoalsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SustainableDevelopmentGoalsListQuery, SustainableDevelopmentGoalsListQueryVariables>(SustainableDevelopmentGoalsListDocument, options);
        }
export type SustainableDevelopmentGoalsListQueryHookResult = ReturnType<typeof useSustainableDevelopmentGoalsListQuery>;
export type SustainableDevelopmentGoalsListLazyQueryHookResult = ReturnType<typeof useSustainableDevelopmentGoalsListLazyQuery>;
export type SustainableDevelopmentGoalsListQueryResult = Apollo.QueryResult<SustainableDevelopmentGoalsListQuery, SustainableDevelopmentGoalsListQueryVariables>;
export const TranslatedTextDocument = gql`
    query TranslatedText($translationKey: TranslationKey!, $language: String!) {
  translation(key: $translationKey) {
    id
    preferredTranslation(preferredLanguage: $language) {
      id
      translation
    }
  }
}
    `;

/**
 * __useTranslatedTextQuery__
 *
 * To run a query within a React component, call `useTranslatedTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslatedTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslatedTextQuery({
 *   variables: {
 *      translationKey: // value for 'translationKey'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTranslatedTextQuery(baseOptions: Apollo.QueryHookOptions<TranslatedTextQuery, TranslatedTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranslatedTextQuery, TranslatedTextQueryVariables>(TranslatedTextDocument, options);
      }
export function useTranslatedTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranslatedTextQuery, TranslatedTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranslatedTextQuery, TranslatedTextQueryVariables>(TranslatedTextDocument, options);
        }
export type TranslatedTextQueryHookResult = ReturnType<typeof useTranslatedTextQuery>;
export type TranslatedTextLazyQueryHookResult = ReturnType<typeof useTranslatedTextLazyQuery>;
export type TranslatedTextQueryResult = Apollo.QueryResult<TranslatedTextQuery, TranslatedTextQueryVariables>;
export const TranslationDocument = gql`
    query Translation($translationKey: TranslationKey!) {
  translation(key: $translationKey) {
    ...TranslationItemData
  }
}
    ${TranslationItemDataFragmentDoc}`;

/**
 * __useTranslationQuery__
 *
 * To run a query within a React component, call `useTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationQuery({
 *   variables: {
 *      translationKey: // value for 'translationKey'
 *   },
 * });
 */
export function useTranslationQuery(baseOptions: Apollo.QueryHookOptions<TranslationQuery, TranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranslationQuery, TranslationQueryVariables>(TranslationDocument, options);
      }
export function useTranslationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranslationQuery, TranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranslationQuery, TranslationQueryVariables>(TranslationDocument, options);
        }
export type TranslationQueryHookResult = ReturnType<typeof useTranslationQuery>;
export type TranslationLazyQueryHookResult = ReturnType<typeof useTranslationLazyQuery>;
export type TranslationQueryResult = Apollo.QueryResult<TranslationQuery, TranslationQueryVariables>;
export const UpdateArticle10NeededDocument = gql`
    mutation UpdateArticle10Needed($dto: UpdateArticle10SupportNeeded!) {
  updateArticle10SupportNeeded(dto: $dto) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    sector
    supportType
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type UpdateArticle10NeededMutationFn = Apollo.MutationFunction<UpdateArticle10NeededMutation, UpdateArticle10NeededMutationVariables>;

/**
 * __useUpdateArticle10NeededMutation__
 *
 * To run a mutation, you first call `useUpdateArticle10NeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle10NeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticle10NeededMutation, { data, loading, error }] = useUpdateArticle10NeededMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateArticle10NeededMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticle10NeededMutation, UpdateArticle10NeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticle10NeededMutation, UpdateArticle10NeededMutationVariables>(UpdateArticle10NeededDocument, options);
      }
export type UpdateArticle10NeededMutationHookResult = ReturnType<typeof useUpdateArticle10NeededMutation>;
export type UpdateArticle10NeededMutationResult = Apollo.MutationResult<UpdateArticle10NeededMutation>;
export type UpdateArticle10NeededMutationOptions = Apollo.BaseMutationOptions<UpdateArticle10NeededMutation, UpdateArticle10NeededMutationVariables>;
export const UpdateArticle10ReceivedDocument = gql`
    mutation UpdateArticle10Received($dto: UpdateArticle10SupportReceived!) {
  updateArticle10SupportReceived(dto: $dto) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    sector
    supportType
    statusOfActivity
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    description
  }
}
    `;
export type UpdateArticle10ReceivedMutationFn = Apollo.MutationFunction<UpdateArticle10ReceivedMutation, UpdateArticle10ReceivedMutationVariables>;

/**
 * __useUpdateArticle10ReceivedMutation__
 *
 * To run a mutation, you first call `useUpdateArticle10ReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle10ReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticle10ReceivedMutation, { data, loading, error }] = useUpdateArticle10ReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateArticle10ReceivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticle10ReceivedMutation, UpdateArticle10ReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticle10ReceivedMutation, UpdateArticle10ReceivedMutationVariables>(UpdateArticle10ReceivedDocument, options);
      }
export type UpdateArticle10ReceivedMutationHookResult = ReturnType<typeof useUpdateArticle10ReceivedMutation>;
export type UpdateArticle10ReceivedMutationResult = Apollo.MutationResult<UpdateArticle10ReceivedMutation>;
export type UpdateArticle10ReceivedMutationOptions = Apollo.BaseMutationOptions<UpdateArticle10ReceivedMutation, UpdateArticle10ReceivedMutationVariables>;
export const UpdateArticle11NeededDocument = gql`
    mutation UpdateArticle11Needed($dto: UpdateArticle11SupportNeeded!) {
  updateArticle11SupportNeeded(dto: $dto) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    supportType
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type UpdateArticle11NeededMutationFn = Apollo.MutationFunction<UpdateArticle11NeededMutation, UpdateArticle11NeededMutationVariables>;

/**
 * __useUpdateArticle11NeededMutation__
 *
 * To run a mutation, you first call `useUpdateArticle11NeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle11NeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticle11NeededMutation, { data, loading, error }] = useUpdateArticle11NeededMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateArticle11NeededMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticle11NeededMutation, UpdateArticle11NeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticle11NeededMutation, UpdateArticle11NeededMutationVariables>(UpdateArticle11NeededDocument, options);
      }
export type UpdateArticle11NeededMutationHookResult = ReturnType<typeof useUpdateArticle11NeededMutation>;
export type UpdateArticle11NeededMutationResult = Apollo.MutationResult<UpdateArticle11NeededMutation>;
export type UpdateArticle11NeededMutationOptions = Apollo.BaseMutationOptions<UpdateArticle11NeededMutation, UpdateArticle11NeededMutationVariables>;
export const UpdateArticle11ReceivedDocument = gql`
    mutation UpdateArticle11Received($dto: UpdateArticle11SupportReceived!) {
  updateArticle11SupportReceived(dto: $dto) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    supportType
    statusOfActivity
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    description
  }
}
    `;
export type UpdateArticle11ReceivedMutationFn = Apollo.MutationFunction<UpdateArticle11ReceivedMutation, UpdateArticle11ReceivedMutationVariables>;

/**
 * __useUpdateArticle11ReceivedMutation__
 *
 * To run a mutation, you first call `useUpdateArticle11ReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle11ReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticle11ReceivedMutation, { data, loading, error }] = useUpdateArticle11ReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateArticle11ReceivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticle11ReceivedMutation, UpdateArticle11ReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticle11ReceivedMutation, UpdateArticle11ReceivedMutationVariables>(UpdateArticle11ReceivedDocument, options);
      }
export type UpdateArticle11ReceivedMutationHookResult = ReturnType<typeof useUpdateArticle11ReceivedMutation>;
export type UpdateArticle11ReceivedMutationResult = Apollo.MutationResult<UpdateArticle11ReceivedMutation>;
export type UpdateArticle11ReceivedMutationOptions = Apollo.BaseMutationOptions<UpdateArticle11ReceivedMutation, UpdateArticle11ReceivedMutationVariables>;
export const UpdateArticle13NeededReceivedDocument = gql`
    mutation UpdateArticle13NeededReceived($dto: UpdateArticle13SupportNeededReceived!) {
  updateArticle13SupportNeededReceived(dto: $dto) {
    id
    project {
      id
      title
      description
    }
    recipientEntity
    channel
    amountRsd
    amountUsd
    timeframeStart
    timeframeEnd
    statusOfActivity
    useImpactAndEstimatedResults
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
  }
}
    `;
export type UpdateArticle13NeededReceivedMutationFn = Apollo.MutationFunction<UpdateArticle13NeededReceivedMutation, UpdateArticle13NeededReceivedMutationVariables>;

/**
 * __useUpdateArticle13NeededReceivedMutation__
 *
 * To run a mutation, you first call `useUpdateArticle13NeededReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle13NeededReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticle13NeededReceivedMutation, { data, loading, error }] = useUpdateArticle13NeededReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateArticle13NeededReceivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticle13NeededReceivedMutation, UpdateArticle13NeededReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticle13NeededReceivedMutation, UpdateArticle13NeededReceivedMutationVariables>(UpdateArticle13NeededReceivedDocument, options);
      }
export type UpdateArticle13NeededReceivedMutationHookResult = ReturnType<typeof useUpdateArticle13NeededReceivedMutation>;
export type UpdateArticle13NeededReceivedMutationResult = Apollo.MutationResult<UpdateArticle13NeededReceivedMutation>;
export type UpdateArticle13NeededReceivedMutationOptions = Apollo.BaseMutationOptions<UpdateArticle13NeededReceivedMutation, UpdateArticle13NeededReceivedMutationVariables>;
export const UpdateArticle9NeededDocument = gql`
    mutation UpdateArticle9Needed($dto: UpdateArticle9SupportNeeded!) {
  updateArticle9SupportNeeded(dto: $dto) {
    id
    project {
      id
      title
      description
    }
    expectedTimeframeStart
    expectedTimeframeEnd
    expectedUseImpactAndEstimatedResults
    supportType
    expectedFinancialInstrument
    estimatedAmountRsd
    estimatedAmountUsd
    sector
    activityContribution
    activityAnchored
    supportReceived {
      id
    }
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type UpdateArticle9NeededMutationFn = Apollo.MutationFunction<UpdateArticle9NeededMutation, UpdateArticle9NeededMutationVariables>;

/**
 * __useUpdateArticle9NeededMutation__
 *
 * To run a mutation, you first call `useUpdateArticle9NeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle9NeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticle9NeededMutation, { data, loading, error }] = useUpdateArticle9NeededMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateArticle9NeededMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticle9NeededMutation, UpdateArticle9NeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticle9NeededMutation, UpdateArticle9NeededMutationVariables>(UpdateArticle9NeededDocument, options);
      }
export type UpdateArticle9NeededMutationHookResult = ReturnType<typeof useUpdateArticle9NeededMutation>;
export type UpdateArticle9NeededMutationResult = Apollo.MutationResult<UpdateArticle9NeededMutation>;
export type UpdateArticle9NeededMutationOptions = Apollo.BaseMutationOptions<UpdateArticle9NeededMutation, UpdateArticle9NeededMutationVariables>;
export const UpdateArticle9ReceivedDocument = gql`
    mutation UpdateArticle9Received($dto: UpdateArticle9SupportReceived!) {
  updateArticle9SupportReceived(dto: $dto) {
    supportNeeded {
      id
      project {
        id
        title
        description
      }
    }
    id
    timeframeStart
    timeframeEnd
    sector
    supportType
    statusOfActivity
    channel
    sector
    amountRsd
    amountUsd
    financialInstrument
    activityContribution
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    description
  }
}
    `;
export type UpdateArticle9ReceivedMutationFn = Apollo.MutationFunction<UpdateArticle9ReceivedMutation, UpdateArticle9ReceivedMutationVariables>;

/**
 * __useUpdateArticle9ReceivedMutation__
 *
 * To run a mutation, you first call `useUpdateArticle9ReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticle9ReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticle9ReceivedMutation, { data, loading, error }] = useUpdateArticle9ReceivedMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateArticle9ReceivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticle9ReceivedMutation, UpdateArticle9ReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticle9ReceivedMutation, UpdateArticle9ReceivedMutationVariables>(UpdateArticle9ReceivedDocument, options);
      }
export type UpdateArticle9ReceivedMutationHookResult = ReturnType<typeof useUpdateArticle9ReceivedMutation>;
export type UpdateArticle9ReceivedMutationResult = Apollo.MutationResult<UpdateArticle9ReceivedMutation>;
export type UpdateArticle9ReceivedMutationOptions = Apollo.BaseMutationOptions<UpdateArticle9ReceivedMutation, UpdateArticle9ReceivedMutationVariables>;
export const UpdateDataCollectionTemplateDocument = gql`
    mutation UpdateDataCollectionTemplate($documentId: ID!, $dto: UpdateDataCollectionTemplate!, $language: String!) {
  updateDataCollectionTemplate(documentId: $documentId, dto: $dto) {
    ...DataCollectionTemplateData
  }
}
    ${DataCollectionTemplateDataFragmentDoc}`;
export type UpdateDataCollectionTemplateMutationFn = Apollo.MutationFunction<UpdateDataCollectionTemplateMutation, UpdateDataCollectionTemplateMutationVariables>;

/**
 * __useUpdateDataCollectionTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateDataCollectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataCollectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataCollectionTemplateMutation, { data, loading, error }] = useUpdateDataCollectionTemplateMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDataCollectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataCollectionTemplateMutation, UpdateDataCollectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataCollectionTemplateMutation, UpdateDataCollectionTemplateMutationVariables>(UpdateDataCollectionTemplateDocument, options);
      }
export type UpdateDataCollectionTemplateMutationHookResult = ReturnType<typeof useUpdateDataCollectionTemplateMutation>;
export type UpdateDataCollectionTemplateMutationResult = Apollo.MutationResult<UpdateDataCollectionTemplateMutation>;
export type UpdateDataCollectionTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateDataCollectionTemplateMutation, UpdateDataCollectionTemplateMutationVariables>;
export const UpdateDataCollectionDocumentAccessDocument = gql`
    mutation UpdateDataCollectionDocumentAccess($id: ID!, $organizations: [ID!]!, $language: String!) {
  updateDataCollectionDocumentAccess(id: $id, organizations: $organizations) {
    ...DataCollectionDocumentData
  }
}
    ${DataCollectionDocumentDataFragmentDoc}`;
export type UpdateDataCollectionDocumentAccessMutationFn = Apollo.MutationFunction<UpdateDataCollectionDocumentAccessMutation, UpdateDataCollectionDocumentAccessMutationVariables>;

/**
 * __useUpdateDataCollectionDocumentAccessMutation__
 *
 * To run a mutation, you first call `useUpdateDataCollectionDocumentAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataCollectionDocumentAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataCollectionDocumentAccessMutation, { data, loading, error }] = useUpdateDataCollectionDocumentAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organizations: // value for 'organizations'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDataCollectionDocumentAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataCollectionDocumentAccessMutation, UpdateDataCollectionDocumentAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataCollectionDocumentAccessMutation, UpdateDataCollectionDocumentAccessMutationVariables>(UpdateDataCollectionDocumentAccessDocument, options);
      }
export type UpdateDataCollectionDocumentAccessMutationHookResult = ReturnType<typeof useUpdateDataCollectionDocumentAccessMutation>;
export type UpdateDataCollectionDocumentAccessMutationResult = Apollo.MutationResult<UpdateDataCollectionDocumentAccessMutation>;
export type UpdateDataCollectionDocumentAccessMutationOptions = Apollo.BaseMutationOptions<UpdateDataCollectionDocumentAccessMutation, UpdateDataCollectionDocumentAccessMutationVariables>;
export const UpdateDataCollectionDocumentContentDocument = gql`
    mutation UpdateDataCollectionDocumentContent($documentId: ID!, $dto: UpdateDataCollectionDocumentContent!, $language: String!) {
  updateDataCollectionDocumentContent(documentId: $documentId, dto: $dto) {
    ...DataCollectionDocumentData
  }
}
    ${DataCollectionDocumentDataFragmentDoc}`;
export type UpdateDataCollectionDocumentContentMutationFn = Apollo.MutationFunction<UpdateDataCollectionDocumentContentMutation, UpdateDataCollectionDocumentContentMutationVariables>;

/**
 * __useUpdateDataCollectionDocumentContentMutation__
 *
 * To run a mutation, you first call `useUpdateDataCollectionDocumentContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataCollectionDocumentContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataCollectionDocumentContentMutation, { data, loading, error }] = useUpdateDataCollectionDocumentContentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDataCollectionDocumentContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataCollectionDocumentContentMutation, UpdateDataCollectionDocumentContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataCollectionDocumentContentMutation, UpdateDataCollectionDocumentContentMutationVariables>(UpdateDataCollectionDocumentContentDocument, options);
      }
export type UpdateDataCollectionDocumentContentMutationHookResult = ReturnType<typeof useUpdateDataCollectionDocumentContentMutation>;
export type UpdateDataCollectionDocumentContentMutationResult = Apollo.MutationResult<UpdateDataCollectionDocumentContentMutation>;
export type UpdateDataCollectionDocumentContentMutationOptions = Apollo.BaseMutationOptions<UpdateDataCollectionDocumentContentMutation, UpdateDataCollectionDocumentContentMutationVariables>;
export const UpdateDataCollectionDocumentDocument = gql`
    mutation UpdateDataCollectionDocument($documentId: ID!, $dto: UpdateDataCollectionDocument!, $language: String!) {
  updateDataCollectionDocument(documentId: $documentId, dto: $dto) {
    ...DataCollectionDocumentData
  }
}
    ${DataCollectionDocumentDataFragmentDoc}`;
export type UpdateDataCollectionDocumentMutationFn = Apollo.MutationFunction<UpdateDataCollectionDocumentMutation, UpdateDataCollectionDocumentMutationVariables>;

/**
 * __useUpdateDataCollectionDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDataCollectionDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataCollectionDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataCollectionDocumentMutation, { data, loading, error }] = useUpdateDataCollectionDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDataCollectionDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataCollectionDocumentMutation, UpdateDataCollectionDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataCollectionDocumentMutation, UpdateDataCollectionDocumentMutationVariables>(UpdateDataCollectionDocumentDocument, options);
      }
export type UpdateDataCollectionDocumentMutationHookResult = ReturnType<typeof useUpdateDataCollectionDocumentMutation>;
export type UpdateDataCollectionDocumentMutationResult = Apollo.MutationResult<UpdateDataCollectionDocumentMutation>;
export type UpdateDataCollectionDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDataCollectionDocumentMutation, UpdateDataCollectionDocumentMutationVariables>;
export const UpdateExternalApplicationDocument = gql`
    mutation UpdateExternalApplication($id: ID!, $dto: UpdateExternalApplication!, $language: String!) {
  updateExternalApplication(id: $id, dto: $dto) {
    ...ExternalApplicationData
  }
}
    ${ExternalApplicationDataFragmentDoc}`;
export type UpdateExternalApplicationMutationFn = Apollo.MutationFunction<UpdateExternalApplicationMutation, UpdateExternalApplicationMutationVariables>;

/**
 * __useUpdateExternalApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateExternalApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalApplicationMutation, { data, loading, error }] = useUpdateExternalApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateExternalApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalApplicationMutation, UpdateExternalApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalApplicationMutation, UpdateExternalApplicationMutationVariables>(UpdateExternalApplicationDocument, options);
      }
export type UpdateExternalApplicationMutationHookResult = ReturnType<typeof useUpdateExternalApplicationMutation>;
export type UpdateExternalApplicationMutationResult = Apollo.MutationResult<UpdateExternalApplicationMutation>;
export type UpdateExternalApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateExternalApplicationMutation, UpdateExternalApplicationMutationVariables>;
export const UpdateExternalSourceDocument = gql`
    mutation UpdateExternalSource($sourceId: ID!, $dto: UpdateExternalSource!, $language: String!) {
  updateExternalSource(sourceId: $sourceId, dto: $dto) {
    ...ExternalSourceData
  }
}
    ${ExternalSourceDataFragmentDoc}`;
export type UpdateExternalSourceMutationFn = Apollo.MutationFunction<UpdateExternalSourceMutation, UpdateExternalSourceMutationVariables>;

/**
 * __useUpdateExternalSourceMutation__
 *
 * To run a mutation, you first call `useUpdateExternalSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalSourceMutation, { data, loading, error }] = useUpdateExternalSourceMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateExternalSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalSourceMutation, UpdateExternalSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalSourceMutation, UpdateExternalSourceMutationVariables>(UpdateExternalSourceDocument, options);
      }
export type UpdateExternalSourceMutationHookResult = ReturnType<typeof useUpdateExternalSourceMutation>;
export type UpdateExternalSourceMutationResult = Apollo.MutationResult<UpdateExternalSourceMutation>;
export type UpdateExternalSourceMutationOptions = Apollo.BaseMutationOptions<UpdateExternalSourceMutation, UpdateExternalSourceMutationVariables>;
export const UpdateIndicatorDocument = gql`
    mutation UpdateIndicator($id: ID!, $dto: UpdateIndicator!) {
  updateIndicator(id: $id, dto: $dto) {
    id
    number
    name
    datasets {
      id
      code
      name
      numeratorDenominator
      guidanceDefinitions
      additionalRemarks
      comments
    }
  }
}
    `;
export type UpdateIndicatorMutationFn = Apollo.MutationFunction<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;

/**
 * __useUpdateIndicatorMutation__
 *
 * To run a mutation, you first call `useUpdateIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicatorMutation, { data, loading, error }] = useUpdateIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>(UpdateIndicatorDocument, options);
      }
export type UpdateIndicatorMutationHookResult = ReturnType<typeof useUpdateIndicatorMutation>;
export type UpdateIndicatorMutationResult = Apollo.MutationResult<UpdateIndicatorMutation>;
export type UpdateIndicatorMutationOptions = Apollo.BaseMutationOptions<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;
export const UpdateIndicatorValueDocument = gql`
    mutation UpdateIndicatorValue($values: [UpdateIndicatorDatasetValue!]!) {
  updateIndicatorValues(values: $values) {
    id
    year
    value
  }
}
    `;
export type UpdateIndicatorValueMutationFn = Apollo.MutationFunction<UpdateIndicatorValueMutation, UpdateIndicatorValueMutationVariables>;

/**
 * __useUpdateIndicatorValueMutation__
 *
 * To run a mutation, you first call `useUpdateIndicatorValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicatorValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicatorValueMutation, { data, loading, error }] = useUpdateIndicatorValueMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateIndicatorValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicatorValueMutation, UpdateIndicatorValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicatorValueMutation, UpdateIndicatorValueMutationVariables>(UpdateIndicatorValueDocument, options);
      }
export type UpdateIndicatorValueMutationHookResult = ReturnType<typeof useUpdateIndicatorValueMutation>;
export type UpdateIndicatorValueMutationResult = Apollo.MutationResult<UpdateIndicatorValueMutation>;
export type UpdateIndicatorValueMutationOptions = Apollo.BaseMutationOptions<UpdateIndicatorValueMutation, UpdateIndicatorValueMutationVariables>;
export const UpdateInfoDocumentDocument = gql`
    mutation UpdateInfoDocument($documentId: ID!, $dto: UpdateInfoDocument!, $language: String!) {
  updateInfoDocument(documentId: $documentId, dto: $dto) {
    ...InfoDocumentData
  }
}
    ${InfoDocumentDataFragmentDoc}`;
export type UpdateInfoDocumentMutationFn = Apollo.MutationFunction<UpdateInfoDocumentMutation, UpdateInfoDocumentMutationVariables>;

/**
 * __useUpdateInfoDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateInfoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInfoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInfoDocumentMutation, { data, loading, error }] = useUpdateInfoDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateInfoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInfoDocumentMutation, UpdateInfoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInfoDocumentMutation, UpdateInfoDocumentMutationVariables>(UpdateInfoDocumentDocument, options);
      }
export type UpdateInfoDocumentMutationHookResult = ReturnType<typeof useUpdateInfoDocumentMutation>;
export type UpdateInfoDocumentMutationResult = Apollo.MutationResult<UpdateInfoDocumentMutation>;
export type UpdateInfoDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateInfoDocumentMutation, UpdateInfoDocumentMutationVariables>;
export const UpdateIntroductionTextDocument = gql`
    mutation UpdateIntroductionText($headerDto: UpdateTranslation!, $textDto: UpdateTranslation!) {
  headerTranslation: updateTranslation(dto: $headerDto) {
    ...TranslationItemData
  }
  textTranslation: updateTranslation(dto: $textDto) {
    ...TranslationItemData
  }
}
    ${TranslationItemDataFragmentDoc}`;
export type UpdateIntroductionTextMutationFn = Apollo.MutationFunction<UpdateIntroductionTextMutation, UpdateIntroductionTextMutationVariables>;

/**
 * __useUpdateIntroductionTextMutation__
 *
 * To run a mutation, you first call `useUpdateIntroductionTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntroductionTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntroductionTextMutation, { data, loading, error }] = useUpdateIntroductionTextMutation({
 *   variables: {
 *      headerDto: // value for 'headerDto'
 *      textDto: // value for 'textDto'
 *   },
 * });
 */
export function useUpdateIntroductionTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntroductionTextMutation, UpdateIntroductionTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntroductionTextMutation, UpdateIntroductionTextMutationVariables>(UpdateIntroductionTextDocument, options);
      }
export type UpdateIntroductionTextMutationHookResult = ReturnType<typeof useUpdateIntroductionTextMutation>;
export type UpdateIntroductionTextMutationResult = Apollo.MutationResult<UpdateIntroductionTextMutation>;
export type UpdateIntroductionTextMutationOptions = Apollo.BaseMutationOptions<UpdateIntroductionTextMutation, UpdateIntroductionTextMutationVariables>;
export const UpdateMeasureDocument = gql`
    mutation UpdateMeasure($dto: UpdateMeasure!) {
  updateMeasure(dto: $dto) {
    id
    reportingInMrv
    name
    objective
    description
    territorialCoverage
    measureType
    lifetimeStart
    lifetimeEnd
    legalAndPolicyBasis
    implementationPhases
    problemsAndBarriers
    expectedImprovements
    achievedResults
    responsibilityFor
    publicConsultationProcess
    totalExpectedInvestmentRsd
    totalExpectedInvestmentUsd
    expectedSourceOfFunding
    linkToOtherMeasures
    indicators
    linkz
    extensionOfMeasure
    otherBenefits
    impactOnGhgEmissions
    lossesAndDamages
    extremeEvents
    climateChangeImpacts
    ndcRelevant
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
    approvedBy
    approvedDate
    reportingPeriods {
      id
      name
      startYear
      endYear
    }
    periodData {
      reportingPeriod {
        id
      }
    }
  }
}
    `;
export type UpdateMeasureMutationFn = Apollo.MutationFunction<UpdateMeasureMutation, UpdateMeasureMutationVariables>;

/**
 * __useUpdateMeasureMutation__
 *
 * To run a mutation, you first call `useUpdateMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeasureMutation, { data, loading, error }] = useUpdateMeasureMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateMeasureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeasureMutation, UpdateMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeasureMutation, UpdateMeasureMutationVariables>(UpdateMeasureDocument, options);
      }
export type UpdateMeasureMutationHookResult = ReturnType<typeof useUpdateMeasureMutation>;
export type UpdateMeasureMutationResult = Apollo.MutationResult<UpdateMeasureMutation>;
export type UpdateMeasureMutationOptions = Apollo.BaseMutationOptions<UpdateMeasureMutation, UpdateMeasureMutationVariables>;
export const UpdateMeasureNcRelevancyDocument = gql`
    mutation UpdateMeasureNcRelevancy($id: ID!, $ncRelevant: Boolean!) {
  updateMeasureNcRelevancy(id: $id, ncRelevant: $ncRelevant) {
    id
    ncRelevant
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type UpdateMeasureNcRelevancyMutationFn = Apollo.MutationFunction<UpdateMeasureNcRelevancyMutation, UpdateMeasureNcRelevancyMutationVariables>;

/**
 * __useUpdateMeasureNcRelevancyMutation__
 *
 * To run a mutation, you first call `useUpdateMeasureNcRelevancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeasureNcRelevancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeasureNcRelevancyMutation, { data, loading, error }] = useUpdateMeasureNcRelevancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ncRelevant: // value for 'ncRelevant'
 *   },
 * });
 */
export function useUpdateMeasureNcRelevancyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeasureNcRelevancyMutation, UpdateMeasureNcRelevancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeasureNcRelevancyMutation, UpdateMeasureNcRelevancyMutationVariables>(UpdateMeasureNcRelevancyDocument, options);
      }
export type UpdateMeasureNcRelevancyMutationHookResult = ReturnType<typeof useUpdateMeasureNcRelevancyMutation>;
export type UpdateMeasureNcRelevancyMutationResult = Apollo.MutationResult<UpdateMeasureNcRelevancyMutation>;
export type UpdateMeasureNcRelevancyMutationOptions = Apollo.BaseMutationOptions<UpdateMeasureNcRelevancyMutation, UpdateMeasureNcRelevancyMutationVariables>;
export const UpdateMeasureNdcRelevancyDocument = gql`
    mutation UpdateMeasureNdcRelevancy($id: ID!, $ndcRelevant: Boolean!) {
  updateMeasureNdcRelevancy(id: $id, ndcRelevant: $ndcRelevant) {
    id
    ndcRelevant
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type UpdateMeasureNdcRelevancyMutationFn = Apollo.MutationFunction<UpdateMeasureNdcRelevancyMutation, UpdateMeasureNdcRelevancyMutationVariables>;

/**
 * __useUpdateMeasureNdcRelevancyMutation__
 *
 * To run a mutation, you first call `useUpdateMeasureNdcRelevancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeasureNdcRelevancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeasureNdcRelevancyMutation, { data, loading, error }] = useUpdateMeasureNdcRelevancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ndcRelevant: // value for 'ndcRelevant'
 *   },
 * });
 */
export function useUpdateMeasureNdcRelevancyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeasureNdcRelevancyMutation, UpdateMeasureNdcRelevancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeasureNdcRelevancyMutation, UpdateMeasureNdcRelevancyMutationVariables>(UpdateMeasureNdcRelevancyDocument, options);
      }
export type UpdateMeasureNdcRelevancyMutationHookResult = ReturnType<typeof useUpdateMeasureNdcRelevancyMutation>;
export type UpdateMeasureNdcRelevancyMutationResult = Apollo.MutationResult<UpdateMeasureNdcRelevancyMutation>;
export type UpdateMeasureNdcRelevancyMutationOptions = Apollo.BaseMutationOptions<UpdateMeasureNdcRelevancyMutation, UpdateMeasureNdcRelevancyMutationVariables>;
export const UpdateMeasurePeriodDataDocument = gql`
    mutation UpdateMeasurePeriodData($dto: UpdateMeasurePeriodData!) {
  updateMeasurePeriodData(dto: $dto) {
    id
    measure {
      id
    }
    reportingPeriod {
      id
      name
    }
    status
    sourceOfFunding
    realized
    investmentRsd
    investmentUsd
  }
}
    `;
export type UpdateMeasurePeriodDataMutationFn = Apollo.MutationFunction<UpdateMeasurePeriodDataMutation, UpdateMeasurePeriodDataMutationVariables>;

/**
 * __useUpdateMeasurePeriodDataMutation__
 *
 * To run a mutation, you first call `useUpdateMeasurePeriodDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeasurePeriodDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeasurePeriodDataMutation, { data, loading, error }] = useUpdateMeasurePeriodDataMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateMeasurePeriodDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeasurePeriodDataMutation, UpdateMeasurePeriodDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeasurePeriodDataMutation, UpdateMeasurePeriodDataMutationVariables>(UpdateMeasurePeriodDataDocument, options);
      }
export type UpdateMeasurePeriodDataMutationHookResult = ReturnType<typeof useUpdateMeasurePeriodDataMutation>;
export type UpdateMeasurePeriodDataMutationResult = Apollo.MutationResult<UpdateMeasurePeriodDataMutation>;
export type UpdateMeasurePeriodDataMutationOptions = Apollo.BaseMutationOptions<UpdateMeasurePeriodDataMutation, UpdateMeasurePeriodDataMutationVariables>;
export const UpdateModuleVisibilityDocument = gql`
    mutation UpdateModuleVisibility($dto: UpdateModuleVisibility!) {
  updateModuleVisibility(dto: $dto) {
    id
    scope
    publiclyVisible
    lastModifiedBy
    lastModifiedDate
  }
}
    `;
export type UpdateModuleVisibilityMutationFn = Apollo.MutationFunction<UpdateModuleVisibilityMutation, UpdateModuleVisibilityMutationVariables>;

/**
 * __useUpdateModuleVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateModuleVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleVisibilityMutation, { data, loading, error }] = useUpdateModuleVisibilityMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateModuleVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModuleVisibilityMutation, UpdateModuleVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModuleVisibilityMutation, UpdateModuleVisibilityMutationVariables>(UpdateModuleVisibilityDocument, options);
      }
export type UpdateModuleVisibilityMutationHookResult = ReturnType<typeof useUpdateModuleVisibilityMutation>;
export type UpdateModuleVisibilityMutationResult = Apollo.MutationResult<UpdateModuleVisibilityMutation>;
export type UpdateModuleVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateModuleVisibilityMutation, UpdateModuleVisibilityMutationVariables>;
export const UpdateNdcTargetsDocument = gql`
    mutation UpdateNdcTargets($dtos: [UpdateNdcTarget!]!, $language: String!) {
  updateNdcTargets(dtos: $dtos) {
    ...NdcTargetData
    targetValues {
      ...NdcTargetValueData
    }
  }
}
    ${NdcTargetDataFragmentDoc}
${NdcTargetValueDataFragmentDoc}`;
export type UpdateNdcTargetsMutationFn = Apollo.MutationFunction<UpdateNdcTargetsMutation, UpdateNdcTargetsMutationVariables>;

/**
 * __useUpdateNdcTargetsMutation__
 *
 * To run a mutation, you first call `useUpdateNdcTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNdcTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNdcTargetsMutation, { data, loading, error }] = useUpdateNdcTargetsMutation({
 *   variables: {
 *      dtos: // value for 'dtos'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateNdcTargetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNdcTargetsMutation, UpdateNdcTargetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNdcTargetsMutation, UpdateNdcTargetsMutationVariables>(UpdateNdcTargetsDocument, options);
      }
export type UpdateNdcTargetsMutationHookResult = ReturnType<typeof useUpdateNdcTargetsMutation>;
export type UpdateNdcTargetsMutationResult = Apollo.MutationResult<UpdateNdcTargetsMutation>;
export type UpdateNdcTargetsMutationOptions = Apollo.BaseMutationOptions<UpdateNdcTargetsMutation, UpdateNdcTargetsMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($id: ID!, $dto: UpdateOrganization!, $language: String!) {
  updateOrganization(id: $id, dto: $dto) {
    ...OrganizationData
  }
}
    ${OrganizationDataFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdatePamDocument = gql`
    mutation UpdatePam($id: ID!, $dto: UpdatePolicyMeasure!) {
  updatePolicyAndMeasure(id: $id, dto: $dto) {
    ...PamData
  }
}
    ${PamDataFragmentDoc}`;
export type UpdatePamMutationFn = Apollo.MutationFunction<UpdatePamMutation, UpdatePamMutationVariables>;

/**
 * __useUpdatePamMutation__
 *
 * To run a mutation, you first call `useUpdatePamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePamMutation, { data, loading, error }] = useUpdatePamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdatePamMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePamMutation, UpdatePamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePamMutation, UpdatePamMutationVariables>(UpdatePamDocument, options);
      }
export type UpdatePamMutationHookResult = ReturnType<typeof useUpdatePamMutation>;
export type UpdatePamMutationResult = Apollo.MutationResult<UpdatePamMutation>;
export type UpdatePamMutationOptions = Apollo.BaseMutationOptions<UpdatePamMutation, UpdatePamMutationVariables>;
export const UpdatePamNcRelevancyDocument = gql`
    mutation UpdatePamNcRelevancy($id: ID!, $ncRelevant: Boolean!) {
  updatePolicyAndMeasureNcRelevancy(id: $id, ncRelevant: $ncRelevant) {
    ...PamData
  }
}
    ${PamDataFragmentDoc}`;
export type UpdatePamNcRelevancyMutationFn = Apollo.MutationFunction<UpdatePamNcRelevancyMutation, UpdatePamNcRelevancyMutationVariables>;

/**
 * __useUpdatePamNcRelevancyMutation__
 *
 * To run a mutation, you first call `useUpdatePamNcRelevancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePamNcRelevancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePamNcRelevancyMutation, { data, loading, error }] = useUpdatePamNcRelevancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ncRelevant: // value for 'ncRelevant'
 *   },
 * });
 */
export function useUpdatePamNcRelevancyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePamNcRelevancyMutation, UpdatePamNcRelevancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePamNcRelevancyMutation, UpdatePamNcRelevancyMutationVariables>(UpdatePamNcRelevancyDocument, options);
      }
export type UpdatePamNcRelevancyMutationHookResult = ReturnType<typeof useUpdatePamNcRelevancyMutation>;
export type UpdatePamNcRelevancyMutationResult = Apollo.MutationResult<UpdatePamNcRelevancyMutation>;
export type UpdatePamNcRelevancyMutationOptions = Apollo.BaseMutationOptions<UpdatePamNcRelevancyMutation, UpdatePamNcRelevancyMutationVariables>;
export const UpdatePamNdcRelevancyDocument = gql`
    mutation UpdatePamNdcRelevancy($id: ID!, $ndcRelevant: Boolean!) {
  updatePolicyAndMeasureNdcRelevancy(id: $id, ndcRelevant: $ndcRelevant) {
    ...PamData
  }
}
    ${PamDataFragmentDoc}`;
export type UpdatePamNdcRelevancyMutationFn = Apollo.MutationFunction<UpdatePamNdcRelevancyMutation, UpdatePamNdcRelevancyMutationVariables>;

/**
 * __useUpdatePamNdcRelevancyMutation__
 *
 * To run a mutation, you first call `useUpdatePamNdcRelevancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePamNdcRelevancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePamNdcRelevancyMutation, { data, loading, error }] = useUpdatePamNdcRelevancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ndcRelevant: // value for 'ndcRelevant'
 *   },
 * });
 */
export function useUpdatePamNdcRelevancyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePamNdcRelevancyMutation, UpdatePamNdcRelevancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePamNdcRelevancyMutation, UpdatePamNdcRelevancyMutationVariables>(UpdatePamNdcRelevancyDocument, options);
      }
export type UpdatePamNdcRelevancyMutationHookResult = ReturnType<typeof useUpdatePamNdcRelevancyMutation>;
export type UpdatePamNdcRelevancyMutationResult = Apollo.MutationResult<UpdatePamNdcRelevancyMutation>;
export type UpdatePamNdcRelevancyMutationOptions = Apollo.BaseMutationOptions<UpdatePamNdcRelevancyMutation, UpdatePamNdcRelevancyMutationVariables>;
export const UpdateSharedDocumentDocument = gql`
    mutation UpdateSharedDocument($documentId: ID!, $dto: UpdateSharedDocument!, $language: String!) {
  updateSharedDocument(documentId: $documentId, dto: $dto) {
    ...SharedDocumentData
  }
}
    ${SharedDocumentDataFragmentDoc}`;
export type UpdateSharedDocumentMutationFn = Apollo.MutationFunction<UpdateSharedDocumentMutation, UpdateSharedDocumentMutationVariables>;

/**
 * __useUpdateSharedDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateSharedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedDocumentMutation, { data, loading, error }] = useUpdateSharedDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateSharedDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSharedDocumentMutation, UpdateSharedDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSharedDocumentMutation, UpdateSharedDocumentMutationVariables>(UpdateSharedDocumentDocument, options);
      }
export type UpdateSharedDocumentMutationHookResult = ReturnType<typeof useUpdateSharedDocumentMutation>;
export type UpdateSharedDocumentMutationResult = Apollo.MutationResult<UpdateSharedDocumentMutation>;
export type UpdateSharedDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateSharedDocumentMutation, UpdateSharedDocumentMutationVariables>;
export const UpdateTranslationDocument = gql`
    mutation UpdateTranslation($dto: UpdateTranslation!) {
  updateTranslation(dto: $dto) {
    ...TranslationItemData
  }
}
    ${TranslationItemDataFragmentDoc}`;
export type UpdateTranslationMutationFn = Apollo.MutationFunction<UpdateTranslationMutation, UpdateTranslationMutationVariables>;

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationMutation, UpdateTranslationMutationVariables>(UpdateTranslationDocument, options);
      }
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = Apollo.MutationResult<UpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = Apollo.BaseMutationOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $dto: UpdateUser!, $language: String!) {
  updateUser(id: $id, dto: $dto) {
    ...UserData
    groupMemberships {
      ...UserGroupData
    }
  }
}
    ${UserDataFragmentDoc}
${UserGroupDataFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserStatusDocument = gql`
    mutation UpdateUserStatus($id: ID!, $enabled: Boolean!, $language: String!) {
  updateUserStatus(id: $id, enabled: $enabled) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type UpdateUserStatusMutationFn = Apollo.MutationFunction<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;

/**
 * __useUpdateUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStatusMutation, { data, loading, error }] = useUpdateUserStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>(UpdateUserStatusDocument, options);
      }
export type UpdateUserStatusMutationHookResult = ReturnType<typeof useUpdateUserStatusMutation>;
export type UpdateUserStatusMutationResult = Apollo.MutationResult<UpdateUserStatusMutation>;
export type UpdateUserStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;
export const UploadCrfDocumentDocument = gql`
    mutation UploadCrfDocument($dto: SimpleFileUpload!) {
  uploadCrfDocument(dto: $dto) {
    ...CrfDocumentData
  }
}
    ${CrfDocumentDataFragmentDoc}`;
export type UploadCrfDocumentMutationFn = Apollo.MutationFunction<UploadCrfDocumentMutation, UploadCrfDocumentMutationVariables>;

/**
 * __useUploadCrfDocumentMutation__
 *
 * To run a mutation, you first call `useUploadCrfDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCrfDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCrfDocumentMutation, { data, loading, error }] = useUploadCrfDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUploadCrfDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadCrfDocumentMutation, UploadCrfDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCrfDocumentMutation, UploadCrfDocumentMutationVariables>(UploadCrfDocumentDocument, options);
      }
export type UploadCrfDocumentMutationHookResult = ReturnType<typeof useUploadCrfDocumentMutation>;
export type UploadCrfDocumentMutationResult = Apollo.MutationResult<UploadCrfDocumentMutation>;
export type UploadCrfDocumentMutationOptions = Apollo.BaseMutationOptions<UploadCrfDocumentMutation, UploadCrfDocumentMutationVariables>;
export const CreateDataCollectionTemplateDocument = gql`
    mutation CreateDataCollectionTemplate($dto: CreateDataCollectionTemplate!) {
  createDataCollectionTemplate(dto: $dto) {
    id
  }
}
    `;
export type CreateDataCollectionTemplateMutationFn = Apollo.MutationFunction<CreateDataCollectionTemplateMutation, CreateDataCollectionTemplateMutationVariables>;

/**
 * __useCreateDataCollectionTemplateMutation__
 *
 * To run a mutation, you first call `useCreateDataCollectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataCollectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataCollectionTemplateMutation, { data, loading, error }] = useCreateDataCollectionTemplateMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateDataCollectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateDataCollectionTemplateMutation, CreateDataCollectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDataCollectionTemplateMutation, CreateDataCollectionTemplateMutationVariables>(CreateDataCollectionTemplateDocument, options);
      }
export type CreateDataCollectionTemplateMutationHookResult = ReturnType<typeof useCreateDataCollectionTemplateMutation>;
export type CreateDataCollectionTemplateMutationResult = Apollo.MutationResult<CreateDataCollectionTemplateMutation>;
export type CreateDataCollectionTemplateMutationOptions = Apollo.BaseMutationOptions<CreateDataCollectionTemplateMutation, CreateDataCollectionTemplateMutationVariables>;
export const CreateDataCollectionDocumentDocument = gql`
    mutation CreateDataCollectionDocument($dto: CreateDataCollectionDocument!) {
  createDataCollectionDocument(dto: $dto) {
    id
  }
}
    `;
export type CreateDataCollectionDocumentMutationFn = Apollo.MutationFunction<CreateDataCollectionDocumentMutation, CreateDataCollectionDocumentMutationVariables>;

/**
 * __useCreateDataCollectionDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDataCollectionDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataCollectionDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataCollectionDocumentMutation, { data, loading, error }] = useCreateDataCollectionDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateDataCollectionDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDataCollectionDocumentMutation, CreateDataCollectionDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDataCollectionDocumentMutation, CreateDataCollectionDocumentMutationVariables>(CreateDataCollectionDocumentDocument, options);
      }
export type CreateDataCollectionDocumentMutationHookResult = ReturnType<typeof useCreateDataCollectionDocumentMutation>;
export type CreateDataCollectionDocumentMutationResult = Apollo.MutationResult<CreateDataCollectionDocumentMutation>;
export type CreateDataCollectionDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDataCollectionDocumentMutation, CreateDataCollectionDocumentMutationVariables>;
export const UploadInfoDocumentDocument = gql`
    mutation UploadInfoDocument($dto: CreateInfoDocument!, $language: String!) {
  uploadInfoDocument(dto: $dto) {
    ...InfoDocumentData
  }
}
    ${InfoDocumentDataFragmentDoc}`;
export type UploadInfoDocumentMutationFn = Apollo.MutationFunction<UploadInfoDocumentMutation, UploadInfoDocumentMutationVariables>;

/**
 * __useUploadInfoDocumentMutation__
 *
 * To run a mutation, you first call `useUploadInfoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInfoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInfoDocumentMutation, { data, loading, error }] = useUploadInfoDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUploadInfoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadInfoDocumentMutation, UploadInfoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadInfoDocumentMutation, UploadInfoDocumentMutationVariables>(UploadInfoDocumentDocument, options);
      }
export type UploadInfoDocumentMutationHookResult = ReturnType<typeof useUploadInfoDocumentMutation>;
export type UploadInfoDocumentMutationResult = Apollo.MutationResult<UploadInfoDocumentMutation>;
export type UploadInfoDocumentMutationOptions = Apollo.BaseMutationOptions<UploadInfoDocumentMutation, UploadInfoDocumentMutationVariables>;
export const UploadProjectionDocumentDocument = gql`
    mutation UploadProjectionDocument($dto: SimpleFileUpload!) {
  uploadProjectionDocument(dto: $dto) {
    ...ProjectionDocumentData
  }
}
    ${ProjectionDocumentDataFragmentDoc}`;
export type UploadProjectionDocumentMutationFn = Apollo.MutationFunction<UploadProjectionDocumentMutation, UploadProjectionDocumentMutationVariables>;

/**
 * __useUploadProjectionDocumentMutation__
 *
 * To run a mutation, you first call `useUploadProjectionDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProjectionDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProjectionDocumentMutation, { data, loading, error }] = useUploadProjectionDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUploadProjectionDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadProjectionDocumentMutation, UploadProjectionDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProjectionDocumentMutation, UploadProjectionDocumentMutationVariables>(UploadProjectionDocumentDocument, options);
      }
export type UploadProjectionDocumentMutationHookResult = ReturnType<typeof useUploadProjectionDocumentMutation>;
export type UploadProjectionDocumentMutationResult = Apollo.MutationResult<UploadProjectionDocumentMutation>;
export type UploadProjectionDocumentMutationOptions = Apollo.BaseMutationOptions<UploadProjectionDocumentMutation, UploadProjectionDocumentMutationVariables>;
export const UploadSharedDocumentDocument = gql`
    mutation UploadSharedDocument($dto: CreateSharedDocument!, $language: String!) {
  uploadSharedDocument(dto: $dto) {
    ...SharedDocumentData
  }
}
    ${SharedDocumentDataFragmentDoc}`;
export type UploadSharedDocumentMutationFn = Apollo.MutationFunction<UploadSharedDocumentMutation, UploadSharedDocumentMutationVariables>;

/**
 * __useUploadSharedDocumentMutation__
 *
 * To run a mutation, you first call `useUploadSharedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSharedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSharedDocumentMutation, { data, loading, error }] = useUploadSharedDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUploadSharedDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadSharedDocumentMutation, UploadSharedDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSharedDocumentMutation, UploadSharedDocumentMutationVariables>(UploadSharedDocumentDocument, options);
      }
export type UploadSharedDocumentMutationHookResult = ReturnType<typeof useUploadSharedDocumentMutation>;
export type UploadSharedDocumentMutationResult = Apollo.MutationResult<UploadSharedDocumentMutation>;
export type UploadSharedDocumentMutationOptions = Apollo.BaseMutationOptions<UploadSharedDocumentMutation, UploadSharedDocumentMutationVariables>;
export const UserGroupsDocument = gql`
    query UserGroups($language: String!) {
  userGroups {
    ...UserGroupData
  }
}
    ${UserGroupDataFragmentDoc}`;

/**
 * __useUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUserGroupsQuery(baseOptions: Apollo.QueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
      }
export function useUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export type UserGroupsQueryHookResult = ReturnType<typeof useUserGroupsQuery>;
export type UserGroupsLazyQueryHookResult = ReturnType<typeof useUserGroupsLazyQuery>;
export type UserGroupsQueryResult = Apollo.QueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export const UserDetailsDocument = gql`
    query UserDetails($username: String!, $language: String!) {
  userByUsername(username: $username) {
    id
    email
    displayName
    organization {
      id
      preferredTranslation(preferredLanguage: $language) {
        ...TranslatedTextData
      }
    }
  }
}
    ${TranslatedTextDataFragmentDoc}`;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsQueryResult = Apollo.QueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export const UsersDocument = gql`
    query Users($language: String!) {
  users {
    ...UserData
    groupMemberships {
      ...UserGroupData
    }
  }
}
    ${UserDataFragmentDoc}
${UserGroupDataFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const VerifyTokenDocument = gql`
    query VerifyToken($token: ID!) {
  verifyToken(token: $token)
}
    `;

/**
 * __useVerifyTokenQuery__
 *
 * To run a query within a React component, call `useVerifyTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyTokenQuery(baseOptions: Apollo.QueryHookOptions<VerifyTokenQuery, VerifyTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyTokenQuery, VerifyTokenQueryVariables>(VerifyTokenDocument, options);
      }
export function useVerifyTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyTokenQuery, VerifyTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyTokenQuery, VerifyTokenQueryVariables>(VerifyTokenDocument, options);
        }
export type VerifyTokenQueryHookResult = ReturnType<typeof useVerifyTokenQuery>;
export type VerifyTokenLazyQueryHookResult = ReturnType<typeof useVerifyTokenLazyQuery>;
export type VerifyTokenQueryResult = Apollo.QueryResult<VerifyTokenQuery, VerifyTokenQueryVariables>;